import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Checkbox,
  CardHeader,
  Chip,
  Tooltip,
  Switch,
  FormControlLabel,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useFormik } from "formik";
import {
  useCreateCustomerMutation,
  useCreateWorkOrderMutation,
  useGetAllSearchCompanyQuery,
  useGetAllWorkOrderHistoryQuery,
  useGetAllAssignDriverHistoryQuery,
  useGetAllInvoiceHistoryQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetLastWorkOrderIdQuery,
  useGetProductQuery,
  useGetTaxQuery,
  useGetWorkOrderQuery,
  useUpdateInvoiceStatusQuery,
  useGetEmailTemplateQuery,
  useGetAllInvoiceQuery,
  useGetDriverQuery,
  useCreateEmailMutation,
  useCreateEmailInvoiceMutation,
  useCreateNoteMutation,
  useGetWorkOrderNotesQuery,
  useGetTripProfitByIdQuery,
  useGetNoteTemplateQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { useNavigate, Link } from "react-router-dom";
import { fmtCustomerName } from '../../../Core/utils/nameUtils';
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import {
  ICompanyDetails,
  ICustomer,
  IProductPopUP,
  ITaxes,
  IEmailTemplate,
  IDriver,
  IAssignDrivers,
  ITripProfitDetail,
  INoteTemplate,
} from "../../../Api/Interface/api.interface";
import {
  validateEmail,
  validatePhoneNumber,
} from "../../../Components/Validation/validationUtils";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toDate } from "date-fns";
import dayjs, { Dayjs } from "dayjs";
import { formatDateTime, toAppTz } from "../../../Core/utils/dateTime";
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import {
  ProductType,
  TransferType,
  WorkOrderStatus,
} from "../../../Core/Enum/enum";
import AddIcon from "@mui/icons-material/Add";
import { FaTrash, FaEdit } from "react-icons/fa";
import { FaUndo } from 'react-icons/fa'	
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import NewCompanyPopUp from "../../CompanyInfo/Components/NewCompanyPopUp";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { uploadImage } from "../../../Components/UploadFile/upload";
import { useParams } from "react-router-dom";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";
import ExpandLessSharpIcon from "@mui/icons-material/ExpandLessSharp";
import placeholderImage from '../../../Images/fav.png';
import ReactQuill from 'react-quill';
import axios from "axios";
import moment from 'moment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import { AssignmentOutlined } from "@mui/icons-material";
import Avatar from "@mui/material/Avatar";
import { alpha } from "@mui/material/styles";
// import ViewWorkOrder from "../Components/ViewWorkOrder";
import ViewWorkOrder, { ViewWorkOrderHandle } from "../../CustomerTransaction/Components/ViewWorkOrder";
import { useConfirm } from "../../../Components/ConfirmDialog";
import DescriptionIcon from '@mui/icons-material/Description';
import ReplayIcon from '@mui/icons-material/Replay';
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ReactToPrint from "react-to-print";
import { AuthContext } from "../../Login/AuthContext";

    dayjs.extend(isSameOrAfter);
    dayjs.extend(isSameOrBefore);

// Derives the display status from the work order + invoice combination.
// Priority: Cancelled > Quote (no invoice yet) > Paid > Pending
const getDerivedStatus = (
  quoteWorkOrderStatus: number | undefined,
  hasInvoice: boolean,
  isPaid: boolean
): { label: string; color: string; bg: string } => {
  if (quoteWorkOrderStatus === WorkOrderStatus.Cancel)
    return { label: "Cancelled", color: "#dc2626", bg: "rgba(239,68,68,0.1)" };
  if (!hasInvoice)
    return { label: "Quote",    color: "#2f3891", bg: "rgba(124,58,237,0.08)" };
  if (isPaid)
    return { label: "Paid",     color: "#16a34a", bg: "rgba(22,163,74,0.1)"  };
  return   { label: "Pending",  color: "#d97706", bg: "rgba(234,179,8,0.1)"  };
};

// Legacy helpers kept for backward-compatibility with any remaining call sites
const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:    return "Paid";
    case WorkOrderStatus.Cancel:  return "Cancelled";
    case WorkOrderStatus.Pending: return "Pending";
    default:                      return "Pending";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:    return "#16a34a";
    case WorkOrderStatus.Cancel:  return "#dc2626";
    case WorkOrderStatus.Pending: return "#d97706";
    default:                      return "#d97706";
  }
};

const getTransferType = (statusCode: string): string => {
  switch (statusCode) {
    case TransferType.OneWayTransfer:
      return "One Way Transfer";
    case TransferType.RoundTrip:
      return "Round Trip";
    // case TransferType.MultiDestination:
    //   return "Multi Destination";
    default:
      return "Unknown Status";
  }
};

const steps = ["Quote", "Invoice", "Payment"];

const stepDetails = [
  { title: "Quote", createdBy: "John Doe", createdAt: "2024-01-30 10:00 AM" },
  { title: "Invoice", convertedBy: "Jane Smith", convertedAt: "2024-01-30 11:30 AM" },
  { title: "Payment", processedBy: "Alice Johnson", processedAt: "2024-01-30 01:00 PM" },
];


const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      // backgroundColor: theme.palette.success.main,
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 7,
    border: 0,
    backgroundColor: theme.palette.grey[300],
    borderRadius: 1,
  },
}));

const CustomStepLabel = styled(StepLabel)(() => ({
  "& .MuiStepLabel-iconContainer": {
    borderRadius: "50%",
    border: "2px solid",
    width: 40,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
    fontWeight: "bold",
  },
}));




interface IProduct {
  productName: string;
  productDescription: string;
  productImg: String | null;
  numberOfPassengers: number | null;
  busCount: number | null;
  transferType: string;
  transferTypeFrom: string;
  transferTypeTo: string;
  transferTypeDescription: string;
  departureDateTime: Dayjs | null;
  returnDateTime: Dayjs | null;
  departureAddress: string;
  destinationAddress: string;
  multiDestination: string;
  quantity: number | null;
  price: number | null;
  tax: number | null;
  taxAmount: number | null;
  total: number;
  taxId: number | null;
  unitPriceWithDiscount: number | null;
  unitTotalWithDiscount: number;
  productType: string;
  productLongDescription: string;
  productShortDescription: string;
}

interface IDiscount {
  value: number | null;
  description: string;
}

interface IQuoteWorkOrder {
  id: number;
  quoteWorkOrderCompanyId: number;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderNo: string;
  quoteWorkOrderIssueDate: Dayjs;
  quoteWorkOrderDueDate: Dayjs;
  quoteWorkOrderAmount: number | null;
  quoteWorkOrderStatus: number;
  quoteWorkOrderSale: IProduct[];
  quoteWorkOrderDiscount: string;
  quoteWorkOrderSubTotal: string;
  quoteWorkOrderSaleGrandTotal: string;
  quoteWorkOrderSaleDiscountDescription: IDiscount[];
  customer: ICustomer;
  company: ICompanyDetails;
  assign_driver: IAssignDrivers;
  quoteWorkOrderCustomerRemark: string;
  quoteWorkOrderCustomerMemo: string;
  quoteWorkOrderSaleDiscount: string;
  quoteWorkOrderSaleSubTotal: string;
  quoteWorkOrderCustomerProjectId: string;
  created_by: number;
  created_at: string;
  mainStatus: number;
  invoiceId: number;
  isInvoice: boolean;
  InvoiceNo: number;
  payment_id: string;
  updated_by: string;
  amount_paid: number;
  due_amount: number;
  po_number: string;
  po_document: string | null;
}
interface IInvoice {
  id: number;
  work_order_id: string;
  quoteWorkOrderCompanyId: number;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderNo: string;
  quoteWorkOrderIssueDate: Dayjs;
  quoteWorkOrderDueDate: Dayjs;
  quoteWorkOrderAmount: number | null;
  quoteWorkOrderStatus: number;
  quoteWorkOrderSale: IProduct[];
  quoteWorkOrderDiscount: string;
  quoteWorkOrderSubTotal: string;
  quoteWorkOrderSaleGrandTotal: string;
  quoteWorkOrderSaleDiscountDescription: IDiscount[];
  customer: ICustomer;
  company: ICompanyDetails;
  quoteWorkOrderCustomerRemark: string;
  quoteWorkOrderCustomerMemo: string;
  quoteWorkOrderSaleDiscount: string;
  quoteWorkOrderSaleSubTotal: string;
  created_by: number;
  created_at: string;
  mainStatus: number;
  invoiceId: number;
  InvoiceNo: number;
  payment_id: string;
  amount_paid: number;
  due_amount: number;
  po_number: string;
  po_document: string | null;
}

interface EmailLogs {
  id: number;
  to: string;
  workOrderNo: string;
  created_at: string;
  subject: string;
  message: string;
  amount: number;
}

interface BamboraTransaction {
  label: string;
  trnId: string;
  trnAmount: number;
  created_at: string;
  trnDate: string;
  trnTime: string;
  messageText: string;
  trnCardType: String;
  trnApproved: String;
}

interface DeclinedTransaction {
  label: string;
  trnId: string;
  trnAmount: number;
  created_at: string;
  trnDate: string;
  trnTime: string;
}

interface  Payment {
  id: number;
  transaction_id: string;
  amount: number;
  payment_date: string;
  payment_method: string;
  payment_mode: string;
  description: string;
  file_path?: string;
  created_at: string;
  updated_at: string;
  date: string;
  is_return: number;
  is_deleted: number;
}

  interface UserInfo {
    id: number;
    username: string;
    token: string;
    user_id: number;
  }


const Index = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { id: QuoteId } = useParams<{ id: string }>();
  useEffect(() => {}, [QuoteId]);


  const [open, setOpen] = useState(false);
  // Toggle for the linked-expense breakdown under the trip profit card.
  const [expensesOpen, setExpensesOpen] = useState(false);
  // Inline-edit state for the driver-cost override on the Trip Profit card.
  const [editingDriverCost, setEditingDriverCost] = useState(false);
  const [driverCostInput,   setDriverCostInput]   = useState<string>("");
  const [savingDriverCost,  setSavingDriverCost]  = useState(false);
  const justConvertedRef = useRef(false);
  const [openTerminateDialog, setOpenTerminateDialog] = useState(false);
  const [terminateLoading, setTerminateLoading] = useState(false);
  const [terminateReason, setTerminateReason] = useState("");
  const [terminateReasonError, setTerminateReasonError] = useState(false);
  const [terminateStep, setTerminateStep] = useState<"ask" | "refund" | "terminate">("ask");
  const [refundData, setRefundData] = useState({ amount: "", method: "", reason: "" });
  const [refundProof, setRefundProof] = useState<File | null>(null);
  const [refundErrors, setRefundErrors] = useState({ amount: false, method: false, reason: false, proof: false });
  const [refundSubmitLoading, setRefundSubmitLoading] = useState(false);
  const [openRefundDialog, setOpenRefundDialog] = useState(false);
  const [refundConfirmId, setRefundConfirmId] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [activeStep, setActiveStep] = useState(0);
  const [mainStatus, setMainStatus] = useState("");
  const [id, setId] = useState("");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [invoiceTotalPrice, setInvoiceTotalPrice] = useState(0);
  const [invoiceTotalTax, setInvoiceTotalTax] = useState(0);
  const [invoiceEmailData, setInvoiceEmailData] = useState({ to: "", template:"", subject: "", message: ""  });
  const [driverEmailData, setDriverEmailData] = useState({ to: "", template:"", subject: "", message: ""  });
  

  const [expandedSteps, setExpandedSteps] = useState<number[]>([]);
  const [expandedStep, setExpandedStep] = useState<number[]>([]);
  const [expandedStepsInvoice, setExpandedStepsInvoice] = useState<number[]>([]);
  const [showAllDrivers, setShowAllDrivers] = useState(false);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [showEmailLog, setShowEmailLog] = useState(false);
  const [amount, setAmount] = useState(0.00);
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [showDriverDialog, setShowDriverDialog] = useState(false);
  const [showDriverEmailDialog, setShowDriverEmailDialog] = useState(false);
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [currentSearchQueryEmailTemplate, setCurrentSearchQueryEmailTemplate] =
  useState("");
  const [loading, setLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState<{ [key: string]: boolean }>({});
  const { showErrorMessage, showMessage } = useNotifier();
  const confirm = useConfirm();
  const API_URL = process.env.REACT_APP_API_URL;
  // const PAYMENT_URL = process.env.REACT_APP_PAYMENT_URL;
  
  const [emailLog, setEmailLog] = useState<EmailLogs[]>([]); 
  const [bamboraTransactionData, setBamboraTransactionData] = useState<BamboraTransaction[]>([]); 
  const [declinedTransaData, setDeclinedTransaData] = useState<DeclinedTransaction[]>([]); 
  const [currentSearchQueryInvoice, setCurrentSearchQueryInvoice] =
  useState("");
  const [currentSearchQueryDriver, setCurrentSearchQueryDriver] =
  useState("");
  const [amountPaid, setAmountPaid] = useState(0.00);
  const [dueAmount, setDueAmount] = useState(0.00);
  const [totalRefunded, setTotalRefunded] = useState(0.00);
  const [grossAmountPaid, setGrossAmountPaid] = useState(0.00);
//  const [selectedDrivers, setSelectedDrivers] = useState<number[]>([]);
  const [selectedDrivers, setSelectedDrivers] = useState<{ 
    id: number; 
    price: number; 
    hourPrice: number 
  }[]>([]);
  
  const [sidebarDriverId, setSidebarDriverId] = useState<number | "">("");
  const [sidebarAssigning, setSidebarAssigning] = useState(false);
  const [sidebarSmsEnabled, setSidebarSmsEnabled] = useState(true);
  const [sidebarSmsText, setSidebarSmsText]     = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const isPdf = fileUrl?.endsWith('.pdf');
  const [shouldIncrementStep, setShouldIncrementStep] = useState(true);
  const [tripPrice, setTripPrice] = useState('');
  const [hourPrice, setHourPrice] = useState('');
  const [isPriceDialogOpen, setIsPriceDialogOpen] = useState(false);
  const [isPoNumberDialogOpen, setIsPoNumberDialogOpen] = useState(false);
  const [selectedDriverId, setSelectedDriverId] = useState<number | null>(null);
  const [selectedDriverName, setSelectedDriverName] = useState<string | null>(null);
  const [poNumber, setPoNumber] = useState("");
  const [poDocumentFile, setPoDocumentFile] = useState<File | null>(null);
  const [hasPo, setHasPo] = useState<boolean | null>(null);
  const [pendingPoPayment, setPendingPoPayment] = useState(false);
  const [openViewQuote, setOpenViewQuote] = useState(false);
  const [openViewInvoice, setOpenViewInvoice] = useState(false);
  const [openEmailClientDialog, setOpenEmailClientDialog] = useState(false);
  const [emailClientTo, setEmailClientTo] = useState("");
  const [emailClientSubject, setEmailClientSubject] = useState("");
  const [emailClientMessage, setEmailClientMessage] = useState("");
  const [emailClientSending, setEmailClientSending] = useState(false);
  const [workOrderId, setWorkOrderId] = useState("");
  const [editableAmount, setEditableAmount] = useState("");
  const [paymentUrl, setPaymentUrl] = useState("");
  const [isRefundLoading, setIsRefundLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [noteText, setNoteText] = useState("");
  const [noteSaving, setNoteSaving] = useState(false);



  const getCurrentDateCanada = () => {
 return new Date().toLocaleDateString("en-CA", {timeZone: 'America/Toronto'})
};

const [paymentData, setPaymentData] = useState({ paymentDate:getCurrentDateCanada(), amount: "", paymentMethod:"", file: null as File | null, description: ""  });
const [showPaymentMethodError, setShowPaymentMethodError] = useState(false);
const [proofUploading, setProofUploading] = useState<Set<number>>(new Set());

  const {
    data: workOrderData,
    isLoading: workIsLoading,
    isError: workOrderError,
    refetch: workOrderRefetch,
  } = useGetWorkOrderQuery({
    searchText: "",
    id: String(QuoteId),
  });

  // const {
  //   data: updateData,
  //   isLoading: updateIsLoading,
  //   isError: updateError,
  // } = useUpdateInvoiceStatusQuery({
  //   mainStatus: mainStatus,
  //   id: id,
  //   po_number: poNumber || "",
  // });

  const [sendClientEmail] = useCreateEmailMutation();
  const [sendEmailWithPdf] = useCreateEmailInvoiceMutation();
  const viewWorkOrderRef = useRef<ViewWorkOrderHandle>(null);

  const handleOpenEmailClient = () => {
    const customer = WorkOrderDataList?.customer;
    const to = customer?.customerEmail || customer?.customerCompanyEmail || "";
    const quoteNo = WorkOrderDataList?.quoteWorkOrderNo || "";
    const firstName = customer?.customerFirstName || "Customer";
    setEmailClientTo(to);

    // Pick "Invoice" template when converted, "Work Order" template for quotes
    const isInvoice = !!WorkOrderDataList?.invoiceId;
    const templateName = isInvoice ? "Invoice" : "Work Order";
    const chosenTemplate =
      emailTemplateList.find((t) => t.template_name === templateName) ||
      emailTemplateList.find((t) => t.template_name === "Work Order");

    if (chosenTemplate) {
      setEmailClientSubject(
        chosenTemplate.subject
          .replace(/\[quote_no\]/g, quoteNo)
          .replace(/\[invoice_no\]/g, derivedInvoiceNo || quoteNo)
          .replace(/\[customer_name\]/g, firstName)
      );
      setEmailClientMessage(
        chosenTemplate.message
          .replace(/\[quote_no\]/g, quoteNo)
          .replace(/\[invoice_no\]/g, derivedInvoiceNo || quoteNo)
          .replace(/\[customer_name\]/g, firstName)
      );
    } else {
      setEmailClientSubject(isInvoice ? `Your Invoice – ${derivedInvoiceNo || quoteNo}` : `Your Quote – ${quoteNo}`);
      setEmailClientMessage(
        `Dear ${firstName},\n\nPlease find attached ${isInvoice ? "invoice" : "quote"} details.\n\nBest regards`
      );
    }
    setOpenEmailClientDialog(true);
  };

  const handleSendClientEmail = async () => {
    try {
      setEmailClientSending(true);
      const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };
      const quoteNo = WorkOrderDataList?.quoteWorkOrderNo || "quote";
      const isInvoice = !!WorkOrderDataList?.invoiceId;
      // When an invoice exists, NEVER fall back to the work-order number — always use TJT*
      const invoiceFileNo =
        derivedInvoiceNo ||
        (invoiceList as any)?.InvoiceNo ||
        (WorkOrderDataList as any)?.InvoiceNo;
      const pdfFileName = isInvoice
        ? `${invoiceFileNo || quoteNo}.pdf`
        : `${quoteNo}.pdf`;
      const formData = new FormData();
      formData.append("to", emailClientTo);
      formData.append("subject", emailClientSubject);
      formData.append("message", emailClientMessage);
      if (WorkOrderDataList?.quoteWorkOrderCustomerId) {
        formData.append("customer_id", WorkOrderDataList.quoteWorkOrderCustomerId);
      }
      formData.append("workOrderNo", quoteNo);

      let pdfBlob: Blob | null = null;
      if (!isInvoice && WorkOrderDataList?.id) {
        // For quotes: fetch the DomPDF-generated PDF from the backend so the
        // attachment matches the print version (html2canvas cuts off the right side)
        try {
          const pdfResp = await axios.post(
            `${API_URL}/generate-quote-pdf`,
            { work_order_id: WorkOrderDataList.id },
            { headers, responseType: "blob" }
          );
          pdfBlob = pdfResp.data as Blob;
        } catch {
          pdfBlob = (await viewWorkOrderRef.current?.generatePdfBlob()) ?? null;
        }
      } else {
        pdfBlob = (await viewWorkOrderRef.current?.generatePdfBlob()) ?? null;
      }
      if (pdfBlob) {
        formData.append("attachments[]", new File([pdfBlob], pdfFileName, { type: "application/pdf" }));
      }

      await axios.post(`${API_URL}/send-email`, formData, { headers });
      showMessage("Email sent to client successfully");
      setOpenEmailClientDialog(false);
      fetchEmailLogs();
    } catch {
      showErrorMessage("Failed to send email");
    } finally {
      setEmailClientSending(false);
    }
  };

  const {
    data: updateData,
    isLoading: updateIsLoading,
    isError: updateError,
} = useUpdateInvoiceStatusQuery({
    mainStatus: "2",
    id: id,
    po_number: poNumber || "", //  Ensure po_number is always provided
}, { skip: !id });

  // Reload the page once the invoice conversion API call succeeds
  useEffect(() => {
    if (updateData && id && justConvertedRef.current) {
      justConvertedRef.current = false;
      const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };

      const doReload = () => window.location.reload();

      const uploadPdfThenReload = async () => {
        // Upload the React-rendered PDF blob so the stored invoice PDF
        // matches the print/view format instead of the blade-generated one
        const invoiceNoFromData = (updateData as any)?.workOrder?.InvoiceNo
          || (updateData as any)?.InvoiceNo
          || derivedInvoiceNo;
        try {
          const blob = await viewWorkOrderRef.current?.generatePdfBlob();
          if (blob && invoiceNoFromData) {
            const pdfForm = new FormData();
            pdfForm.append("invoice_no", String(invoiceNoFromData));
            // Filename = invoice number only (e.g. "TJT260429-01.pdf"). No "Invoice_" / "WO" prefix.
            pdfForm.append("pdf", new File([blob], `${invoiceNoFromData}.pdf`, { type: "application/pdf" }));
            await axios.post(`${API_URL}/store-invoice-pdf`, pdfForm, { headers });
          }
        } catch { /* non-critical — PDF upload failure should not block reload */ }
      };

      // Always call /update-po-number when a PO is present so the PO payment
      // is created and amount_paid / due_amount / status are persisted. The
      // /work-order/update-invoice endpoint only converts the quote — it does
      // not handle PO payment logic.
      if (poNumber) {
        const poForm = new FormData();
        poForm.append("workOrderNo", WorkOrderDataList?.quoteWorkOrderNo || "");
        poForm.append("po_number", poNumber);
        if (poDocumentFile) {
          poForm.append("po_document", poDocumentFile);
        }
        axios.post(`${API_URL}/update-po-number`, poForm, { headers })
          .finally(() => uploadPdfThenReload().finally(doReload));
      } else {
        uploadPdfThenReload().finally(doReload);
      }
    }
  }, [updateData, id]);


  const {
    data: workOrderHistoryData,
    isLoading: workOrderHistoryIsLoading,
    isError: workOrderHistoryError,
    refetch: workOrderHistoryRefetch,
  } = useGetAllWorkOrderHistoryQuery({
    id: String(QuoteId),
  });

  const {
    data: workOrderNotesData,
    refetch: refetchWorkOrderNotes,
  } = useGetWorkOrderNotesQuery(String(QuoteId), { skip: !QuoteId });

  const { data: tripProfitData, refetch: refetchTripProfit } = useGetTripProfitByIdQuery(
    Number(QuoteId), { skip: !QuoteId }
  );
  const tripProfit: ITripProfitDetail | null = useMemo(
    () => (tripProfitData as any)?.data ?? null,
    [tripProfitData]
  );

  const [createNote] = useCreateNoteMutation();
  const { data: noteTemplateData } = useGetNoteTemplateQuery({ searchText: "" });
  const noteTemplates: INoteTemplate[] = Array.isArray(noteTemplateData?.data) ? (noteTemplateData!.data as INoteTemplate[]) : [];

  const workOrderNotes: Array<{ id: number; subject: string; message: string; created_by: string; created_at: string }> =
    useMemo(() => (Array.isArray(workOrderNotesData?.data) ? workOrderNotesData!.data : []), [workOrderNotesData]);

  const handleSaveNote = async () => {
    if (!noteText.trim()) return;
    setNoteSaving(true);
    await createNote({
      note_subject: "Work Order Note",
      note_message: noteText.trim(),
      work_order_id: QuoteId,
    });
    setNoteText("");
    refetchWorkOrderNotes();
    showMessage("Your note is saved successfully");
    setNoteSaving(false);
  };

  const {
    data: assignDriverHistoryData,
    isLoading: assignDriverHistoryIsLoading,
    isError: assignDriverHistoryError,
    refetch: assignDriverHistoryRefetch,
  } = useGetAllAssignDriverHistoryQuery({
    id: String(QuoteId),
  });
  


  const {
    data: invoiceHistoryData,
    isLoading: invoiceHistoryIsLoading,
    isError: invoiceHistoryError,
    refetch: invoiceHistoryRefetch,
  } = useGetAllInvoiceHistoryQuery({
    id: String(QuoteId),
  });

  const {
      data: invoiceData,
      isLoading: invoiceIsLoading,
      isError: invoiceError,
      refetch: invoiceRefetch,
    } = useGetAllInvoiceQuery({
      searchText: currentSearchQueryInvoice,
      id: "",
      quoteWorkOrderCustomerId: "",
      quoteWorkOrderCustomerProjectId: "",
    });

    const {
      data: driverData,
      isLoading: driverIsLoading,
      isError: driverError,
      refetch: driverRefetch,
    } = useGetDriverQuery({
      searchText: currentSearchQueryDriver,
      id: "",
    });

  const WorkOrderDataList = useMemo(() => {
    if (
      workOrderData &&
      Array.isArray(workOrderData.data) &&
      workOrderData.data.length > 0
    ) {
      return workOrderData.data[0] as IQuoteWorkOrder;
    }
    return null;
  }, [workOrderData]);

  // Push dynamic top-bar title whenever the invoice status of this work order is known
  useEffect(() => {
    if (!WorkOrderDataList) return;
    const isInvoice = !!WorkOrderDataList.invoiceId;
    window.dispatchEvent(
      new CustomEvent("topBarTitleChange", { detail: isInvoice ? "Invoice Details" : "Quote Details" })
    );
  }, [WorkOrderDataList?.invoiceId]);

  const [payments, setPayments] = useState<Payment[]>([]);
  const [refunds, setRefunds] = useState<Payment[]>([]);

  const invoiceList = useMemo(() => {
    if (
      invoiceData &&
      Array.isArray(invoiceData.data) &&
      invoiceData.data.length > 0
    ) {
      const matchingInvoice = invoiceData.data.find(
        (invoice: IInvoice) => String(invoice.work_order_id) === String(QuoteId)
      );
      return matchingInvoice || null;
    }
    return null;
  }, [invoiceData, QuoteId]);

  // Derive invoice number from history data (most reliable source) with fallbacks
  const derivedInvoiceNo = useMemo(() => {
    const historyEntry = Array.isArray(workOrderHistoryData?.data)
      ? workOrderHistoryData!.data.find((o: any) => o.isInvoice === true)
      : null;
    return historyEntry?.InvoiceNo || invoiceList?.InvoiceNo || WorkOrderDataList?.InvoiceNo || null;
  }, [workOrderHistoryData, invoiceList, WorkOrderDataList]);


 

  // const invoiceList: IInvoice[] = useMemo(() => {
  //     if (invoiceData && Array.isArray(invoiceData.data)) {
  //       return invoiceData.data as IInvoice[];
  //     }
  //     return [];
  //   }, [invoiceData]);

    const driverList: IDriver[] = useMemo(() => {
      if (driverData && Array.isArray(driverData.data)) {
        return driverData.data as IDriver[];
      }
      return [];
    }, [driverData]);

    const isDriverAvailable = (driverAvailability: any, departureDateTime: any) => {
      const driverStartTime = moment(driverAvailability.startTime, 'HH:mm'); // Driver's start time
      const driverEndTime = moment(driverAvailability.endTime, 'HH:mm'); // Driver's end time
    
      const departureTime = moment(departureDateTime, 'DD-MMM-YY hh:mm A'); // Departure time


      // Check if the departure time is within the driver's availability window
      return departureTime.isBetween(driverStartTime, driverEndTime, null, '[]'); // '[]' includes the boundary times
    };
    

React.useEffect(() => {
    const fetchUserInfo = async () => {
      try {
          const response = await axios.post(
              `${API_URL}/user/userInfo`,
              {}, // No body required
              {
                  headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${localStorage.getItem('token') || ''}`, // Include token from localStorage
                  },
              }
          );
          setUserInfo(response.data.data); // Update your state with the response
    
      } catch (error) {
          console.error('Error fetching user info', error);
      }
  };
    
    fetchUserInfo();
  }, []);

    const checkDriverAvailability = (
      driverAvailability: any,
      departureDateTime: string,
      returnDateTime: string
    ) => {
      const departureTime = dayjs(departureDateTime); // Product's departure time
      const returnTime = dayjs(returnDateTime); // Product's return time
    
      const transferDay = departureTime.format('dddd'); // Day of the transfer (e.g., 'Thursday')
    
      // Find availability for the day
      const dayAvailability = driverAvailability.find((day: any) => day.day === transferDay);
    
      if (!dayAvailability || dayAvailability.timeSlots.length === 0) {
        console.log(`Driver not available on ${transferDay}`);
        return false;
      }
    
      // Ensure times are compared only as "HH:mm"
      const departureTimeOnly = departureTime.format('HH:mm');
      const returnTimeOnly = returnTime.format('HH:mm');
    
      // Check if the transfer time fits within any available time slot
      const isAvailable = dayAvailability.timeSlots.some((slot: any) => {
        if (slot.startTime && slot.endTime) {
          // console.log('Checking slot:', slot); 
          const slotStart = dayjs(`1970-01-01T${slot.startTime}:00`);
          const slotEnd = dayjs(`1970-01-01T${slot.endTime}:00`);
          const departure = dayjs(`1970-01-01T${departureTimeOnly}:00`);
          const returnT = dayjs(`1970-01-01T${returnTimeOnly}:00`);
    
          // Validate if times are valid
          if (!slotStart.isValid() || !slotEnd.isValid() || !departure.isValid() || !returnT.isValid()) {
            console.error('Invalid time detected:', {
              slotStart: slot.startTime,
              slotEnd: slot.endTime,
              departure: departureTimeOnly,
              returnT: returnTimeOnly,
            });
            return false;
          }
    
        
          // Check if both departure and return fit within the time slot
          // const fitsWithinSlot =
          //   departure.isSameOrAfter(slotStart) && returnT.isSameOrBefore(slotEnd);
            const fitsWithinSlot = departure.isSameOrAfter(slotStart) && departure.isBefore(slotEnd);

          // console.log(
          //   `Checking slot: ${slot.startTime} - ${slot.endTime} | Departure: ${departure.format(
          //     'HH:mm'
          //   )} | Return: ${returnT.format('HH:mm')} | Fits: ${fitsWithinSlot}`
          // );
    
          return fitsWithinSlot;
        }
        return false;
      });
    
      return isAvailable;
    };
    
    
    const availableDrivers = driverList.filter((driver) =>
      driver.driverUserRole === 'driver' &&  // Only filter drivers with 'DRIVER' role
      invoiceList?.quoteWorkOrderSale.some((product: any) => {
        //  console.log('Driver:', driver);
        //  console.log('Product:', product);
    
        const isAvailable = checkDriverAvailability(
          driver.availability,
          product.departureDateTime,
          product.returnDateTime
        );
    
        // console.log(
        //   `Driver ${driver.driverFirstName} ${driver.driverLastName} available: ${isAvailable}`
        // );
        return isAvailable;
      })
    );

    const nonAvailableDrivers = driverList.filter((driver) =>
      driver.driverUserRole === 'driver' && // Only filter drivers with 'DRIVER' role
      invoiceList?.quoteWorkOrderSale.every((product: any) => {
        const isAvailable = checkDriverAvailability(
          driver.availability,
          product.departureDateTime,
          product.returnDateTime
        );
        return !isAvailable; // Non-available drivers will have no matching availability
      })
    );
    
   // console.log('Available Drivers:', availableDrivers);
    
    


    const invoiceHistories = useMemo(() => {
      if (
        invoiceHistoryData &&
        Array.isArray(invoiceHistoryData.data) &&
        invoiceHistoryData.data.length > 0
      ) {
        return invoiceHistoryData.data; // Return the full array
      }
      return [];
    }, [invoiceHistoryData]);
    

   const {
      data: emailTemplateData,
      isLoading: emailTemplateIsLoading,
      isError: emailTemplateError,
      refetch: emailTemplateRefetch,
    } = useGetEmailTemplateQuery({
      searchText: currentSearchQueryEmailTemplate,
      // id: "",
    });

  const emailTemplateList: IEmailTemplate[] = useMemo(() => {
      if (emailTemplateData && Array.isArray(emailTemplateData.data)) {
        return emailTemplateData.data as IEmailTemplate[];
      }
      return [];
    }, [emailTemplateData]);


    useEffect(() => {
      fetchPayments();
    }, [QuoteId]); // Runs when QuoteId changes
    


    const fetchPayments = () => {
      if (!QuoteId) return;
    
      axios.get(`${API_URL}/payments-by-workorder?work_order_id=${QuoteId}`)
        .then(response => {
          const rawData: Payment[] = Array.isArray(response.data) ? response.data : [];

          // Deduplicate by id AND by logical signature. Catches:
          //  - online payments duplicated under the same transaction_id
          //  - PO payments (no transaction_id) duplicated with the same
          //    method/amount/date/description — typically a PO entered twice
          //    or auto-created on top of an existing PO row.
          const seenIds = new Set<number>();
          const seenSig = new Set<string>();
          const unique = rawData.filter((p) => {
            if (seenIds.has(p.id)) return false;
            const txnSig = [
              String(p.transaction_id || "").trim().toLowerCase(),
              String(p.payment_mode || "").trim().toLowerCase(),
              Number(p.amount || 0).toFixed(2),
              String(p.payment_date || p.created_at || "").slice(0, 10),
              Number(p.is_return || 0),
            ].join("|");
            // Fallback signature for payments without a transaction_id
            // (Purchase Order, cash, cheque, etc.).
            const altSig = [
              "alt",
              String(p.payment_method || "").trim().toLowerCase(),
              String(p.payment_mode   || "").trim().toLowerCase(),
              Number(p.amount || 0).toFixed(2),
              String(p.payment_date || p.created_at || "").slice(0, 10),
              String(p.description || "").trim().toLowerCase(),
              Number(p.is_return || 0),
            ].join("|");
            if (p.transaction_id && seenSig.has(txnSig)) return false;
            if (!p.transaction_id && seenSig.has(altSig)) return false;
            seenIds.add(p.id);
            seenSig.add(p.transaction_id ? txnSig : altSig);
            return true;
          });

          const sortedPayments = unique.sort((a: Payment, b: Payment) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
          );

          // Backend already filters is_deleted=0; use Number() for safe int/string comparison
          const validPayments = sortedPayments.filter(
            (p: Payment) => Number(p.is_deleted) === 0 && Number(p.is_return) === 0
          );
          const refunded = sortedPayments.filter(
            (p: Payment) => Number(p.is_deleted) === 0 && Number(p.is_return) === 1
          );

          setPayments(validPayments);
          setRefunds(refunded);

          setLoading(false);
        })
        .catch(error => {
          console.error("Error fetching payments:", error);
          setLoading(false);
        });
    };
    
    
    useEffect(() => {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    };
      axios.get(`${API_URL}/payment-url`, {headers})
        .then(response => {
          setPaymentUrl(response.data.payment_url);
        })
        .catch(error => {
          console.error("Error fetching payment URL:", error);
        });
    }, []);



  useEffect(() => {
    // ── Prefer live transaction records, but fall back to the persisted
    //     invoice/work-order amount_paid so the summary never shows $0
    //     when payments exist but the live fetch hasn't (re)populated yet.
    const paymentsTotal = payments.reduce(
      (sum, p) => sum + Math.abs(parseFloat(String(p.amount || 0))),
      0
    );
    const refundedTotal = refunds.reduce(
      (sum, r) => sum + Math.abs(parseFloat(String(r.amount || 0))),
      0
    );
    const liveAdjustedPaid = Math.max(0, paymentsTotal - refundedTotal);
    const persistedPaid = Math.max(
      0,
      Number(invoiceList?.amount_paid ?? WorkOrderDataList?.amount_paid ?? 0)
    );
    // Use the live value when we actually have transactions to sum from;
    // otherwise trust the persisted invoice total.
    const adjustedPaid = payments.length > 0 || refunds.length > 0
      ? liveAdjustedPaid
      : persistedPaid;
    const grandTotalNum = parseFloat(
      invoiceList?.quoteWorkOrderSaleGrandTotal ||
      WorkOrderDataList?.quoteWorkOrderSaleGrandTotal ||
      "0"
    );
    const dueAmt = Math.max(0, grandTotalNum - adjustedPaid);

    // grossAmountPaid = raw sum of all payments (before refunds)
    // totalRefunded   = raw sum of all refunds
    // amountPaid      = net adjusted paid (payments − refunds), with persisted fallback
    // dueAmount       = grand total − adjusted paid
    setGrossAmountPaid(payments.length > 0 ? paymentsTotal : persistedPaid);
    setTotalRefunded(refundedTotal);
    setAmountPaid(adjustedPaid);
    setDueAmount(dueAmt);

    if (grandTotalNum > 0) {
      setAmount(adjustedPaid <= 0 ? grandTotalNum : dueAmt);
    }

    if (WorkOrderDataList?.customer?.customerEmail) {
      setInvoiceEmailData(prev => ({ ...prev, to: WorkOrderDataList.customer.customerEmail }));
    }
  }, [WorkOrderDataList, invoiceList, payments, refunds]);


  useEffect(() => {
    // Pre-fill payment dialog with the current balance due (always from real-time state)
    const initialAmount = dueAmount.toFixed(2);
    setEditableAmount(initialAmount);
    setPaymentData(prev => ({ ...prev, amount: initialAmount }));
  }, [dueAmount]);
  

  

 useEffect(() => {
  // Check if there is already a selected template
  if (!invoiceEmailData.template && emailTemplateList.length > 0) {
    // Find the default template with the name "Payment Link"
    const defaultTemplate = emailTemplateList.find(
      (template) => template.template_name === "Invoice"
    ) || emailTemplateList.find(
      (template) => template.template_name === "Payment Link"
    );

    if (defaultTemplate) {
      // Set the default template
      setInvoiceEmailData({
        ...invoiceEmailData,
        template: String(defaultTemplate.id), // Set default template ID
        subject: defaultTemplate.subject, // Set subject
        message: defaultTemplate.message, // Set message
      });
    }
  }

  // Update the subject and message when the selected template changes
  if (invoiceEmailData.template) {
    const selectedTemplate = emailTemplateList.find(
      (template) => template.id === Number(invoiceEmailData.template)
    );

    if (selectedTemplate) {
      setInvoiceEmailData({
        ...invoiceEmailData,
        subject: selectedTemplate.subject,
        message: selectedTemplate.message,
      });
    }
  }
}, [invoiceEmailData.template, emailTemplateList]);


useEffect(() => {
  // Check if there is already a selected template
  if (!driverEmailData.template && emailTemplateList.length > 0) {
    // Find the default template with the name "Payment Link"
    const defaultTemplate = emailTemplateList.find(
      (template) => template.template_name === "Trip Assignment"
    );

    if (defaultTemplate) {
      // Set the default template
      setDriverEmailData({
        ...driverEmailData,
        template: String(defaultTemplate.id), // Set default template ID
        subject: defaultTemplate.subject, // Set subject
        message: defaultTemplate.message, // Set message
      });
    }
  }


  if (driverEmailData.template) {
    const selectedTemplate = emailTemplateList.find(
      (template) => template.id === Number(driverEmailData.template)
    );

    if (selectedTemplate) {
      setDriverEmailData({
        ...driverEmailData,
        subject: selectedTemplate.subject,
        message: selectedTemplate.message,
      });
    }
  }
}, [driverEmailData.template, emailTemplateList]);

   
      
      const fetchEmailLogs = async () => {
        try {
          const response = await axios.get(`${API_URL}/view-email-logs`);
          setEmailLog(response.data.emailLogs); // Set the fetched data to state
        } catch (error) {
          console.error("Failed to load email logs", error);
        }
      };

      const fetchBamboraTransaction = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/view-bambora-transactions`,
            {
              params: { id: QuoteId },  // Pass workOrderId as a query parameter
            }
          );
          setBamboraTransactionData(response.data.bamboraTransactions); // Set fetched data to state
        } catch (error) {
          console.error("Failed to load Bambora transactions", error);
        }
      };
    
      // Fetch declined transactions for the work order
      const fetchDeclinedTransaction = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/view-declined-transactions`,
            {
              params: { id: QuoteId }, // Pass workOrderId as a query parameter
            }
          );
          setDeclinedTransaData(response.data.declinedTransactions); // Set fetched data to state
        } catch (error) {
          console.error("Failed to load declined transactions", error);
        }
      };


      useEffect(() => {
        fetchEmailLogs();
      }, []);

      useEffect(() => {
        if (QuoteId) {
          fetchBamboraTransaction();
          fetchDeclinedTransaction();
        }
      }, [QuoteId])


 const handleRefundAll = async () => {
    if (!payments.length) return;
    setIsRefundLoading(true);
    try {
      for (const payment of payments) {
        if (!payment.transaction_id) continue;
        const payload = { id: payment.transaction_id, updated_by: userInfo?.user_id };
        await axios.post(`${API_URL}/returntransaction`, payload, { headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` } });
      }
      showMessage("All payments refunded successfully!");
      fetchPayments();
      setTimeout(() => invoiceRefetch(), 800);
    } catch {
      // Try local-only soft refund via delete
      try {
        const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };
        for (const payment of payments) {
          await axios.post(`${API_URL}/delete-payment/${payment.id}`, { work_order_id: QuoteId, _method: "DELETE" }, { headers });
        }
        showMessage("Payments removed. You can now terminate.");
        fetchPayments();
        setTimeout(() => invoiceRefetch(), 800);
      } catch {
        showErrorMessage("Refund failed. Please refund manually from Payment History.");
      }
    } finally {
      setIsRefundLoading(false);
    }
  };

 const refundPayment = (transactionId: any) => {
    if (!transactionId) return;
    setRefundConfirmId(transactionId);
  };

  const executeRefund = async () => {
    const transactionId = refundConfirmId;
    setRefundConfirmId(null);
    if (!transactionId) return;
    setIsRefundLoading(true);

    const payload = { id: transactionId, updated_by: userInfo?.user_id };
    const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };

    try {
      const response = await axios.post(`${API_URL}/returntransaction`, payload, { headers });
      if (response.status === 200 && response.data?.infocode !== 'ERROR') {
        showMessage("Refund successful!");
        setTimeout(() => { invoiceRefetch(); }, 1000);
        fetchPayments();
      } else {
        showErrorMessage(response.data?.message || "Refund failed");
      }
    } catch (error: any) {
      console.error(error);
      showErrorMessage(error?.response?.data?.message || "An error occurred during refund.");
    } finally {
      setIsRefundLoading(false);
    }
  };


const deletePayment = async (id: any) => {
      const confirmed = await confirm({
        title: "Delete Payment",
        message: "Are you sure you want to delete this payment? This action cannot be undone.",
        confirmLabel: "Delete",
        cancelLabel: "Cancel",
        variant: "danger",
      });
      if (!confirmed) return;
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };
      axios.post(`${API_URL}/delete-payment/${id}`, {
        work_order_id: QuoteId,
        _method: 'DELETE',
      }, { headers })
        .then(() => {
          showMessage("Payment deleted!");
          setTimeout(() => { invoiceRefetch(); }, 1000);
          fetchPayments();
        })
        .catch(error => {
          console.error("Delete error:", error);
          showErrorMessage("Failed to delete payment.");
        });
    };



  const timeLineSteps = React.useMemo(() => {
    if (
      workOrderHistoryData &&
      Array.isArray(workOrderHistoryData.data) &&
      workOrderHistoryData.data.length > 0
    ) {
      const steps = workOrderHistoryData.data.map((order, index) => {
        // Distinguish the conversion snapshot (isInvoice flipped false→true)
        // from subsequent invoice-side edits (isInvoice was already true on
        // the previous snapshot too). Both rows have isInvoice=true after
        // editInvoice mirrors into workOrderHistory.
        const prevSnap: any = index > 0 ? (workOrderHistoryData.data as any[])[index - 1] : null;
        const prevIsInvoice = !!(prevSnap && prevSnap.isInvoice);
        const isConversionStep = !!order.isInvoice && !prevIsInvoice && index !== 0;
        const isInvoiceEditStep = !!order.isInvoice && prevIsInvoice && index !== 0;
        const label =
          index === 0
            ? "Quote created"
            : order.quoteWorkOrderStatus === WorkOrderStatus.Cancel
            ? "Quote terminated"
            : isConversionStep
            ? "Quote converted to invoice"
            : isInvoiceEditStep
            ? "Invoice edited"
            : "Quote edited";


        // ── Derived values for this snapshot ──────────────────────────────
        const snapGrandTotal  = Number(order.quoteWorkOrderSaleGrandTotal || 0);
        const snapSubTotal    = Number(order.quoteWorkOrderSubTotal || 0);
        const snapDiscount    = Number(order.quoteWorkOrderDiscount || 0);
        const snapHst         = Math.max(0, snapGrandTotal - snapSubTotal + snapDiscount);
        const snapRaw         = index === 0
          ? (order.created_at || order.updated_at || "")
          : (order.updated_at || order.created_at || "");
        const snapDayjs       = snapRaw ? dayjs(snapRaw) : null;
        const snapDateStr     = snapDayjs ? snapDayjs.format("MMM D, YYYY") : "—";
        const snapTimeStr     = snapDayjs ? snapDayjs.format("h:mm A") : "";
        const isTerminated    = order.quoteWorkOrderStatus === WorkOrderStatus.Cancel && index !== 0;
        // "Edited" includes both quote edits and invoice edits — both should
        // surface their `changes` diff. Only the initial conversion step is
        // excluded (it's a state flip, not a content edit).
        const isEdited        = (isInvoiceEditStep || (!order.isInvoice && !isTerminated && index !== 0));
        const termMemo: string = (order as any).quoteWorkOrderCustomerMemo || "";
        const terminateReason = termMemo.startsWith("__TERMINATE__:")
          ? termMemo.slice("__TERMINATE__:".length).trim() : null;

        // ── "What changed" payload from the backend (only on edited rows) ──
        const editChanges: Array<{
          kind?: string; field: string; label?: string;
          from?: any; to?: any; index?: number; sub?: number;
        }> = isEdited && Array.isArray((order as any).changes) ? (order as any).changes : [];
        const fmtChangeValue = (field: string, v: any): string => {
          if (v === null || v === undefined || v === "") return "—";
          // Heuristic: anything time-ish renders as date+time
          const isDateField =
            /dateTime|DateTime|IssueDate|DueDate/i.test(field) ||
            (typeof v === "string" && /\d{4}-\d{2}-\d{2}T/.test(v));
          if (isDateField) {
            const d = dayjs(v);
            if (d.isValid()) return d.format("MMM D, YYYY h:mm A");
          }
          // Money-ish numeric fields
          if (/Total|SubTotal|Discount|price|Price/.test(field)) {
            const n = Number(v);
            if (!Number.isNaN(n) && String(v).trim() !== "") return `$${n.toFixed(2)}`;
          }
          return String(v);
        };

        const actorLabel = index === 0
          ? "Created by"
          : isConversionStep
          ? "Converted by"
          : isTerminated
          ? "Terminated by"
          : "Edited by";
        const actionColor = index === 0
          ? "#2f3891"
          : isConversionStep
          ? "#16a34a"
          : isTerminated
          ? "#dc2626"
          : "#f59e0b";

        const description = (
          <Box sx={{ mt: 1 }}>

            {/* ── Meta row: actor + date ───────────────────────────────────── */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, bgcolor: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, px: 1.5, py: 0.4 }}>
                <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: actionColor }} />
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#475569" }}>{actorLabel}:</Typography>
                <Typography sx={{ fontSize: 11, color: "#1e293b", fontWeight: 700 }}>{order.updated_by || "—"}</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, bgcolor: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, px: 1.5, py: 0.4 }}>
                <Typography sx={{ fontSize: 11, color: "#94a3b8" }}>📅</Typography>
                <Typography sx={{ fontSize: 11, color: "#475569" }}>{snapDateStr}</Typography>
              </Box>
              {snapTimeStr && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, bgcolor: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10, px: 1.5, py: 0.4 }}>
                  <Typography sx={{ fontSize: 11, color: "#3b82f6" }}>🕐</Typography>
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#1d4ed8" }}>{snapTimeStr}</Typography>
                </Box>
              )}
            </Box>

            {/* ── What changed (edited events only) ───────────────────────── */}
            {isEdited && editChanges.length > 0 && (
              <Box sx={{ mb: 1.5, p: 1.25, bgcolor: "#fffbeb", border: "1px solid #fde68a", borderRadius: 2 }}>
                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#b45309", textTransform: "uppercase", letterSpacing: 0.6, mb: 0.75 }}>
                  Changes
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 2.25 }}>
                  {editChanges.map((c, ci) => (
                    <Box component="li" key={ci} sx={{ fontSize: 12, color: "#1e293b", lineHeight: 1.6 }}>
                      <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: "#92400e" }}>
                        {c.label || c.field}
                        {typeof c.index === "number" && (c.kind === "sale" || c.kind === "stop") ? ` (Service ${c.index + 1})` : ""}
                        :{" "}
                      </Typography>
                      <Typography component="span" sx={{ fontSize: 12, color: "#64748b", textDecoration: "line-through" }}>
                        {fmtChangeValue(c.field, c.from)}
                      </Typography>
                      <Typography component="span" sx={{ fontSize: 12, color: "#475569", mx: 0.5 }}>→</Typography>
                      <Typography component="span" sx={{ fontSize: 12, color: "#15803d", fontWeight: 600 }}>
                        {fmtChangeValue(c.field, c.to)}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}

            {/* ── Trip Name banner ─────────────────────────────────────────── */}
            {order.quoteWorkOrderSale?.some((p: any) => p.productShortDescription) && (
              <Box sx={{ mb: 1.5, px: 2, py: 1.25, bgcolor: "#ede9fe", borderLeft: "4px solid #2f3891", borderRadius: "0 8px 8px 0", display: "flex", flexWrap: "wrap", gap: 0.75, alignItems: "center" }}>
                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#2f3891", textTransform: "uppercase", letterSpacing: 0.6, mr: 0.5 }}>Trip Name:</Typography>
                {order.quoteWorkOrderSale
                  .filter((p: any) => p.productShortDescription)
                  .map((p: any, i: number) => (
                    <Box key={i} sx={{ bgcolor: "#fff", border: "1px solid #c7d2fe", borderRadius: 4, px: 1.25, py: 0.2 }}>
                      <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#4338ca" }}>{p.productShortDescription}</Typography>
                    </Box>
                  ))}
              </Box>
            )}

            {/* ── Invoice badge ────────────────────────────────────────────── */}
            {!!order.isInvoice && (
              <Box sx={{ mb: 1.5, p: 1.5, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                  <Box>
                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#16a34a", textTransform: "uppercase", letterSpacing: 0.5 }}>Charter No.</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#15803d" }}>
                      {order.InvoiceNo || invoiceList?.InvoiceNo || derivedInvoiceNo || "—"}
                    </Typography>
                  </Box>
                  {(order.po_number || invoiceList?.po_number || WorkOrderDataList?.po_number) && (
                    <Box>
                      <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#16a34a", textTransform: "uppercase", letterSpacing: 0.5 }}>PO Number</Typography>
                      <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#15803d" }}>
                        {order.po_number || invoiceList?.po_number || WorkOrderDataList?.po_number}
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Button size="small" variant="contained" startIcon={<VisibilitySharpIcon sx={{ fontSize: 13 }} />}
                  onClick={() => handleOpenViewInvoice(String(WorkOrderDataList?.id))}
                  sx={{ bgcolor: "#16a34a", "&:hover": { bgcolor: "#15803d" }, textTransform: "none", fontWeight: 600, fontSize: 12, borderRadius: 1.5, boxShadow: "none", px: 1.5, py: 0.5 }}>
                  View Invoice
                </Button>
              </Box>
            )}

            {/* ── Termination notice ───────────────────────────────────────── */}
            {isTerminated && (
              <Box sx={{ mb: 1.5, p: 1.5, bgcolor: "#fef2f2", border: "1px solid #fecaca", borderRadius: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: terminateReason ? 1 : 0 }}>
                  <Typography sx={{ fontSize: 13 }}>⛔</Typography>
                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#dc2626" }}>This quote was terminated</Typography>
                </Box>
                {terminateReason && (
                  <Box sx={{ bgcolor: "#fff", border: "1px solid #fecaca", borderRadius: 1.5, px: 1.25, py: 0.75 }}>
                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.5, mb: 0.25 }}>Reason</Typography>
                    <Typography sx={{ fontSize: 12, color: "#7f1d1d", fontWeight: 500 }}>{terminateReason}</Typography>
                  </Box>
                )}
              </Box>
            )}

            {/* ── Services table ───────────────────────────────────────────── */}
            {order.quoteWorkOrderSale && order.quoteWorkOrderSale.length > 0 && (
              <Box sx={{ border: "1px solid #e2e8f0", borderRadius: 2, overflow: "hidden", mb: 1.5 }}>
                {/* Table header */}
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr auto auto auto", gap: 0, bgcolor: "#f8fafc", borderBottom: "1px solid #e2e8f0", px: 1.5, py: 0.75 }}>
                  <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.6 }}>Service / Product</Typography>
                  <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.6, textAlign: "center", minWidth: 50 }}>Qty</Typography>
                  <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.6, textAlign: "right", minWidth: 70 }}>Unit Price</Typography>
                  <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.6, textAlign: "right", minWidth: 70 }}>Subtotal</Typography>
                </Box>
                {/* Table rows */}
                {order.quoteWorkOrderSale.map((row: IProduct, ri: number) => {
                  const qty   = (row as any).busCount ?? (row as any).quantity ?? 1;
                  const price = row.price ?? 0;
                  const sub   = price * qty;
                  return (
                    <Box key={ri} sx={{ display: "grid", gridTemplateColumns: "1fr auto auto auto", gap: 0, px: 1.5, py: 1, borderBottom: ri < order.quoteWorkOrderSale.length - 1 ? "1px solid #f1f5f9" : "none", bgcolor: ri % 2 === 1 ? "#fafafa" : "#fff", alignItems: "center" }}>
                      <Box>
                        {row.productShortDescription && (
                          <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#2f3891", mb: 0.15 }}>{row.productShortDescription}</Typography>
                        )}
                        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#1e293b" }}>{row.productName || "—"}</Typography>
                        {(row as any).tripType && (
                          <Typography sx={{ fontSize: 10, color: "#94a3b8", mt: 0.15 }}>{(row as any).tripType}</Typography>
                        )}
                      </Box>
                      <Typography sx={{ fontSize: 12, color: "#475569", textAlign: "center", minWidth: 50 }}>{qty}</Typography>
                      <Typography sx={{ fontSize: 12, color: "#475569", textAlign: "right", minWidth: 70 }}>${price.toFixed(2)}</Typography>
                      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#1e293b", textAlign: "right", minWidth: 70 }}>${sub.toFixed(2)}</Typography>
                    </Box>
                  );
                })}
              </Box>
            )}

            {/* ── Totals summary ───────────────────────────────────────────── */}
            <Box sx={{ bgcolor: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 2, overflow: "hidden" }}>
              {/* Subtotal */}
              <Box sx={{ display: "flex", justifyContent: "space-between", px: 1.5, py: 0.75, borderBottom: "1px solid #f1f5f9" }}>
                <Typography sx={{ fontSize: 12, color: "#64748b" }}>Subtotal</Typography>
                <Typography sx={{ fontSize: 12, color: "#1e293b", fontWeight: 500 }}>${snapSubTotal.toFixed(2)}</Typography>
              </Box>
              {/* Discounts */}
              {order.quoteWorkOrderSaleDiscountDescription && order.quoteWorkOrderSaleDiscountDescription.map((d: IDiscount, di: number) => (
                <Box key={di} sx={{ display: "flex", justifyContent: "space-between", px: 1.5, py: 0.6, borderBottom: "1px solid #f1f5f9" }}>
                  <Typography sx={{ fontSize: 12, color: "#dc2626" }}>{d.description || "Discount"}</Typography>
                  <Typography sx={{ fontSize: 12, color: "#dc2626", fontWeight: 500 }}>-${(d.value ?? 0).toFixed(2)}</Typography>
                </Box>
              ))}
              {snapDiscount > 0 && (
                <Box sx={{ display: "flex", justifyContent: "space-between", px: 1.5, py: 0.6, borderBottom: "1px solid #f1f5f9" }}>
                  <Typography sx={{ fontSize: 12, color: "#64748b" }}>Total Discount</Typography>
                  <Typography sx={{ fontSize: 12, color: "#dc2626", fontWeight: 500 }}>-${snapDiscount.toFixed(2)}</Typography>
                </Box>
              )}
              {/* HST */}
              {snapHst > 0 && (
                <Box sx={{ display: "flex", justifyContent: "space-between", px: 1.5, py: 0.6, borderBottom: "1px solid #f1f5f9" }}>
                  <Typography sx={{ fontSize: 12, color: "#64748b" }}>HST</Typography>
                  <Typography sx={{ fontSize: 12, color: "#1e293b", fontWeight: 500 }}>${snapHst.toFixed(2)}</Typography>
                </Box>
              )}
              {/* Grand Total */}
              <Box sx={{ display: "flex", justifyContent: "space-between", px: 1.5, py: 1, bgcolor: "#1e293b" }}>
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>Grand Total</Typography>
                <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#fff" }}>${snapGrandTotal.toFixed(2)}</Typography>
              </Box>
            </Box>

          </Box>
        );


        

        return {
          label,
          description,
          _ts: snapDayjs ? snapDayjs.valueOf() : 0,
        };
      });






  
//   if (bamboraTransactionData && bamboraTransactionData.length > 0) {
//     bamboraTransactionData.forEach((transaction) => {
//       steps.push({
//         label: "Payment Successful",
//         description: (
//           <div>
//             <Typography variant="body1">
//               <strong>Transaction ID:</strong> {transaction.trnId}
//               <br />
//               <strong>Amount:</strong> ${transaction.trnAmount}
//               <br />
//               <strong>Date</strong>{" "}
//               {transaction.trnDate && transaction.trnTime ? (
//   <>
//     {moment(transaction.trnDate).format('MMM DD, YYYY')} at {moment(transaction.trnTime, 'HH:mm:ss').format('hh:mm A')}
//   </>
// ) : (
//   ""
// )}
//             </Typography>
//           </div>
//         ),
//       });
//     });
//   }

//   if (declinedTransaData && declinedTransaData.length > 0) {
//     declinedTransaData.forEach((transaction) => {
//       steps.push({
//         label: "Payment Declined",
//         description: (
//           <div>
//             <Typography variant="body1">
//               <strong>Transaction ID:</strong> {transaction.trnId}
//               <br />
//               {/* <strong>Reason:</strong> {transaction.messageText || "N/A"}
//               <br /> */}
//               <strong>Date:</strong>{" "}
//               { transaction.created_at
//                   ? moment(transaction.created_at).format("MMM DD, YYYY, hh:mm a")
//                   : ""}
             
//             </Typography>
//           </div>
//         ),
//       });
//     });
//   }

if (
  assignDriverHistoryData && 
  Array.isArray(assignDriverHistoryData.data) && 
  assignDriverHistoryData.data.length > 0
) {
  assignDriverHistoryData.data.forEach((driverEvent) => {
    // Ensure assign_to is an array
    const assignedDrivers = Array.isArray(driverEvent.assign_to) ? driverEvent.assign_to : [];

    // Find matching drivers from driverList
    const assignedDriverNames = assignedDrivers
      .map((driverObj: any) => {
        const matchedDriver = driverList.find((driver) => driver.id === driverObj.driverId);
        return matchedDriver ? `${matchedDriver.driverFirstName} ${matchedDriver.driverLastName}` : "Unknown Driver";
      })
      .join(", "); // Convert array to a string
     // Convert array to a string

    //   console.log("Driver List:", driverList);
    // console.log("Assigned Drivers:", assignedDrivers);
    // console.log("Resolved Driver Names:", assignedDriverNames);

      const assignedDate = driverEvent?.created_at
      ? dayjs(driverEvent.created_at).format("MMM D, YYYY [at] h:mm A")
      : "";

    const driverEventTs = driverEvent.created_at ? dayjs(driverEvent.created_at).valueOf() : 0;
    steps.push({
      label: "Driver Assigned",
      description: (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 0.5 }}>
            <Box sx={{ bgcolor: "#eef2ff", border: "1px solid #c7d2fe", borderRadius: 1.5, px: 1.5, py: 0.5 }}>
              <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#2f3891" }}>🚗 {assignedDriverNames}</Typography>
            </Box>
          </Box>
          <Typography variant="body1"><strong>Assigned By:</strong> {driverEvent.updated_by || "—"}</Typography>
          <Typography variant="body1"><strong>Date:</strong> {driverEvent.created_at ? `${dayjs(driverEvent.created_at).format("MMM D, YYYY")} · ${dayjs(driverEvent.created_at).format("h:mm A")}` : "—"}</Typography>
        </Box>
      ),
      _ts: driverEventTs,
    });
  });
}


  // Add payment events
  if (payments && payments.length > 0) {
    const grandTotalForPay = parseFloat(String(invoiceList?.quoteWorkOrderSaleGrandTotal || "0"));
    // Sort payments chronologically to compute running totals correctly
    const sortedPayments = [...payments].sort((a, b) =>
      dayjs(a.created_at || a.payment_date).valueOf() - dayjs(b.created_at || b.payment_date).valueOf()
    );
    let runningPaid = 0;
    sortedPayments.forEach((payment) => {
      const paidAmt = parseFloat(String(payment.amount || 0));
      runningPaid += paidAmt;
      const remaining = Math.max(0, grandTotalForPay - runningPaid);
      const payTs = payment.created_at ? dayjs(payment.created_at).valueOf() : (payment.payment_date ? dayjs(payment.payment_date).valueOf() : 0);
      steps.push({
        label: "Payment Received",
        description: (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 0.5 }}>
              <Box sx={{ bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 1.5, px: 1.5, py: 0.5 }}>
                <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#16a34a" }}>Amount: ${paidAmt.toFixed(2)}</Typography>
              </Box>
              {remaining > 0 && (
                <Box sx={{ bgcolor: "#fef2f2", border: "1px solid #fecaca", borderRadius: 1.5, px: 1.5, py: 0.5 }}>
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#dc2626" }}>Due: ${remaining.toFixed(2)}</Typography>
                </Box>
              )}
              {remaining === 0 && (
                <Box sx={{ bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 1.5, px: 1.5, py: 0.5 }}>
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#16a34a" }}>✓ Fully Paid</Typography>
                </Box>
              )}
            </Box>
            <Typography variant="body1"><strong>Method:</strong> {payment.payment_method}</Typography>
            <Typography variant="body1"><strong>Date:</strong> {formatDateTime(payment.payment_date || payment.created_at, "MMM D, YYYY")}{payment.created_at ? ` · ${formatDateTime(payment.created_at, "h:mm A")}` : ""}</Typography>
            {payment.description && <Typography variant="body1"><strong>Note:</strong> {payment.description}</Typography>}
          </Box>
        ),
        _ts: payTs,
      });
    });
  }

  // Add refund events
  if (refunds && refunds.length > 0) {
    refunds.forEach((refund) => {
      const refundAmt = Math.abs(parseFloat(String(refund.amount || 0)));
      const refundTs = refund.created_at ? dayjs(refund.created_at).valueOf() : 0;
      steps.push({
        label: "Refund Issued",
        description: (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 0.5 }}>
              <Box sx={{ bgcolor: "#fef2f2", border: "1px solid #fecaca", borderRadius: 1.5, px: 1.5, py: 0.5 }}>
                <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#dc2626" }}>↩ Refunded: ${refundAmt.toFixed(2)}</Typography>
              </Box>
            </Box>
            <Typography variant="body1"><strong>Method:</strong> {refund.payment_method || "—"}</Typography>
            <Typography variant="body1"><strong>Date:</strong> {dayjs(refund.payment_date || refund.created_at).format("MMM D, YYYY")}{refund.created_at ? ` · ${dayjs(refund.created_at).format("h:mm A")}` : ""}</Typography>
            {refund.description && <Typography variant="body1"><strong>Note:</strong> {refund.description}</Typography>}
          </Box>
        ),
        _ts: refundTs,
      });
    });
  }

  // Sort all events by timestamp descending (most recent first). When two
  // events share the same timestamp (e.g. "Quote created" and "Quote
  // converted to invoice" written in the same second), use a label-based
  // tiebreaker so they always render in a stable lifecycle order:
  //   Quote created → Quote converted to invoice → Invoice edited → …
  // In a newest-first list, items with a HIGHER priority value appear
  // closer to the top, so "Quote created" gets the lowest priority among
  // its peers — pushing it BELOW "Quote converted to invoice" in display
  // since the conversion logically happens AFTER the creation.
  const labelPriority = (label: string): number => {
    const l = (label || "").toLowerCase();
    if (l.includes("quote created"))                  return 1; // oldest
    if (l.includes("converted") || (l.includes("invoice") && !l.includes("edited") && !l.includes("driver"))) return 2;
    if (l.includes("edited"))                         return 3;
    if (l.includes("driver"))                         return 4;
    if (l.includes("payment"))                        return 5;
    if (l.includes("refund"))                         return 6;
    if (l.includes("terminat"))                       return 7;
    return 0;
  };
  steps.sort((a: any, b: any) => {
    const tsDiff = (b._ts ?? 0) - (a._ts ?? 0);
    if (tsDiff !== 0) return tsDiff;
    return labelPriority(b.label) - labelPriority(a.label);
  });
  return steps;
}


    return [];
  }, [workOrderHistoryData, bamboraTransactionData, declinedTransaData, assignDriverHistoryData, driverList, payments, refunds, invoiceList]);

  const stripHtmlTags = (html: string) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  };

  const toggleStepDetails = (index: number) => {
    if (expandedSteps.includes(index)) {
      setExpandedSteps(
        expandedSteps.filter((stepIndex) => stepIndex !== index)
      );
    } else {
      setExpandedSteps([...expandedSteps, index]);
    }
  };

  const toggleStepDetail = (index: number) => {
    if (expandedStep.includes(index)) {
      setExpandedStep(
        expandedStep.filter((stepIndex) => stepIndex !== index)
      );
    } else {
      setExpandedStep([...expandedSteps, index]);
    }
  };

  const toggleStepInvoice = (index: number) => {
    if (expandedStepsInvoice.includes(index)) {
      setExpandedStepsInvoice(
        expandedStepsInvoice.filter((stepIndex) => stepIndex !== index)
      );
    } else {
      setExpandedStepsInvoice([...expandedStepsInvoice, index]);
    }
  };

  const coursings = Array.isArray(WorkOrderDataList?.quoteWorkOrderSale)
    ? WorkOrderDataList!.quoteWorkOrderSale
    : [];

    const invoiceCoursings = Array.isArray(invoiceList?.quoteWorkOrderSale)
    ? invoiceList!.quoteWorkOrderSale
    : [];

    // const invoiceCoursings = invoiceList.flatMap((invoice) =>
    //   Array.isArray(invoice.quoteWorkOrderSale) ? invoice.quoteWorkOrderSale : []
    // );
    
  

  // const activeStep = WorkOrderDataList?.quoteWorkOrderStatus || 0;

  useEffect(() => {
    if (!WorkOrderDataList) return;
    const hasInvoice = !!WorkOrderDataList.invoiceId;
    if (hasInvoice && dueAmount === 0 && amountPaid > 0) {
      // Fully paid
      setActiveStep(3);
    } else if (hasInvoice) {
      // Invoice exists but still has a balance
      setActiveStep(2);
    } else {
      // Not yet converted — keep current step if already advanced (just-converted pending refetch)
      setActiveStep((prev) => (prev <= 1 ? 1 : prev));
    }
  }, [WorkOrderDataList, dueAmount, amountPaid]);

    useEffect(() => {
        let newTotalPrice = 0;
        let newTotalTax = 0;
      
        coursings.forEach((product) => {
          newTotalPrice += (product.price ?? 0) * (product.quantity ?? 1); // price × quantity
          newTotalTax += product.taxAmount ?? 0; // Sum of tax amounts
        });
      
        setTotalPrice(newTotalPrice); // Update state with new total price
        setTotalTax(newTotalTax); // Update state with new total tax
      }, [coursings, totalPrice, totalTax]);

      useEffect(() => {
        let newTotalPrice = 0;
        let newTotalTax = 0;
      
        // Calculate totals for invoiceList
        invoiceCoursings.forEach((product: any) => {
          newTotalPrice += (product.price ?? 0) * (product.quantity ?? 1); // price × quantity
          newTotalTax += product.taxAmount ?? 0; // Sum of invoice tax amounts
        });
      
        setInvoiceTotalPrice(newTotalPrice); // Update state with new total price for invoices
        setInvoiceTotalTax(newTotalTax); // Update state with new total tax for invoices
   //console.log(newTotalPrice)
      }, [invoiceList, invoiceTotalPrice, invoiceTotalTax  ]);

  const handleWorkOrder = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleOpenDialog = () => {
    setHasPo(null);
    setPoNumber("");
    setPoDocumentFile(null);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setHasPo(null);
    setPoNumber("");
    setPoDocumentFile(null);
  };

  const handleConfirmDialog = () => {
    setOpen(false);
    // PO payment is now created exclusively by the /update-po-number flow that
    // fires from proceedWithInvoiceSuccess → useEffect at line ~649. The older
    // pendingPoPayment path also POSTed to /save-payment, which produced a
    // second payment row alongside the one /update-po-number creates. Keeping
    // a single canonical path here avoids the duplicate PO payment.
    proceedWithInvoiceSuccess(hasPo ? poNumber : "");
  };

  const handleRefundSubmit = async () => {
    const refundAmt = parseFloat(refundData.amount);
    const errors = {
      amount: !refundData.amount || refundAmt <= 0 || refundAmt > amountPaid,
      method: !refundData.method,
      reason: !refundData.reason.trim(),
      proof: false,
    };
    setRefundErrors(errors);
    if (Object.values(errors).some(Boolean)) return;

    setRefundSubmitLoading(true);
    try {
      const formData = new FormData();
      formData.append("work_order_id", QuoteId || "");
      formData.append("invoice_id", String(WorkOrderDataList?.invoiceId || ""));
      formData.append("refund_amount", refundData.amount);
      formData.append("refund_method", refundData.method);
      formData.append("reason", refundData.reason);
      if (refundProof) formData.append("proof", refundProof);
      const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };
      await axios.post(`${API_URL}/refund`, formData, { headers });
      showMessage("Refund processed successfully!");
      fetchPayments();
      setTimeout(() => invoiceRefetch(), 600);
      setTerminateStep("terminate");
    } catch {
      showErrorMessage("Refund failed. Please try again.");
    } finally {
      setRefundSubmitLoading(false);
    }
  };

  const handleStandaloneRefundSubmit = async () => {
    const refundAmt = parseFloat(refundData.amount);
    const errors = {
      amount: !refundData.amount || refundAmt <= 0 || refundAmt > amountPaid,
      method: !refundData.method,
      reason: !refundData.reason.trim(),
      proof: false,
    };
    setRefundErrors(errors);
    if (Object.values(errors).some(Boolean)) return;

    setRefundSubmitLoading(true);
    try {
      const formData = new FormData();
      formData.append("work_order_id", QuoteId || "");
      formData.append("invoice_id", String(WorkOrderDataList?.invoiceId || ""));
      formData.append("refund_amount", refundData.amount);
      formData.append("refund_method", refundData.method);
      formData.append("reason", refundData.reason);
      if (refundProof) formData.append("proof", refundProof);
      const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };
      await axios.post(`${API_URL}/refund`, formData, { headers });
      showMessage("Refund processed successfully!");
      setOpenRefundDialog(false);
      setRefundData({ amount: "", method: "", reason: "" });
      setRefundProof(null);
      setRefundErrors({ amount: false, method: false, reason: false, proof: false });
      fetchPayments();
      setTimeout(() => invoiceRefetch(), 600);
    } catch {
      showErrorMessage("Refund failed. Please try again.");
    } finally {
      setRefundSubmitLoading(false);
    }
  };

  const handleTerminate = async () => {
    if (!terminateReason.trim()) {
      setTerminateReasonError(true);
      return;
    }
    setTerminateLoading(true);
    try {
      const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };
      await axios.post(`${API_URL}/work-order/terminate`, { QuoteId, reason: terminateReason.trim() }, { headers });
      showMessage("Work order terminated successfully");
      setOpenTerminateDialog(false);
      setTerminateReason("");
      setTerminateReasonError(false);
      setTimeout(() => {
        workOrderRefetch();
        workOrderHistoryRefetch();
      }, 800);
    } catch {
      showErrorMessage("Failed to terminate work order");
    } finally {
      setTerminateLoading(false);
    }
  };

  // Auto-save full payment via PO once the invoice is created
  useEffect(() => {
    if (!pendingPoPayment) return;
    const invoiceId = WorkOrderDataList?.invoiceId;
    if (!invoiceId) return;

    const savePOPayment = async () => {
      try {
        const grandTotal =
          WorkOrderDataList?.quoteWorkOrderSaleGrandTotal || "0";
        const grandTotalNumPre = parseFloat(grandTotal) || 0;
        const paidAlready = Number(amountPaid || (WorkOrderDataList as any)?.amount_paid || 0);
        const dueLeft = Number((WorkOrderDataList as any)?.due_amount ?? dueAmount ?? (grandTotalNumPre - paidAlready));
        // Hard guard: do not submit a duplicate PO payment when nothing is owed
        if (dueLeft <= 0 || (grandTotalNumPre > 0 && paidAlready >= grandTotalNumPre)) {
          setPendingPoPayment(false);
          return;
        }
        // Reject duplicate submission for the same PO already in payments list
        const poExists = payments.some(
          (p) =>
            String(p.transaction_id || "").trim() === String(poNumber || "").trim() &&
            String(p.payment_mode || "").toLowerCase() === "po" &&
            Number(p.is_return || 0) === 0
        );
        if (poExists) {
          setPendingPoPayment(false);
          return;
        }
        const formData = new FormData();
        formData.append("work_order_id", QuoteId || "");
        formData.append("invoice_id", String(invoiceId));
        formData.append(
          "customer_id",
          String(WorkOrderDataList?.quoteWorkOrderCustomerId || "")
        );
        formData.append("amount", grandTotal);
        formData.append("paymentDate", getCurrentDateCanada());
        formData.append("paymentMethod", "Purchase Order (PO)");
        formData.append("description", `PO Number: ${poNumber}`);
        formData.append("payment_mode", "PO");
        formData.append("transaction_id", String(poNumber || ""));
        const headers = {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        };
        await axios.post(`${API_URL}/save-payment`, formData, { headers });
        showMessage("Invoice converted and payment recorded via PO");
        setPendingPoPayment(false);
        // Immediately update amounts so UI reflects payment without waiting for refetch
        const grandTotalNum = parseFloat(grandTotal);
        setAmountPaid(grandTotalNum);
        setDueAmount(0);
        // Advance to final step (all steps complete)
        setActiveStep(3);
        setTimeout(() => {
          invoiceRefetch();
          fetchPayments();
          workOrderHistoryRefetch();
        }, 1000);
      } catch (error) {
        console.error("Error saving PO payment:", error);
        showErrorMessage("Failed to record PO payment");
        setPendingPoPayment(false);
      }
    };

    savePOPayment();
  }, [pendingPoPayment, WorkOrderDataList?.invoiceId]);

  const handleOpenModal = (file: string): void => {
    const url = `${LARAVEL_API_URL}/${file}`;
    setFileUrl(url);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setFileUrl(null);
  };

  const proceedWithInvoiceSuccess = (poNumber: string) => {
    // Move to Invoice step (step 1 → shown as "Invoice created")
    // If PO is used, savePOPayment useEffect will advance to final step after payment records
    justConvertedRef.current = true;
    setActiveStep(2);

    const newMainStatus =
      WorkOrderDataList?.mainStatus === 1
        ? WorkOrderDataList.mainStatus + 1
        : 2;

    setMainStatus(String(newMainStatus));
    setId(WorkOrderDataList?.id ? String(WorkOrderDataList.id) : id);
    setPoNumber(poNumber.trim() ? poNumber : "");
    // Refetches removed — we navigate away immediately after conversion
  };


 

  // React.useEffect(() => {
  //   if (!updateIsLoading && !updateError && UpdateStatusInvoiceDataList) {
  //     navigate(`/invoice/history/${UpdateStatusInvoiceDataList.invoiceId || null}`);
  //   }
  // }, [updateIsLoading, updateError, UpdateStatusInvoiceDataList, navigate]);

  const handlePayment = () => {

 
    // const invoice = invoiceList.find(
    //   (invoice) => invoice.quoteWorkOrderNo === WorkOrderDataList?.quoteWorkOrderNo
    // );

      setActiveStep((prevStep) => prevStep + 1); 
      //setShowPaymentDetails(true);  // Show the payment details dialog 
   

  };
  

  const handleOnRoute = () => {
    
     setShowDriverDialog(true);
   
  };

  const handleDeliverComplete = () => {
    // Parse assigned drivers
    const assignedDrivers: { driverId: number; price: number; hourPrice: number }[] = 
      invoiceList.assign_driver.assign_to 
        ? JSON.parse(invoiceList.assign_driver.assign_to) 
        : [];
  
    // Check if all assigned drivers have a valid price
    const allDriversHavePrices = assignedDrivers.every(
      (driver) => driver.price !== undefined && driver.price > 0
    );
  
    if (!allDriversHavePrices) {
      showErrorMessage("Please enter a trip price for all assigned drivers.");
      return; // Stop further execution
    }
  
    try {
      const headers = {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };

      const updatePayload = {
        QuoteId: QuoteId,
    };

    
       const response =  axios.post(`${API_URL}/update-completed-status`, updatePayload, { headers });
       workOrderRefetch();
       setActiveStep((prevStep) => prevStep + 1);
      //  showMessage("Price saved successfully");


  } catch (error) {
      console.error("Error updating completed status:", error);
     showErrorMessage("Failed to update completed status.");
  }
  
    
  };
  
  

    const getNextButtonLabel = () => {
      switch (activeStep) {
        case 0:
          return "Convert to Invoice";
        case 1:
          return "Convert to Invoice";
        case 2:
          return "Process Payment";
          //return null;
        default:
          return "Finish";
      }
    };

    const handleNext = () => {
      switch (activeStep) {
        case 0:
          handleWorkOrder();
          break;
        case 1:
          handleOpenDialog();
          break;
        case 2:
          handlePayment();
          break;
        default:
          break;
      }
    };

    const handleProcessPayment = () => {
      handlePayment();
      // Optionally move to the next step after payment
      // setActiveStep(3); // Move to On Route
    };
    

    const handleSelectDriver = (driverId: number) => {
      const busCountFromInvoice = invoiceList?.quoteWorkOrderSale?.[0]?.busCount;
    
      if (!busCountFromInvoice) {
        console.warn("No busCount found in the invoiceList.quoteWorkOrderSale.");
        return;
      }
    
      setSelectedDrivers((prev) => {
        const existingDriver = prev.find((d) => d.id === driverId);
    
        if (existingDriver) {
          // Remove the driver if already selected
          return prev.filter((d) => d.id !== driverId);
        } else {
          // Add the driver only if the limit has not been reached
          if (prev.length < busCountFromInvoice) {
            return [...prev, { id: driverId, price: 0, hourPrice: 0 }];
          }
        }
    
        return prev;
      });
    };
    
    
    const handleInputChange = (driverId: number, field: "price" | "hourPrice", value: number) => {
      setSelectedDrivers((prev) =>
        prev.map((d) => 
          d.id === driverId ? { ...d, [field]: value } : d
        )
      );
    };
    

   
        const handleAssignDriver = async () => {
      
        try {
            const headers = {
                Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
            };
      
            const updatePayload = {
              drivers: selectedDrivers.map((driver) => ({
                  driverId: driver.id, 
                  price: driver.price, 
                  hourPrice: driver.hourPrice
              })),
              QuoteId: QuoteId,
          };
            const response = await axios.post(`${API_URL}/assign-driver`, updatePayload, { headers });
        
            await handleSendDriverEmail();
            invoiceRefetch();
            workOrderRefetch();
            assignDriverHistoryRefetch();
            showMessage("Assigned driver successfully and email sent to driver(s).");

            // if (WorkOrderDataList?.mainStatus !== undefined) {
            //   const newMainStatus = (WorkOrderDataList.mainStatus || 0) + 2; // Update status
            //   setMainStatus(String(newMainStatus)); // Update the state with the new status
            // }
            setSelectedDrivers([]);
            handleDriverDialogClose();
            if (shouldIncrementStep) {
              setActiveStep((prevStep) => prevStep + 1);
            }
          

        } catch (error) {
            console.error("Error assigning driver:", error);
           showErrorMessage("Failed to assign driver.");
        }
      
    };

    // ── Build pre-filled driver SMS from current trip data ────────────────────
    const buildSidebarDriverSms = (driverId: number | ""): string => {
      const sale: any = (invoiceList?.quoteWorkOrderSale as any)?.[0] ?? {};
      const customer  = invoiceList?.customer as any;

      // Date / time
      const firstPickup = Array.isArray(sale?.pickups) && sale.pickups.length > 0 ? sale.pickups[0] : null;
      const depRaw      = firstPickup?.dateTime || sale?.departureDateTime || "";
      const tripDate    = depRaw && dayjs(depRaw).isValid() ? dayjs(depRaw).format("ddd, MMM D, YYYY") : "TBD";
      const pickupTime  = depRaw && dayjs(depRaw).isValid() ? dayjs(depRaw).format("h:mm A") : "TBD";

      const lastDropoff = Array.isArray(sale?.dropoffs) && sale.dropoffs.length > 0
        ? sale.dropoffs[sale.dropoffs.length - 1] : null;
      const dropRaw     = lastDropoff?.dateTime || sale?.returnDateTime || "";
      const dropoffTime = dropRaw && dayjs(dropRaw).isValid() ? dayjs(dropRaw).format("h:mm A") : "TBD";

      // Addresses
      const pickupAddr  = firstPickup?.address
        ? `${firstPickup.address}${firstPickup.city ? `, ${firstPickup.city}` : ""}`
        : (sale?.transferTypeFrom || "N/A");
      const dropAddr    = lastDropoff?.address
        ? `${lastDropoff.address}${lastDropoff.city ? `, ${lastDropoff.city}` : ""}`
        : (sale?.transferTypeTo || "N/A");

      // Client info
      const clientName  = customer
        ? `${customer.customerFirstName || ""} ${customer.customerLastName || ""}`.trim() || "N/A"
        : "N/A";
      const clientPhone = customer?.customerMobileNum || customer?.customerCompanyPhoneNumebr || "N/A";

      // Driver name
      const driver      = driverId ? driverList.find((d) => d.id === driverId) : null;
      const driverName  = driver
        ? `${driver.driverFirstName || ""} ${driver.driverLastName || ""}`.trim()
        : "TBD";

      // Return pickup/drop-off are treated as a separate trip and intentionally
      // omitted from this template.
      const passengers = sale?.numberOfPassengers ? String(sale.numberOfPassengers) : "N/A";
      return (
        `New Trip Assigned\n\n` +
        `Date: ${tripDate}\n` +
        `Pickup Time: ${pickupTime}\n` +
        `Drop-off Time: ${dropoffTime}\n\n` +
        `Pickup: ${pickupAddr}\n` +
        `Drop-off: ${dropAddr}\n\n` +
        `Client: ${clientName}\n` +
        `Passengers: ${passengers}\n\n` +
        `Please arrive 10 mins before pickup time.`
      );
    };

    const handleSidebarAssignDriver = async () => {
      if (!sidebarDriverId) return;
      if (sidebarSmsEnabled && !sidebarSmsText.trim()) {
        showErrorMessage("SMS message cannot be empty. Disable SMS or enter a message.");
        return;
      }
      setSidebarAssigning(true);
      try {
        const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };
        await axios.post(`${API_URL}/assign-driver`, {
          QuoteId: QuoteId,
          drivers: [{ driverId: sidebarDriverId, price: 0, hourPrice: 0 }],
          send_sms:       sidebarSmsEnabled,
          client_message: "",
          driver_message: sidebarSmsEnabled ? sidebarSmsText : "",
        }, { headers });
        invoiceRefetch();
        workOrderRefetch();
        assignDriverHistoryRefetch();
        showMessage(sidebarSmsEnabled ? "Driver assigned & SMS sent." : "Driver assigned successfully.");
      } catch {
        showErrorMessage("Failed to assign driver.");
      } finally {
        setSidebarAssigning(false);
      }
    };

    const handleOpenPriceDialog = (driverId: number) => {
      // Find the selected driver from driverList
      const driverData = driverList.find(driver => driver.id === driverId);
    
      if (!driverData) return; // Ensure it's not undefined
    
      const assignedDrivers = invoiceList.assign_driver?.assign_to
      ? JSON.parse(invoiceList.assign_driver.assign_to)
      : [];

      const driverAssignment = assignedDrivers.find((d: any) => d.driverId === driverId);
      // Set the selected driver details
      setSelectedDriverId(driverData.id);

      if (driverAssignment) {
        setTripPrice(driverAssignment.price?.toString() || ""); // Ensure it's a string
        setHourPrice(driverAssignment.hourPrice?.toString() || ""); // Ensure it's a string
      } else {
        setTripPrice(tripPrice.toString());
        setHourPrice(hourPrice.toString());
      }
    
    
      const fullName = `${driverData.driverFirstName} ${driverData.driverLastName}`;
      setSelectedDriverName(fullName);
      // Open the price dialog
      setIsPriceDialogOpen(true);
    };
    
    

    const handleSavePrice = async () => {

       try {
        const headers = {
            Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        };
  
        const updatePayload = {
          driverId: selectedDriverId,
          price: parseFloat(tripPrice),
          hourPrice: parseFloat(hourPrice),
          QuoteId: QuoteId,
      };

      
         const response = await axios.post(`${API_URL}/update-driver-price`, updatePayload, { headers });
         
         invoiceRefetch();
         showMessage("Price saved successfully");
         handleClosePriceDialog();

    } catch (error) {
        console.error("Error assigning price:", error);
       showErrorMessage("Failed to assign price.");
    }
    
      }
  

    const handleClosePriceDialog = () => {
      setIsPriceDialogOpen(false);
      setSelectedDriverId(null);
      setTripPrice('');
      setHourPrice('');
    };


    const handleClosePoNumberDialog = () => {
      setIsPoNumberDialogOpen(false);
      setPoNumber("");
      setPoDocumentFile(null);
    };
    

  const isLoading =
    workIsLoading || updateIsLoading || workOrderHistoryIsLoading;

  useEffect(() => {
    if (!updateIsLoading) {
      workOrderRefetch();
    }
  }, [updateIsLoading, workOrderRefetch]);

  // After conversion query finishes loading, navigate to invoice detail page
  useEffect(() => {
    if (justConvertedRef.current && !updateIsLoading && id) {
      justConvertedRef.current = false;
      navigate(`/work-order/history/${QuoteId}`);
    }
  }, [updateIsLoading, id, updateData]);

  useEffect(() => {
    if (!workOrderHistoryIsLoading) {
      workOrderHistoryRefetch();
    }
  }, [workOrderHistoryIsLoading, workOrderHistoryRefetch]);

  useEffect(() => {
  
//console.log(invoiceList)
  }, [invoiceList]);

  

  const discountList = Array.isArray(
    WorkOrderDataList?.quoteWorkOrderSaleDiscountDescription
  )
    ? WorkOrderDataList!.quoteWorkOrderSaleDiscountDescription
    : [];

    const invoiceDiscountList = Array.isArray(
      invoiceList?.quoteWorkOrderSaleDiscountDescription
    )
      ? invoiceList!.quoteWorkOrderSaleDiscountDescription
      : [];

    // const invoiceDiscountList = invoiceList.flatMap((history) =>
    //   Array.isArray(history.quoteWorkOrderSaleDiscountDescription)
    //     ? history.quoteWorkOrderSaleDiscountDescription
    //     : []
    // );

    const handleShowMore = () => {
      setShowAllDrivers(!showAllDrivers);
    };
    

  if (isLoading || workIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  const convertPlainTextToHTML= (text: string) => {
    return text
      .replace(/\n/g, '<br>') // Replace line breaks with <br>
      .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length)); // Replace multiple spaces with &nbsp;
  }

  const handleAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEditableAmount(event.target.value);
  };

  const handleSendPaymentLink = () => {
    const paymentTemplate = emailTemplateList.find(
      (template) => template.template_name === "Payment Link"
    );
    setInvoiceEmailData({
      to: WorkOrderDataList?.customer?.customerEmail || "",
      template: paymentTemplate?.id?.toString() || "",
      subject: paymentTemplate?.subject || "Payment Link",
      message: paymentTemplate?.message || "",
    });
    setShowEmailDialog(true);
  };

  const handleOpenDriverDialog = (driver: any) => {
   
    setDriverEmailData({
      ...driverEmailData,
      to: driver.driverEmail || "", // Set the driver's email in the "To" field
    });
    handleReSendDriverEmail(driver);
   //setShowDriverEmailDialog(true); // Close the dialog after submission
  // setInvoiceEmailData({ ...invoiceEmailData, to: WorkOrderDataList?.customer.customerEmail });
 };



  const handleReSendPaymentLink = () => {


    const paymentTemplate = emailTemplateList.find(
      (template) => template.template_name === "Payment Link"
    );
  
    setInvoiceEmailData({
      to: WorkOrderDataList?.customer.customerEmail || "",
      template: paymentTemplate?.id?.toString() || "", // Set the Payment template ID
      subject: paymentTemplate?.subject || "Payment Reminder", // Use template subject or fallback
      message: paymentTemplate?.message || "Please find the payment details attached.", // Use template message or fallback
    });
  
    setShowEmailDialog(true); // Close the dialog after submission
   // setInvoiceEmailData({ ...invoiceEmailData, to: WorkOrderDataList?.customer.customerEmail });
  };

  const handleEmailDialogClose = () => setShowEmailDialog(false);

  const handleDriverEmailDialogClose = () => setShowDriverEmailDialog(false);

  const handleDriverDialogClose = () => setShowDriverDialog(false);

  const handlePaymentDialogClose = () => setShowPaymentDialog(false);

  const handleSendDriverEmail = async () => {
    setLoading(true);
  
    try {

      const selectedTemplate = emailTemplateList.find(
        (template) => template.template_name === "Trip Assignment"
      );
      if (!selectedTemplate) {
        throw new Error("Template 'Trip Assignment' not found");
    }
 // Gather data from invoiceCoursings and invoiceList
 let busType = "";
 let transferType = ""; // Leave empty to fetch dynamically from data
 let transferFrom = ""; // Leave empty to fetch dynamically from data
 let transferTo = ""; // Leave empty to fetch dynamically from data
 let departureAddress = ""; // Leave empty to fetch dynamically from data
 let departureDate = ""; // Leave empty to fetch dynamically from data
 let destinationAddress = ""; // Leave empty to fetch dynamically from data
 let destinationDate = ""; // Leave empty to fetch dynamically from data

 // Iterate through each product in invoiceCoursings
 invoiceCoursings.forEach((product: any) => {
     busType = product.productName || "Bus";
     transferType = product.transferType
     ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
         .find((key) => TransferType[key] === String(product.transferType)) ?? "Default Transfer Type"
     : "Default Transfer Type"; // Dynamically set transferType


 // Use a default transferType if none was found

     transferFrom = product.transferTypeFrom || transferFrom; // Dynamically set transferFrom
     transferTo = product.transferTypeTo || transferTo; // Dynamically set transferTo
     departureAddress = product.departureAddress || departureAddress; // Dynamically set departureAddress
     departureDate = formatDateTime(product.departureDateTime, "DD-MMM-YY hh:mm A") || departureDate; // Dynamically set departureDate
     destinationAddress = product.destinationAddress || destinationAddress; // Dynamically set destinationAddress
     destinationDate = formatDateTime(product.returnDateTime, "DD-MMM-YY hh:mm A") || destinationDate; // Dynamically set destinationDate
     destinationDate = product.returnDateTime
     ? dayjs(product.returnDateTime).isValid()
       ? dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")
       : ""
     : "";
   

  });

 const driverDetails = selectedDrivers
  .map((driverId) => {
    const driver = driverList?.find((driver) => driver.id === driverId.id);
    return driver
      ? {
          email: driver.driverEmail,
          firstName: driver.driverFirstName || "Driver",
          lastName: driver.driverLastName || "",
        }
      : null;
  })
  .filter((driver): driver is { email: string; firstName: string; lastName: string } => driver !== null); // Type assertion to let TS know the array contains only valid drivers

  const driverEmails = driverDetails.map((driver) => driver.email);  // Array of individual driver emails


 // Prepare the data object for template replacement
 for (let driver of driverDetails) {
  // Prepare email data with the individual driver's first name
  const data = {
    driverFirstName: driver.firstName, // Assign first name of the current driver
    busType,
    transferType,
    transferFrom,
    transferTo,
    departureAddress,
    departureDate,
    destinationAddress,
    destinationDate,
  };

 // Replace placeholders in the selected template
 const emailMessage = selectedTemplate?.message
     ? replaceTemplatePlaceholders(selectedTemplate.message, data)
     : "";


  

        const emailData = {
    customer_id: WorkOrderDataList ? parseInt(WorkOrderDataList.quoteWorkOrderCustomerId, 10) : 0,
    workOrderNo: WorkOrderDataList ? WorkOrderDataList.quoteWorkOrderNo : "",
    subject: selectedTemplate?.subject || "Trip Assignment",
    message: convertPlainTextToHTML(emailMessage), // Ensure message is in HTML format
};
 
       
const formData = new FormData();
formData.append("customer_id", emailData.customer_id.toString());
formData.append("workOrderNo", emailData.workOrderNo);
formData.append("to", driver.email);
formData.append("subject", emailData.subject);
formData.append("message", emailData.message);

  const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  };

  try {
    const emailResponse = await axios.post(`${API_URL}/send-email`, formData, { headers });

    if (emailResponse.status === 200) {
        // Email sent successfully
        console.log("Email sent successfully");
        fetchEmailLogs();
    } else {
        // Error response from the server
        console.error("Failed to send email");
        showErrorMessage(`Failed to send email`);
    }
} catch (error) {
    console.error("Error during email sending:", error);
    showErrorMessage(`Failed to send email `);
}
}

setDriverEmailData({ ...driverEmailData, subject: "", message: "" });

           
} catch (error) {
  console.error("Error during email handling:", error);
  showErrorMessage("Failed to send emails");
} finally {
  handleEmailDialogClose();
  setLoading(false);
}
};

const replaceTemplatePlaceholders = (template: string, data: any) => {
  let result = template
    .replace("[driver_name]", data.driverFirstName)
    .replace("[bus_type]", data.busType)
    .replace("[transfer_type]", data.transferType)
    .replace("[transfer_from]", data.transferFrom)
    .replace("[transfer_to]", data.transferTo)
    .replace("[departure_address]", data.departureAddress)
    .replace("[departure_date]", data.departureDate)
    .replace("[destination_address]", data.destinationAddress);

  // Only replace [destination_date] if it exists
  result = data.destinationDate
    ? result.replace("[destination_date]", data.destinationDate)
    : result.replace("([destination_date])", ""); // Remove () when no return date

  return result;
};


const handleReSendDriverEmail = async (driver: any) => {
 // setLoading(true);
  setLoadingStates((prev) => ({ ...prev, [driver.id]: true }));

  try {
    // Ensure a template is selected
    const selectedTemplate = emailTemplateList.find(
      (template) => template.id === Number(driverEmailData.template)
    );

    if (!selectedTemplate) {
      throw new Error("Please select an email template.");
    }

    // Gather details for email
    let busType = "";
    let transferType = "";
    let transferFrom = "";
    let transferTo = "";
    let departureAddress = "";
    let departureDate = "";
    let destinationAddress = "";
    let destinationDate = "";

    invoiceCoursings.forEach((product: any) => {
      busType = product.productName || "Bus";
      transferType = product.transferType
        ? (Object.keys(TransferType) as (keyof typeof TransferType)[]).find(
            (key) => TransferType[key] === String(product.transferType)
          ) ?? "Default Transfer Type"
        : "Default Transfer Type";

      transferFrom = product.transferTypeFrom || transferFrom;
      transferTo = product.transferTypeTo || transferTo;
      departureAddress = product.departureAddress || departureAddress;
      departureDate = product.departureDateTime
        ? dayjs(product.departureDateTime).format("DD-MMM-YY hh:mm A")
        : departureDate;
      destinationAddress = product.destinationAddress || destinationAddress;
      destinationDate = product.returnDateTime
        ? dayjs(product.returnDateTime).isValid()
          ? dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")
          : ""
        : destinationDate;
    });

    const driverDetails = {
      email: driver.driverEmail,
      firstName: driver.driverFirstName || "Driver",
      lastName: driver.driverLastName || "",
    };

    if (!driverDetails.email) {
      throw new Error("Driver email is missing.");
    }

    const data = {
      driverFirstName: driverDetails.firstName,
      busType,
      transferType,
      transferFrom,
      transferTo,
      departureAddress,
      departureDate,
      destinationAddress,
      destinationDate,
    };

    const emailMessage = replaceTemplatePlaceholders(selectedTemplate.message, data) || "";
    const emailData = {
      customer_id: WorkOrderDataList ? parseInt(WorkOrderDataList.quoteWorkOrderCustomerId, 10) : 0,
      workOrderNo: WorkOrderDataList ? WorkOrderDataList.quoteWorkOrderNo : "",
      subject: driverEmailData.subject || selectedTemplate.subject,
      message: convertPlainTextToHTML(emailMessage),
    };

    const formData = new FormData();
    formData.append("customer_id", emailData.customer_id.toString());
    formData.append("workOrderNo", emailData.workOrderNo);
    formData.append("to", driverDetails.email);
    formData.append("subject", emailData.subject);
    formData.append("message", emailData.message);

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    };

    try {
      const emailResponse = await axios.post(`${API_URL}/send-email`, formData, { headers });

      if (emailResponse.status === 200) {
        showMessage(`Email sent successfully`)
        console.log(`Email sent successfully to ${driverDetails.email}`);
      } else {
        console.error(`Failed to send email to ${driverDetails.email}`);
      }
    } catch (error) {
      console.error(`Error sending email to ${driverDetails.email}:`, error);
    }

    fetchEmailLogs();
  } catch (error) {
    console.error("Error during email sending:", error);

    if (error instanceof Error) {
      showErrorMessage(error.message);
    } else {
      showErrorMessage("Failed to send email.");
    }
  } finally {
    //setLoading(false);
    setLoadingStates((prev) => ({ ...prev, [driver.id]: false })); // Reset loading
    handleDriverEmailDialogClose();
  }
};

const handleOpenViewQuote = (transactionId: string) => {
  setWorkOrderId(transactionId);
  setOpenViewQuote(true);
};

const handleCloseViewQuote = () => {
  setOpenViewQuote(false);
  setWorkOrderId("");
};

const handleOpenViewInvoice = (transactionId: string) => {
  setWorkOrderId(transactionId);
  setOpenViewInvoice(true);
};

const handleCloseViewInvoice = () => {
  setOpenViewInvoice(false);
  setWorkOrderId("");
};


const handleAddPoNumber = (invoiceNo: string) => {
  // Block when invoice/work order is terminated/cancelled
  if (WorkOrderDataList?.quoteWorkOrderStatus === WorkOrderStatus.Cancel) {
    showErrorMessage("Cannot edit PO Number on a terminated invoice.");
    return;
  }
  // Prefill with the current PO so the dialog acts as add OR edit
  const existingPo =
    invoiceList?.po_number ||
    (WorkOrderDataList as any)?.po_number ||
    "";
  setPoNumber(existingPo ? String(existingPo) : "");
  setIsPoNumberDialogOpen(true);
};


const updateInvoicePoNumber = async (poNumber: string) => {
  // Validate: non-empty
  const trimmedPo = String(poNumber || "").trim();
  if (!trimmedPo) {
    showErrorMessage("PO Number cannot be empty.");
    return;
  }
  // Block when terminated
  if (WorkOrderDataList?.quoteWorkOrderStatus === WorkOrderStatus.Cancel) {
    showErrorMessage("Cannot edit PO Number on a terminated invoice.");
    return;
  }
  setLoading(true);
  try {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    };

    const formData = new FormData();
    formData.append("workOrderNo", WorkOrderDataList?.quoteWorkOrderNo || "");
    formData.append("po_number", trimmedPo);
    if (poDocumentFile) {
      formData.append("po_document", poDocumentFile);
    }

    const response = await axios.post(`${API_URL}/update-po-number`, formData, { headers });
    const updatedInvoice = response?.data?.data;
    // eslint-disable-next-line no-console
    console.log("UPDATED DATA:", response?.data);
    // eslint-disable-next-line no-console
    console.log("INVOICE VALUES:", {
      paid:  updatedInvoice?.amount_paid,
      total: updatedInvoice?.quoteWorkOrderSaleGrandTotal,
      due:   updatedInvoice?.due_amount,
      po:    updatedInvoice?.po_number,
    });

    showMessage("PO Number added successfully!");

    // ── Optimistic local sync so the CTA flips to "Paid (PO)" instantly ───
    if (updatedInvoice) {
      const paid = Number(updatedInvoice.amount_paid ?? 0);
      const due  = Number(updatedInvoice.due_amount ?? 0);
      setAmountPaid(paid);
      setDueAmount(due);
    } else {
      const grandTotalNum = parseFloat(
        String(invoiceList?.quoteWorkOrderSaleGrandTotal || "0")
      );
      if (grandTotalNum > 0 && (amountPaid ?? 0) <= 0) {
        setAmountPaid(grandTotalNum);
        setDueAmount(0);
      }
    }

    // ── Force refetch every cache that drives the CTA ─────────────────────
    await Promise.all([
      invoiceRefetch(),
      workOrderRefetch(),
      workOrderHistoryRefetch(),
    ]);
    fetchPayments();
  } catch (error) {
    showErrorMessage("Failed to update PO Number.");
  }
  handleClosePoNumberDialog();
  setLoading(false);
};




  const handleSendEmail = async () => {
    setLoading(true);
  
    try {
        

      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };

        const customerFirstName =  WorkOrderDataList?.customer.customerFirstName || "Customer";
      
   const paymentFormData = new FormData();
      paymentFormData.append("invoice_id",  String(WorkOrderDataList?.invoiceId));
      paymentFormData.append("customer_id", String(WorkOrderDataList?.quoteWorkOrderCustomerId));
      paymentFormData.append("requested_amt", editableAmount);
      paymentFormData.append( "total_due", parseFloat(WorkOrderDataList?.quoteWorkOrderSaleGrandTotal ?? "0").toFixed(2),
      );


      const response = await axios.post(`${API_URL}/generate-payment-link`, paymentFormData, { headers });
  
      const paymentId = response.data.payment_link?.payment_id;
  
      if (!paymentId) throw new Error("Payment ID not returned.");
  
      const paymentLink = paymentId ? `${paymentUrl}/${paymentId}` 
      : "No payment link available.";

      
        // const paymentLink = WorkOrderDataList?.payment_id
        //       ? `${paymentUrl}/${WorkOrderDataList.payment_id}`
        //       : "No payment link available.";

      
              const updatedMessage = invoiceEmailData.message
              ? invoiceEmailData.message
                  .replace(/\[customer_name\]/g, customerFirstName)
                  .replace(/\[payment_link\]/g, paymentLink)
                  .replace(/\[amount\]/g, editableAmount)
                  .replace(/\[total_due\]/g, (parseFloat(WorkOrderDataList?.quoteWorkOrderSaleGrandTotal ?? "0") - (amountPaid ?? 0)).toFixed(2))
              : ''; // Fallback to empty string if message is undefined

        const bodyHtml = convertPlainTextToHTML(updatedMessage);

        const emailData = {
            customer_id: WorkOrderDataList ? parseInt(WorkOrderDataList.quoteWorkOrderCustomerId, 10) : 0,
            workOrderNo: WorkOrderDataList ? WorkOrderDataList.quoteWorkOrderNo : "",
            amount: editableAmount,
            to: invoiceEmailData.to,
            subject: invoiceEmailData.subject,
            message: bodyHtml,
        };
 

        // Create FormData object
        const formData = new FormData();
        formData.append("customer_id", emailData.customer_id.toString());
        formData.append("workOrderNo", emailData.workOrderNo);
        formData.append("amount", emailData.amount.toString());
        formData.append("to", emailData.to);
        formData.append("subject", emailData.subject);
        formData.append("message", emailData.message);

        // Attach invoice PDF — prefer the saved file from disk (correct logo + layout)
        const invoiceNo = derivedInvoiceNo || WorkOrderDataList?.quoteWorkOrderNo || "invoice";
        let attachedPdf = false;
        const invoiceId = WorkOrderDataList?.invoiceId;
        if (invoiceId) {
          try {
            const savedPdfResponse = await axios.get(`${API_URL}/invoices/${invoiceId}/pdf-saved`, {
              responseType: "blob",
              headers: { Authorization: headers.Authorization },
            });
            if (savedPdfResponse.data) {
              formData.append("attachments[]", new File([savedPdfResponse.data], `${invoiceNo}.pdf`, { type: "application/pdf" }));
              attachedPdf = true;
            }
          } catch (pdfErr) {
            console.warn("Could not fetch saved invoice PDF, falling back to html2canvas:", pdfErr);
          }
        }
        if (!attachedPdf) {
          const invoicePdfBlob = await viewWorkOrderRef.current?.generatePdfBlob();
          if (invoicePdfBlob) {
            formData.append("attachments[]", new File([invoicePdfBlob], `${invoiceNo}.pdf`, { type: "application/pdf" }));
          }
        }

        const emailResponse = await axios.post(`${API_URL}/send-email`, formData, { headers });

        if (emailResponse) {
        
            showMessage("Email sent successfully");
            fetchEmailLogs(); 
         //   await refetchActivityHistory();
          //  setInvoiceEmailData({ ...invoiceEmailData, subject: "", message: "" });
           
        } else {
            showErrorMessage("Failed to send email");
        }
    } catch (error) {
        console.error("Error during email sending:", error);
        showErrorMessage("Failed to send email");
    } finally {
        handleEmailDialogClose();
        setLoading(false);
    }
};

const handleSavePayment = async () => {

if (!paymentData.paymentMethod) {
  setShowPaymentMethodError(true);
  return;
}

  // Hard guard against overpayment / duplicate submission when fully paid
  const totalAmt = Number((WorkOrderDataList as any)?.quoteWorkOrderSaleGrandTotal || 0);
  const paidAmt  = Number((WorkOrderDataList as any)?.amount_paid || amountPaid || 0);
  const dueAmt   = Number((WorkOrderDataList as any)?.due_amount ?? dueAmount ?? (totalAmt - paidAmt));
  const status   = String((WorkOrderDataList as any)?.paymentStatus || "").toLowerCase();
  if (dueAmt <= 0 || status === "paid" || (totalAmt > 0 && paidAmt >= totalAmt)) {
    showMessage("This invoice is already fully paid.");
    setShowPaymentDialog(false);
    return;
  }
  // Block over-payment that would push amountPaid past grandTotal
  if (totalAmt > 0 && paidAmt + Number(paymentData.amount || 0) > totalAmt) {
    showErrorMessage(`Payment exceeds remaining balance ($${dueAmt.toFixed(2)}).`);
    return;
  }

  setLoading(true);


setShowPaymentMethodError(false);


  try {
    const formData = new FormData();
    formData.append("work_order_id", QuoteId || "defaultQuoteId");
    if (WorkOrderDataList?.invoiceId) {
      formData.append("invoice_id", String(WorkOrderDataList.invoiceId));
    }
    formData.append("customer_id", String(WorkOrderDataList?.quoteWorkOrderCustomerId || ""));
    formData.append("amount", paymentData.amount);
    formData.append("paymentDate", paymentData.paymentDate);
    formData.append("paymentMethod", paymentData.paymentMethod);
    formData.append("description", paymentData.description);
    formData.append("payment_mode", 'OFFLINE'); // Add payment mode as Offline
    if (paymentData.file) {
      formData.append("file", paymentData.file);
    }

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    };

    // Send the formData to the backend
    const paymentResponse = await axios.post(`${API_URL}/save-payment`, formData, { headers });

    if (paymentResponse && paymentResponse.data) {
      showMessage("Payment saved successfully");
      // Immediately update local amounts so further submissions are blocked even before refetch
      const newPaid = paidAmt + Number(paymentData.amount || 0);
      setAmountPaid(newPaid);
      setDueAmount(Math.max(0, totalAmt - newPaid));
      fetchPayments();
      setTimeout(() => {
        invoiceRefetch();
        workOrderRefetch();
        workOrderHistoryRefetch();
      }, 1000);
   //  await invoiceRefetch();
      setPaymentData({ paymentDate: getCurrentDateCanada(),amount: "", paymentMethod: "", description: "", file: null });
    } else {
      showErrorMessage("Failed to process payment");
    }
  } catch (error) {
    console.error("Error during payment saving", error);
    showErrorMessage("Failed to process payment");
  } finally {
    handlePaymentDialogClose();
    setLoading(false);
  }
};

const uploadPaymentProof = async (paymentId: number, file: File) => {
  if (file.type !== "application/pdf" && !file.name.toLowerCase().endsWith(".pdf")) {
    showErrorMessage("Only PDF files are allowed");
    return;
  }
  if (file.size > 5 * 1024 * 1024) {
    showErrorMessage("File size must be under 5 MB");
    return;
  }
  setProofUploading((prev) => new Set(prev).add(paymentId));
  try {
    const formData = new FormData();
    formData.append("proof", file);
    const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };
    await axios.post(`${API_URL}/payments/${paymentId}/upload-proof`, formData, { headers });
    showMessage("Proof uploaded successfully");
    fetchPayments();
  } catch {
    showErrorMessage("Failed to upload proof");
  } finally {
    setProofUploading((prev) => { const s = new Set(prev); s.delete(paymentId); return s; });
  }
};

const updateInvoiceAmount = async (amount: number) => {
  try {
      const headers = {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };

      const updatePayload = {
          workOrderNo: WorkOrderDataList?.quoteWorkOrderNo,
          amount: amount,
          invoice_id: WorkOrderDataList?.id,
          customer_id: WorkOrderDataList?.quoteWorkOrderCustomerId,
          total_due: WorkOrderDataList?.quoteWorkOrderSaleGrandTotal,
          payment_id: WorkOrderDataList?.payment_id,
      };

      await axios.put(`${API_URL}/`, updatePayload, { headers });

    //  showMessage("Invoice amount updated successfully.");
  } catch (error) {
      console.error("Error updating invoice amounupdate-invoice-amountt:", error);
    //  showErrorMessage("Failed to update invoice amount.");
  }
};




const handlePaymentPopup = () => {
  // Block opening the payment dialog when nothing is owed / already paid
  const totalAmt = Number((WorkOrderDataList as any)?.quoteWorkOrderSaleGrandTotal || 0);
  const paidAmt  = Number((WorkOrderDataList as any)?.amount_paid || amountPaid || 0);
  const dueAmt   = Number((WorkOrderDataList as any)?.due_amount ?? dueAmount ?? (totalAmt - paidAmt));
  const status   = String((WorkOrderDataList as any)?.paymentStatus || "").toLowerCase();
  if (dueAmt <= 0 || status === "paid" || (totalAmt > 0 && paidAmt >= totalAmt)) {
    showMessage?.("This invoice is already fully paid.");
    return;
  }
  setShowPaymentDialog(true);
};

// const handleEmailCheck = async() => {
//   const response = await axios.post(`${API_URL}/trigger-email`);
//   console.log(response)
// };

  return (
    <div>
      {isLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Grid container spacing={3}>
            {/* TOP HEADER CARD */}
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card sx={{ bgcolor: "#ffffff", borderRadius: 3, overflow: "hidden", boxShadow: "0 2px 16px rgba(0,0,0,0.10)", border: "1px solid #e2e8f0", position: "relative" }}>

                {/* Top accent bar */}
                <Box sx={{ height: 4, background: "linear-gradient(90deg, #f59e0b 0%, #ef4444 50%, #2f3891 100%)" }} />

                {/* ── Header ── */}
                <Box sx={{ px: 3, pt: 2.5, pb: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>

                    {/* Left: WO number + status */}
                    <Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1, flexWrap: "wrap" }}>
                        <Typography sx={{ color: "#0f172a", fontWeight: 800, fontSize: 22, letterSpacing: "-0.3px", lineHeight: 1 }}>
                          {derivedInvoiceNo || WorkOrderDataList?.quoteWorkOrderNo || ""}
                        </Typography>
                        {derivedInvoiceNo && (
                          <>
                            <Box sx={{ width: 1, height: 18, bgcolor: "#e2e8f0" }} />
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, bgcolor: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 1.5, px: 1, py: 0.25, flexWrap: "nowrap" }}>
                              <Typography sx={{ color: "#64748b", fontWeight: 600, fontSize: 10, letterSpacing: 0.5, whiteSpace: "nowrap" }}>WO#</Typography>
                              <Typography sx={{ color: "#475569", fontWeight: 700, fontSize: 13, whiteSpace: "nowrap" }}>{WorkOrderDataList?.quoteWorkOrderNo}</Typography>
                            </Box>
                            {(() => {
                              const isCancelled = WorkOrderDataList?.quoteWorkOrderStatus === WorkOrderStatus.Cancel;
                              const currentPo = invoiceList?.po_number || WorkOrderDataList?.po_number;
                              if (currentPo) {
                                return (
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                    <Chip label={`PO: ${currentPo}`} size="small" sx={{ bgcolor: "#f1f5f9", color: "#475569", fontWeight: 600, fontSize: 10, border: "1px solid #e2e8f0", height: 20 }} />
                                    {(invoiceList?.po_document || WorkOrderDataList?.po_document) && (
                                      <Tooltip title="View PO Document">
                                        <IconButton
                                          size="small"
                                          component="a"
                                          href={`${LARAVEL_API_URL}/${invoiceList?.po_document || WorkOrderDataList?.po_document}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          sx={{ p: 0.25, color: "#2f3891" }}
                                        >
                                          <DescriptionIcon sx={{ fontSize: 14 }} />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    {!isCancelled && (
                                      <Tooltip title="Edit PO Number">
                                        <IconButton
                                          size="small"
                                          onClick={() => handleAddPoNumber(derivedInvoiceNo!)}
                                          sx={{ p: 0.25, color: "#2f3891" }}
                                        >
                                          <FaEdit style={{ fontSize: 12 }} />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </Box>
                                );
                              }
                              if (isCancelled) return null;
                              return (
                                <Chip label="+ Add PO Number" size="small" onClick={() => handleAddPoNumber(derivedInvoiceNo!)} sx={{ bgcolor: "#fff7ed", color: "#c2410c", fontWeight: 600, fontSize: 10, border: "1px solid #fed7aa", height: 20, cursor: "pointer" }} />
                              );
                            })()}
                          </>
                        )}
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                        {(() => {
                          const rawStatus = invoiceList?.quoteWorkOrderStatus ?? WorkOrderDataList?.quoteWorkOrderStatus;
                          const hasInv    = !!(WorkOrderDataList?.invoiceId || invoiceList);
                          const paid      = dueAmount === 0 && amountPaid > 0;
                          const ds        = getDerivedStatus(rawStatus, hasInv, paid);
                          return (
                            <Chip
                              label={ds.label}
                              size="small"
                              sx={{
                                fontWeight: 700, fontSize: 10, height: 22, px: 0.5,
                                color: ds.color,
                                backgroundColor: ds.bg,
                                border: `1px solid ${ds.color}44`,
                              }}
                            />
                          );
                        })()}
                        <Typography sx={{ color: "#94a3b8", fontSize: 11 }}>
                          {WorkOrderDataList?.created_at ? dayjs(WorkOrderDataList.created_at).format("MMM D, YYYY · h:mm A") : ""}
                        </Typography>
                      </Box>

                      {/* Workflow pipeline badge */}
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 1 }}>
                        {[
                          { label: "Quote",   step: 0, color: "#2f3891", bg: "#ede9fe" },
                          { label: "Invoice", step: 1, color: "#d97706", bg: "#fef3c7" },
                          { label: "Paid",    step: 2, color: "#16a34a", bg: "#dcfce7" },
                        ].map((s, i) => {
                          const isPaidPipeline = dueAmount === 0 && amountPaid > 0;
                          const currentStep = isPaidPipeline ? 2
                            : WorkOrderDataList?.isInvoice ? 1
                            : 0;
                          const active = i === currentStep;
                          return (
                            <React.Fragment key={s.label}>
                              <Box sx={{
                                fontSize: "0.62rem", fontWeight: active ? 700 : 500,
                                color: active ? s.color : "#cbd5e1",
                                backgroundColor: active ? s.bg : "transparent",
                                borderRadius: "20px", px: active ? 1.25 : 0.5, py: "2px",
                                border: active ? `1px solid ${s.color}40` : "none",
                                lineHeight: 1.6,
                              }}>{s.label}</Box>
                              {i < 2 && <Box component="span" sx={{ color: "#e2e8f0", fontSize: "0.6rem" }}>▶</Box>}
                            </React.Fragment>
                          );
                        })}
                      </Box>

                      {/* Issued By company badge */}
                      {WorkOrderDataList?.company?.companyName && (() => {
                        const name: string = WorkOrderDataList.company.companyName;
                        const isBusLines = name.toLowerCase().includes("bus line");
                        return (
                          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, mt: 1 }}>
                            <Typography sx={{ fontSize: "0.68rem", color: "#94a3b8", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                              Issued by
                            </Typography>
                            <Box sx={{
                              display: "inline-flex", alignItems: "center",
                              px: 1.25, py: 0.4, borderRadius: "6px",
                              fontSize: "0.75rem", fontWeight: 700, letterSpacing: "0.02em",
                              bgcolor: isBusLines ? "#dbeafe" : "#dcfce7",
                              color: isBusLines ? "#1e40af" : "#15803d",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                            }}>
                              {name}
                            </Box>
                          </Box>
                        );
                      })()}
                    </Box>

                    {/* Right: action buttons */}
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}>
                      {/* Print */}
                      <ReactToPrint
                        trigger={() => (
                          <Button variant="outlined" size="small" startIcon={<LocalPrintshopOutlinedIcon sx={{ fontSize: 13 }} />}
                            sx={{ borderColor: "#e2e8f0", color: "#0f172a", textTransform: "none", fontWeight: 600, fontSize: 12, borderRadius: 1.5, "&:hover": { borderColor: "#cbd5e1", bgcolor: "#f8fafc" } }}>
                            Print
                          </Button>
                        )}
                        content={() => viewWorkOrderRef.current?.getContentElement() ?? null}
                        // When an invoice exists, the saved PDF must be named by the invoice number ("TJT…"),
                        // never the work-order number ("WO…").
                        documentTitle={
                          (WorkOrderDataList?.invoiceId
                            ? (derivedInvoiceNo || invoiceList?.InvoiceNo || WorkOrderDataList?.InvoiceNo)
                            : WorkOrderDataList?.quoteWorkOrderNo)
                          || WorkOrderDataList?.quoteWorkOrderNo
                          || "Quote"
                        }
                      />
                      {/* Email */}
                      <Button variant="outlined" size="small" startIcon={<EmailOutlinedIcon sx={{ fontSize: 13 }} />}
                        onClick={handleOpenEmailClient}
                        sx={{ borderColor: "#e2e8f0", color: "#2f3891", textTransform: "none", fontWeight: 600, fontSize: 12, borderRadius: 1.5, "&:hover": { borderColor: "#c4b5fd", bgcolor: "#faf5ff" } }}>
                        Email
                      </Button>
                      {/* Refund — only when there's a paid amount to refund */}
                      {amountPaid > 0 && (
                        <Button variant="outlined" size="small" startIcon={<ReplayIcon sx={{ fontSize: 13 }} />}
                          onClick={() => {
                            setRefundData({ amount: Number(amountPaid).toFixed(2), method: "", reason: "" });
                            setRefundProof(null);
                            setRefundErrors({ amount: false, method: false, reason: false, proof: false });
                            setOpenRefundDialog(true);
                          }}
                          sx={{ borderColor: "#fed7aa", color: "#ea580c", textTransform: "none", fontWeight: 600, fontSize: 12, borderRadius: 1.5, "&:hover": { borderColor: "#fb923c", bgcolor: "#fff7ed" } }}>
                          Refund
                        </Button>
                      )}
                      {/* Refund status badge — shown when refunds exist but no remaining paid amount */}
                      {refunds.length > 0 && amountPaid <= 0 && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, bgcolor: "#fef2f2", border: "1px solid #fecaca", borderRadius: 1.5, px: 1.5, py: 0.5 }}>
                          <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: "#dc2626" }} />
                          <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#dc2626" }}>Refunded</Typography>
                        </Box>
                      )}
                      {/* Partially refunded badge — refunds exist but still some amount paid */}
                      {refunds.length > 0 && amountPaid > 0 && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, bgcolor: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 1.5, px: 1.5, py: 0.5 }}>
                          <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: "#ea580c" }} />
                          <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#ea580c" }}>Partially Refunded</Typography>
                        </Box>
                      )}
                      {/* Terminate — only when not already cancelled */}
                      {WorkOrderDataList?.quoteWorkOrderStatus !== WorkOrderStatus.Cancel && (
                        <Button variant="outlined" size="small" startIcon={<CancelOutlined sx={{ fontSize: 13 }} />}
                          onClick={() => {
                            setTerminateStep(amountPaid > 0 ? "ask" : "terminate");
                            setRefundData({ amount: Number(amountPaid).toFixed(2), method: "", reason: "" });
                            setRefundProof(null);
                            setRefundErrors({ amount: false, method: false, reason: false, proof: false });
                            setTerminateReason(""); setTerminateReasonError(false);
                            setOpenTerminateDialog(true);
                          }}
                          sx={{ borderColor: "#fecaca", color: "#dc2626", textTransform: "none", fontWeight: 600, fontSize: 12, borderRadius: 1.5, "&:hover": { borderColor: "#f87171", bgcolor: "#fef2f2" } }}>
                          Terminate
                        </Button>
                      )}
                      {/* Convert to Invoice — only when NOT yet converted */}
                      {!WorkOrderDataList?.invoiceId && activeStep < 2 && WorkOrderDataList?.quoteWorkOrderStatus !== WorkOrderStatus.Cancel && (
                        <Button variant="contained" size="small" onClick={handleOpenDialog}
                          sx={{ bgcolor: "#2f3891", "&:hover": { bgcolor: "#252e7a" }, borderRadius: 1.5, textTransform: "none", fontWeight: 700, fontSize: 12, px: 2, boxShadow: "none" }}>
                          Convert to Invoice
                        </Button>
                      )}
                      {/* Payment Paid badge — fully paid (requires invoice + actual payment) */}
                      {!!WorkOrderDataList?.invoiceId && dueAmount === 0 && amountPaid > 0 && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 1.5, px: 1.5, py: 0.5 }}>
                          <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: "#16a34a" }} />
                          <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#16a34a" }}>Payment Paid</Typography>
                        </Box>
                      )}
                      {!!WorkOrderDataList?.invoiceId && (
                        <Button variant="outlined" size="small" startIcon={<VisibilitySharpIcon sx={{ fontSize: 13 }} />}
                          onClick={() => handleOpenViewInvoice(String(WorkOrderDataList?.id))}
                          sx={{ borderColor: "#e2e8f0", color: "#64748b", textTransform: "none", fontWeight: 600, fontSize: 12, borderRadius: 1.5, "&:hover": { borderColor: "#cbd5e1", bgcolor: "#f8fafc" } }}>
                          Invoice{derivedInvoiceNo ? ` · ${derivedInvoiceNo}` : ""}
                        </Button>
                      )}
                      <Box sx={{ width: 1, height: 24, bgcolor: "#e2e8f0" }} />
                      <IconButton size="small" component={Link}
                        to={`/quote-history/${WorkOrderDataList?.id}`}
                        sx={{ color: "#94a3b8", border: "1px solid #e2e8f0", borderRadius: 1.5, width: 32, height: 32, "&:hover": { color: "#475569", bgcolor: "#f8fafc", borderColor: "#cbd5e1" } }}>
                        <EditSharpIcon sx={{ fontSize: 15 }} />
                      </IconButton>
                    </Box>

                  </Box>
                </Box>

                {/* Divider */}
                <Box sx={{ mx: 3, borderTop: "1px solid #f1f5f9" }} />

                {/* ── Remarks on Invoice + Internal / Office Remarks ── */}
                {((WorkOrderDataList?.quoteWorkOrderCustomerMemo && WorkOrderDataList.quoteWorkOrderCustomerMemo.trim() !== "") ||
                  (WorkOrderDataList?.quoteWorkOrderCustomerRemark && WorkOrderDataList.quoteWorkOrderCustomerRemark.trim() !== "")) && (
                  <Box sx={{ mx: 3, mt: 2, mb: 0.5, display: "flex", flexDirection: "column", gap: 1 }}>
                    {WorkOrderDataList?.quoteWorkOrderCustomerRemark && WorkOrderDataList.quoteWorkOrderCustomerRemark.trim() !== "" && (
                      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25, bgcolor: "#fffbeb", border: "1px solid #fde68a", borderRadius: 2, px: 2, py: 1.25 }}>
                        <Box sx={{ flexShrink: 0, mt: 0.25 }}>
                          <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: "#f59e0b" }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                          <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#92400e", letterSpacing: 0.4, mb: 0.25 }}>
                            SPECIAL NOTIFICATION
                          </Typography>
                          <Typography sx={{ fontSize: 13, color: "#78350f", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                            {WorkOrderDataList.quoteWorkOrderCustomerRemark}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                    {WorkOrderDataList?.quoteWorkOrderCustomerMemo && WorkOrderDataList.quoteWorkOrderCustomerMemo.trim() !== "" && (
                      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25, bgcolor: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 2, px: 2, py: 1.25 }}>
                        <Box sx={{ flexShrink: 0, mt: 0.25 }}>
                          <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: "#2563eb" }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                          <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#1e40af", letterSpacing: 0.4, mb: 0.25 }}>
                            INTERNAL / OFFICE NOTES
                          </Typography>
                          <Typography sx={{ fontSize: 13, color: "#1e3a8a", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                            {WorkOrderDataList.quoteWorkOrderCustomerMemo}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Box>
                )}

                {/* ── Stepper ── */}
                <Box sx={{ px: 3, pt: 2.5, pb: 2, overflowX: "auto" }}>
                  <Stepper activeStep={activeStep} alternativeLabel connector={<CustomStepConnector />}>
                    {steps.map((label, index) => {
                      const isCompleted = activeStep > index;
                      const isActive = activeStep === index;
                      return (
                        <Step key={label}>
                          <CustomStepLabel>
                            <Typography sx={{ fontWeight: isActive ? 700 : 600, fontSize: 12, color: isCompleted ? "#94a3b8" : isActive ? "#0f172a" : "#94a3b8", letterSpacing: 0.4, mt: 0.5 }}>{label}</Typography>
                            {isCompleted && (
                              <Box sx={{ mt: 0.5 }}>
                                {index === 0 && workOrderHistoryData && Array.isArray(workOrderHistoryData.data) && workOrderHistoryData.data.length > 0 && (
                                  <Box sx={{ textAlign: "center" }}>
                                    <Typography sx={{ fontSize: 10, fontWeight: 600, color: "#475569" }}>{workOrderHistoryData.data[0]?.updated_by}</Typography>
                                    <Typography sx={{ fontSize: 9, color: "#94a3b8" }}>{dayjs(workOrderHistoryData.data[0]?.created_at).format("MMM D, YYYY")}</Typography>
                                  </Box>
                                )}
                                {index === 1 && invoiceHistories && Array.isArray(invoiceHistories) && invoiceHistories.length > 0 && (
                                  <Box sx={{ textAlign: "center" }}>
                                    <Typography sx={{ fontSize: 10, fontWeight: 600, color: "#475569" }}>{invoiceHistories[0]?.updated_by}</Typography>
                                    <Typography sx={{ fontSize: 9, color: "#94a3b8" }}>{dayjs(invoiceHistories[0]?.created_at).format("MMM D, YYYY")}</Typography>
                                  </Box>
                                )}
                                {index === 2 && (
                                  <Box sx={{ textAlign: "center" }}>
                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#10b981" }}>${parseFloat(invoiceList?.quoteWorkOrderSaleGrandTotal ?? "0").toFixed(2)}</Typography>
                                    {amountPaid > 0 && (
                                      <Typography sx={{ fontSize: 9, color: "#94a3b8" }}>Paid: ${amountPaid.toFixed(2)}</Typography>
                                    )}
                                  </Box>
                                )}
                              </Box>
                            )}
                            {isActive && (
                              <Typography sx={{ fontSize: 9, color: "#f59e0b", fontWeight: 700, mt: 0.25, letterSpacing: 0.4 }}>IN PROGRESS</Typography>
                            )}
                          </CustomStepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </Box>

                {/* ── Trip Profit Summary ── */}
                {tripProfit && (
                  <Box sx={{ mx: 3, mb: 2.5 }}>
                    <Box sx={{ borderRadius: 2.5, border: "1px solid #e2e8f0", overflow: "hidden", bgcolor: "#fff" }}>
                      {/* Header */}
                      <Box sx={{ px: 2.5, py: 1.5, bgcolor: "#f8fafc", borderBottom: "1px solid #e2e8f0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Trip Profit Summary</Typography>
                        <Box sx={{
                          px: 1.5, py: 0.5, borderRadius: 1.5,
                          bgcolor: tripProfit.profit > 0 ? "rgba(22,163,74,0.1)" : tripProfit.profit < 0 ? "rgba(220,38,38,0.1)" : "rgba(245,158,11,0.1)",
                          display: "flex", alignItems: "center", gap: 0.5,
                        }}>
                          <Typography sx={{
                            fontSize: 13, fontWeight: 800,
                            color: tripProfit.profit > 0 ? "#16a34a" : tripProfit.profit < 0 ? "#dc2626" : "#f59e0b",
                          }}>
                            {tripProfit.profit >= 0 ? "+" : ""}${Math.abs(tripProfit.profit).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </Typography>
                          {tripProfit.profit_margin !== 0 && (
                            <Typography sx={{ fontSize: 10, color: "#94a3b8" }}>({tripProfit.profit_margin}%)</Typography>
                          )}
                        </Box>
                      </Box>
                      {/* 4-metric row — Driver Cost is editable */}
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        {[
                          { key: "revenue",       label: "Revenue",     value: tripProfit.revenue,       color: "#2f3891" },
                          { key: "driver_cost",   label: "Driver Cost", value: tripProfit.driver_cost,   color: "#f59e0b" },
                          { key: "trip_expenses", label: "Expenses",    value: tripProfit.trip_expenses, color: "#ef4444" },
                          { key: "profit",        label: "Net Profit",  value: tripProfit.profit,
                            color: tripProfit.profit >= 0 ? "#16a34a" : "#dc2626", bold: true },
                        ].map((item: any, i: number) => (
                          <Box key={item.key} sx={{
                            flex: "1 1 25%", minWidth: 100,
                            px: 2, py: 1.5, textAlign: "center",
                            borderRight: i < 3 ? "1px solid #f1f5f9" : "none",
                            borderTop: "none",
                          }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
                              <Typography sx={{ fontSize: 10, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 600 }}>
                                {item.label}
                              </Typography>
                              {item.key === "driver_cost" && !editingDriverCost && (
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setDriverCostInput(String(tripProfit.driver_cost ?? 0));
                                    setEditingDriverCost(true);
                                  }}
                                  title="Edit Driver Cost"
                                  sx={{ p: 0.25, color: "#94a3b8", "&:hover": { color: "#2f3891" } }}
                                >
                                  <EditSharpIcon sx={{ fontSize: 12 }} />
                                </IconButton>
                              )}
                            </Box>
                            {item.key === "driver_cost" && editingDriverCost ? (
                              <Box sx={{ mt: 0.5, display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
                                <TextField
                                  size="small"
                                  type="number"
                                  value={driverCostInput}
                                  onChange={(e) => setDriverCostInput(e.target.value)}
                                  inputProps={{ min: 0, step: "0.01", style: { textAlign: "center", fontSize: 13 } }}
                                  sx={{ width: 110 }}
                                  autoFocus
                                />
                                <Box sx={{ display: "flex", gap: 0.5 }}>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    disabled={savingDriverCost}
                                    onClick={async () => {
                                      const amount = Number(driverCostInput);
                                      if (Number.isNaN(amount) || amount < 0) {
                                        showErrorMessage("Enter a valid amount");
                                        return;
                                      }
                                      setSavingDriverCost(true);
                                      try {
                                        const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };
                                        await axios.post(`${API_URL}/driver-payment/set-trip-cost`, {
                                          work_order_id: Number(QuoteId),
                                          total_payment: amount,
                                        }, { headers });
                                        showMessage("Driver cost updated");
                                        setEditingDriverCost(false);
                                        await refetchTripProfit();
                                      } catch (e: any) {
                                        showErrorMessage(e?.response?.data?.message || "Failed to update driver cost");
                                      } finally {
                                        setSavingDriverCost(false);
                                      }
                                    }}
                                    sx={{ textTransform: "none", fontSize: 11, fontWeight: 700, py: 0.25, px: 1, bgcolor: "#2f3891", "&:hover": { bgcolor: "#252d73" } }}
                                  >
                                    {savingDriverCost ? "…" : "Save"}
                                  </Button>
                                  <Button
                                    size="small"
                                    variant="text"
                                    onClick={() => { setEditingDriverCost(false); }}
                                    sx={{ textTransform: "none", fontSize: 11, fontWeight: 600, py: 0.25, px: 1, color: "#64748b" }}
                                  >
                                    Cancel
                                  </Button>
                                </Box>
                              </Box>
                            ) : (
                              <Typography sx={{ fontSize: 15, fontWeight: item.bold ? 800 : 700, color: item.color, mt: 0.25 }}>
                                ${Math.abs(item.value).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </Typography>
                            )}
                          </Box>
                        ))}
                      </Box>

                      {/* ── Driver-wise breakdown ─────────────────────────── */}
                      {Array.isArray(tripProfit.driver_payments) && tripProfit.driver_payments.length > 0 && (
                        <Box sx={{ borderTop: "1px solid #f1f5f9", bgcolor: "#fff" }}>
                          <Box sx={{ px: 2.5, py: 1, bgcolor: "#fffbeb", borderBottom: "1px solid #fef3c7", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#b45309", textTransform: "uppercase", letterSpacing: 0.6 }}>
                              Driver Earnings Breakdown
                            </Typography>
                            <Typography sx={{ fontSize: 11, color: "#92400e" }}>
                              {tripProfit.driver_payments.length} driver{tripProfit.driver_payments.length !== 1 ? "s" : ""}
                            </Typography>
                          </Box>
                          {(() => {
                            // Sanity check: sum of breakdown should equal total Driver Cost.
                            const sum = (tripProfit.driver_payments || []).reduce(
                              (s: number, p: any) => s + (Number(p?.total_payment) || 0), 0
                            );
                            const mismatch = Math.abs(sum - Number(tripProfit.driver_cost || 0)) > 0.01;
                            return mismatch ? (
                              <Box sx={{ px: 2.5, py: 0.75, bgcolor: "#fef2f2", borderBottom: "1px solid #fecaca" }}>
                                <Typography sx={{ fontSize: 10.5, color: "#b91c1c", fontWeight: 600 }}>
                                  ⚠ Breakdown sum (${sum.toFixed(2)}) does not match total (${Number(tripProfit.driver_cost || 0).toFixed(2)}). Re-assign or save the trip to resync.
                                </Typography>
                              </Box>
                            ) : null;
                          })()}
                          {tripProfit.driver_payments.map((p: any, i: number) => {
                            const hours = Number(p?.hours_worked) || 0;
                            const rate  = Number(p?.hourly_rate)  || 0;
                            const amt   = Number(p?.total_payment) || 0;
                            const status = String(p?.status || "pending").toLowerCase();
                            return (
                              <Box
                                key={i}
                                sx={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr auto auto",
                                  gap: 1.5,
                                  px: 2.5,
                                  py: 1.25,
                                  borderBottom: i < tripProfit.driver_payments.length - 1 ? "1px solid #f8fafc" : "none",
                                  alignItems: "center",
                                }}
                              >
                                <Box sx={{ minWidth: 0 }}>
                                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>
                                    {p?.driver_name || "—"}
                                  </Typography>
                                  {(hours > 0 || rate > 0) && (
                                    <Typography sx={{ fontSize: 10.5, color: "#64748b", mt: 0.25 }}>
                                      {hours.toFixed(2)} hr × ${rate.toFixed(2)}/hr
                                    </Typography>
                                  )}
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <Box sx={{
                                    px: 1, py: 0.25, borderRadius: 1,
                                    bgcolor: status === "paid" ? "#dcfce7" : "#fef3c7",
                                    border: `1px solid ${status === "paid" ? "#86efac" : "#fde68a"}`,
                                  }}>
                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: status === "paid" ? "#15803d" : "#b45309", textTransform: "uppercase" }}>
                                      {status === "paid" ? "Paid" : "Pending"}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#f59e0b", textAlign: "right", whiteSpace: "nowrap", minWidth: 80 }}>
                                  ${amt.toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </Typography>
                              </Box>
                            );
                          })}
                        </Box>
                      )}

                      {/* Driver names row */}
                      {(tripProfit.driver_names || tripProfit.linked_expenses?.length > 0) && (
                        <Box sx={{ px: 2.5, py: 1, borderTop: "1px solid #f1f5f9", display: "flex", gap: 2, flexWrap: "wrap" }}>
                          {tripProfit.driver_names && (
                            <Typography sx={{ fontSize: 11, color: "#64748b" }}>
                              <strong>Driver:</strong> {tripProfit.driver_names}
                            </Typography>
                          )}
                          {tripProfit.linked_expenses?.length > 0 && (
                            <Box
                              component="button"
                              onClick={() => setExpensesOpen((v) => !v)}
                              aria-expanded={expensesOpen}
                              sx={{
                                all: "unset",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                fontSize: 11,
                                color: "#2f3891",
                                "&:hover": { textDecoration: "underline" },
                              }}
                            >
                              <Typography component="span" sx={{ fontSize: 11, color: "#64748b" }}>
                                <strong>Trip Expenses:</strong> {tripProfit.linked_expenses.length} item{tripProfit.linked_expenses.length !== 1 ? "s" : ""}
                              </Typography>
                              <Typography component="span" sx={{ fontSize: 11, fontWeight: 700, color: "#2f3891" }}>
                                {expensesOpen ? "▲ Hide" : "▼ View"}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      )}
                      {/* ── Expense breakdown ─────────────────────────────── */}
                      {expensesOpen && (
                        <Box sx={{ borderTop: "1px solid #f1f5f9", bgcolor: "#fff" }}>
                          {Array.isArray(tripProfit.linked_expenses) && tripProfit.linked_expenses.length > 0 ? (
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                              <Box sx={{ display: "grid", gridTemplateColumns: "1fr auto auto", gap: 1.5, px: 2.5, py: 1, bgcolor: "#f8fafc", borderBottom: "1px solid #f1f5f9" }}>
                                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Description</Typography>
                                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6, textAlign: "right" }}>Date</Typography>
                                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6, textAlign: "right" }}>Amount</Typography>
                              </Box>
                              {tripProfit.linked_expenses.map((exp: any, ei: number) => (
                                <Box
                                  key={exp?.id ?? ei}
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr auto auto",
                                    gap: 1.5,
                                    px: 2.5,
                                    py: 1.25,
                                    borderBottom: ei < tripProfit.linked_expenses.length - 1 ? "1px solid #f8fafc" : "none",
                                    alignItems: "start",
                                  }}
                                >
                                  <Box sx={{ minWidth: 0 }}>
                                    <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: "#1e293b" }}>
                                      {exp?.description || "—"}
                                    </Typography>
                                    {exp?.category && (
                                      <Typography sx={{ fontSize: 10.5, color: "#64748b", mt: 0.25 }}>
                                        {exp.category}
                                      </Typography>
                                    )}
                                    {exp?.status && (
                                      <Typography sx={{ fontSize: 10.5, color: "#94a3b8", mt: 0.25 }}>
                                        Status: {exp.status}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Typography sx={{ fontSize: 11.5, color: "#475569", textAlign: "right", whiteSpace: "nowrap" }}>
                                    {exp?.date ? dayjs(exp.date).format("MMM D, YYYY") : "—"}
                                  </Typography>
                                  <Box sx={{ textAlign: "right" }}>
                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#ef4444", whiteSpace: "nowrap" }}>
                                      ${Number(exp?.total ?? exp?.amount ?? 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </Typography>
                                    {exp?.hst != null && Number(exp.hst) > 0 && (
                                      <Typography sx={{ fontSize: 10, color: "#94a3b8", whiteSpace: "nowrap" }}>
                                        incl. HST ${Number(exp.hst).toFixed(2)}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                              ))}
                            </Box>
                          ) : (
                            <Box sx={{ px: 2.5, py: 2, textAlign: "center" }}>
                              <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
                                No expenses added
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}

                {/* ── Next action ── */}
                <Box sx={{ mx: 3, mb: 3, borderTop: "1px solid #f1f5f9", pt: 2.5, display: "flex", justifyContent: "center", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                  {(WorkOrderDataList?.invoiceId || activeStep >= 2) ? (
                    <>
                      {/* Invoice number badge */}
                      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 2, px: 2, py: 0.75, flexShrink: 0 }}>
                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#16a34a", letterSpacing: 0.5, whiteSpace: "nowrap" }}>INVOICE</Typography>
                        <Box sx={{ width: "1px", height: 16, bgcolor: "#bbf7d0", flexShrink: 0 }} />
                        <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#15803d", whiteSpace: "nowrap" }}>
                          {derivedInvoiceNo ? `#${derivedInvoiceNo}` : ""}
                        </Typography>
                        {(invoiceList?.po_number || WorkOrderDataList?.po_number) ? (
                          <>
                            <Box sx={{ width: "1px", height: 16, bgcolor: "#bbf7d0", flexShrink: 0 }} />
                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#16a34a", letterSpacing: 0.5, whiteSpace: "nowrap" }}>PO</Typography>
                            <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#15803d", whiteSpace: "nowrap" }}>{invoiceList?.po_number || WorkOrderDataList?.po_number}</Typography>
                            {(invoiceList?.po_document || WorkOrderDataList?.po_document) && (
                              <Tooltip title="View PO Document">
                                <IconButton
                                  size="small"
                                  component="a"
                                  href={`${LARAVEL_API_URL}/${invoiceList?.po_document || WorkOrderDataList?.po_document}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  sx={{ p: 0.25, color: "#16a34a" }}
                                >
                                  <DescriptionIcon sx={{ fontSize: 14 }} />
                                </IconButton>
                              </Tooltip>
                            )}
                            {WorkOrderDataList?.quoteWorkOrderStatus !== WorkOrderStatus.Cancel && (
                              <Tooltip title="Edit PO Number">
                                <IconButton
                                  size="small"
                                  onClick={() => handleAddPoNumber(derivedInvoiceNo!)}
                                  sx={{ p: 0.25, color: "#15803d" }}
                                >
                                  <FaEdit style={{ fontSize: 12 }} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </>
                        ) : (
                          WorkOrderDataList?.quoteWorkOrderStatus !== WorkOrderStatus.Cancel && (
                            <>
                              <Box sx={{ width: "1px", height: 16, bgcolor: "#bbf7d0", flexShrink: 0 }} />
                              <Chip
                                label="+ Add PO Number"
                                size="small"
                                onClick={() => handleAddPoNumber(derivedInvoiceNo!)}
                                sx={{ bgcolor: "#fff7ed", color: "#c2410c", fontWeight: 700, fontSize: 10, border: "1px solid #fed7aa", height: 20, cursor: "pointer" }}
                              />
                            </>
                          )
                        )}
                      </Box>
                      {(() => {
                        // Single source of truth — same object that renders the PO number.
                        const paid  = Number(invoiceList?.amount_paid || 0);
                        const total = Number(invoiceList?.quoteWorkOrderSaleGrandTotal || 0);
                        const due   = Number(invoiceList?.due_amount || 0);
                        const hasPO = !!invoiceList?.po_number;
                        // eslint-disable-next-line no-console
                        console.log("CTA DATA SOURCE:", { paid, total, due, po: invoiceList?.po_number });
                        const status = String((invoiceList as any)?.paymentStatus || (WorkOrderDataList as any)?.paymentStatus || "").toLowerCase();
                        const isFullyPaid =
                          status === "paid" ||
                          (Number(dueAmount) <= 0 && Number(amountPaid) > 0) ||
                          (paid >= total && due === 0 && total > 0) ||
                          (total > 0 && paid >= total);
                        if (isFullyPaid && hasPO) {
                          return (
                            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 2, px: 2, py: 0.75 }}>
                              <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#10b981", flexShrink: 0 }} />
                              <Typography sx={{ color: "#10b981", fontWeight: 700, fontSize: 13, whiteSpace: "nowrap" }}>Paid (PO)</Typography>
                            </Box>
                          );
                        }
                        if (isFullyPaid) {
                          return (
                            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 2, px: 2, py: 0.75 }}>
                              <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#10b981", flexShrink: 0 }} />
                              <Typography sx={{ color: "#10b981", fontWeight: 700, fontSize: 13, whiteSpace: "nowrap" }}>Payment Paid</Typography>
                            </Box>
                          );
                        }
                        return (
                          <Button variant="contained" onClick={handlePaymentPopup}
                            sx={{ bgcolor: "#10b981", "&:hover": { bgcolor: "#059669" }, borderRadius: 2, textTransform: "none", fontWeight: 700, px: 4, py: 0.9, boxShadow: "0 2px 8px rgba(16,185,129,0.3)", fontSize: 13, letterSpacing: 0.3, flexShrink: 0 }}>
                            Process Payment
                          </Button>
                        );
                      })()}
                    </>
                  ) : (
                    /* Not yet converted to invoice */
                    <Button variant="contained" onClick={handleOpenDialog}
                      sx={{ bgcolor: "#2f3891", "&:hover": { bgcolor: "#252e7a" }, borderRadius: 2, textTransform: "none", fontWeight: 700, px: 5, py: 1.1, boxShadow: "0 2px 8px rgba(124,58,237,0.3)", fontSize: 13, letterSpacing: 0.3 }}>
                      Convert to Invoice
                    </Button>
                  )}
                </Box>

              </Card>
            </Grid>

            {/* LEFT COLUMN */}
            <Grid item lg={8} md={8} sm={12} xs={12}>
              <Grid container spacing={3}>
                {/* CUSTOMER CARD */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card sx={{ borderRadius: 3, boxShadow: "0 1px 8px rgba(0,0,0,0.08)", border: "1px solid #f1f5f9" }}>
                    <Box sx={{ p: 2.5, display: "flex", alignItems: "flex-start", gap: 2 }}>
                      {/* Avatar */}
                      <Avatar
                        sx={{ width: 52, height: 52, bgcolor: "#ede9fe", color: "#2f3891", fontWeight: 700, fontSize: 18, cursor: "pointer", flexShrink: 0 }}
                        onClick={() => navigate(`/customer-history/${WorkOrderDataList?.quoteWorkOrderCustomerId || null}`)}>
                        {(WorkOrderDataList?.customer?.customerFirstName?.[0] || "").toUpperCase()}{(WorkOrderDataList?.customer?.customerLastName?.[0] || "").toUpperCase()}
                      </Avatar>
                      {/* Details */}
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          sx={{ fontWeight: 700, color: "#1e293b", fontSize: 15, cursor: "pointer", "&:hover": { color: "#2f3891" }, transition: "color 0.15s" }}
                          onClick={() => navigate(`/customer-history/${WorkOrderDataList?.quoteWorkOrderCustomerId || null}`)}>
                          {`${WorkOrderDataList?.customer?.customerFirstName || ""} ${WorkOrderDataList?.customer?.customerLastName || ""}`.trim()}
                        </Typography>
                        {WorkOrderDataList?.customer?.customerCompanyName && (
                          <Typography sx={{ fontSize: 12, color: "#64748b", fontWeight: 500, mt: 0.25, mb: 1 }}>
                            {WorkOrderDataList.customer.customerCompanyName}
                          </Typography>
                        )}
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 0.5 }}>
                          {WorkOrderDataList?.customer?.customerMobileNum && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Box sx={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", minWidth: 38, letterSpacing: 0.4 }}>MOB</Box>
                              <Typography sx={{ fontSize: 12, color: "#475569" }}>{WorkOrderDataList.customer.customerMobileNum}</Typography>
                            </Box>
                          )}
                          {WorkOrderDataList?.customer?.customerEmail && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Box sx={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", minWidth: 38, letterSpacing: 0.4 }}>EMAIL</Box>
                              <Typography sx={{ fontSize: 12, color: "#475569" }}>{WorkOrderDataList.customer.customerEmail}</Typography>
                            </Box>
                          )}
                          {WorkOrderDataList?.customer?.customerCompanyPhoneNumebr && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Box sx={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", minWidth: 38, letterSpacing: 0.4 }}>TEL</Box>
                              <Typography sx={{ fontSize: 12, color: "#475569" }}>{WorkOrderDataList.customer.customerCompanyPhoneNumebr}</Typography>
                            </Box>
                          )}
                          {WorkOrderDataList?.customer?.customerCompanyEmail && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Box sx={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", minWidth: 38, letterSpacing: 0.4 }}>CO.</Box>
                              <Typography sx={{ fontSize: 12, color: "#475569" }}>{WorkOrderDataList.customer.customerCompanyEmail}</Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Card>
                </Grid>




                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card sx={{ borderRadius: 3, boxShadow: "0 1px 8px rgba(0,0,0,0.08)", border: "1px solid #f1f5f9" }}>
                    <Box sx={{ px: 2.5, py: 2, borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: 3, height: 16, borderRadius: 2, bgcolor: "#2f3891" }} />
                      <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: 13, textTransform: "uppercase", letterSpacing: 0.8 }}>Services</Typography>
                    </Box>
                    <Box sx={{ p: 2 }}>
                      {workOrderError || coursings.length === 0 ? (
                        <Typography sx={{ fontSize: 13, color: "#94a3b8", textAlign: "center", py: 3 }}>
                          {workOrderError ? "Error fetching data" : "No services added"}
                        </Typography>
                      ) : (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                          {(invoiceCoursings.length > 0 ? invoiceCoursings : coursings)
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((product: any, index: any) => {
                              const qty = product.busCount || product.quantity || 1;
                              const unitPrice = parseFloat(String(product.price ?? 0));
                              const lineTotal = product.total > 0 ? product.total : unitPrice * qty;
                              const taxAmt = parseFloat(String(product.taxAmount ?? 0));
                              const tripFrom = product.transferTypeFrom || product.departureAddress || "";
                              const tripTo = product.transferTypeTo || product.destinationAddress || "";
                              const tripTypeLabel =
                                product.transferType === TransferType.RoundTrip ? "Round Trip" :
                                product.transferType === TransferType.OneWayTransfer ? "One Way Transfer" :
                                product.transferType ? String(product.transferType) : "";
                              const pickupList = product.pickups?.length ? product.pickups : product.departureAddress ? [{ address: product.departureAddress, dateTime: product.departureDateTime }] : [];
                              const dropoffList = product.dropoffs?.length ? product.dropoffs : product.destinationAddress ? [{ address: product.destinationAddress, dateTime: product.returnDateTime }] : [];
                              const retPickups = product.returnPickups || [];
                              const retDropoffs = product.returnDropoffs || [];
                              return (
                                <Box key={index} sx={{ borderRadius: 2.5, border: "1px solid #e2e8f0", overflow: "hidden", bgcolor: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
                                  {/* ── Header bar ── */}
                                  <Box sx={{ px: 2.5, py: 1.5, bgcolor: "#f8fafc", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                      <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#2f3891", flexShrink: 0 }} />
                                      <Typography sx={{ fontWeight: 800, fontSize: 14, color: "#0f172a" }}>{product.productName || "Service"}</Typography>
                                      {tripTypeLabel && (
                                        <Chip label={tripTypeLabel} size="small" sx={{ height: 20, fontSize: 10, fontWeight: 600, bgcolor: "#f0fdf4", color: "#16a34a", border: "1px solid #bbf7d0" }} />
                                      )}
                                    </Box>
                                    <Typography sx={{ fontWeight: 800, fontSize: 16, color: "#2f3891" }}>${lineTotal.toFixed(2)}</Typography>
                                  </Box>

                                  <Box sx={{ p: 2 }}>
                                    {/* ── Description ── */}
                                    {product.productDescription && (
                                      <Typography sx={{ fontSize: 12, color: "#64748b", mb: 1.5, whiteSpace: "pre-wrap" }}>
                                        {product.productDescription}
                                      </Typography>
                                    )}
                                    {/* ── Route ── */}
                                    {(tripFrom || tripTo) && (
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5, bgcolor: "#f8fafc", borderRadius: 1.5, px: 1.5, py: 0.75 }}>
                                        <Box sx={{ fontSize: 10, fontWeight: 700, color: "#16a34a", textTransform: "uppercase", letterSpacing: 0.5, flexShrink: 0 }}>Route</Box>
                                        <Typography sx={{ fontSize: 12, color: "#475569", fontWeight: 600 }}>{tripFrom}</Typography>
                                        <Box sx={{ fontSize: 14, color: "#94a3b8" }}>→</Box>
                                        <Typography sx={{ fontSize: 12, color: "#475569", fontWeight: 600 }}>{tripTo}</Typography>
                                      </Box>
                                    )}

                                    {/* ── Pricing breakdown grid ── */}
                                    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 1, mb: 1.5 }}>
                                      {product.numberOfPassengers && (
                                        <Box sx={{ textAlign: "center", bgcolor: "#ede9fe", borderRadius: 1.5, px: 1, py: 0.75 }}>
                                          <Typography sx={{ fontSize: 10, fontWeight: 600, color: "#2f3891", textTransform: "uppercase", letterSpacing: 0.4 }}>Passengers</Typography>
                                          <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#252e7a" }}>{product.numberOfPassengers}<Typography component="span" sx={{ fontSize: 10, fontWeight: 500 }}> pax</Typography></Typography>
                                        </Box>
                                      )}
                                      <Box sx={{ textAlign: "center", bgcolor: "#dbeafe", borderRadius: 1.5, px: 1, py: 0.75 }}>
                                        <Typography sx={{ fontSize: 10, fontWeight: 600, color: "#1d4ed8", textTransform: "uppercase", letterSpacing: 0.4 }}>Buses</Typography>
                                        <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#1d4ed8" }}>{qty}<Typography component="span" sx={{ fontSize: 10, fontWeight: 500 }}> bus{qty > 1 ? "es" : ""}</Typography></Typography>
                                      </Box>
                                      <Box sx={{ textAlign: "center", bgcolor: "#f0fdf4", borderRadius: 1.5, px: 1, py: 0.75 }}>
                                        <Typography sx={{ fontSize: 10, fontWeight: 600, color: "#16a34a", textTransform: "uppercase", letterSpacing: 0.4 }}>Price/Bus</Typography>
                                        <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#15803d" }}>${unitPrice.toFixed(2)}</Typography>
                                      </Box>
                                      <Box sx={{ textAlign: "center", bgcolor: "#fff7ed", borderRadius: 1.5, px: 1, py: 0.75, border: "1px solid #fed7aa" }}>
                                        <Typography sx={{ fontSize: 10, fontWeight: 600, color: "#c2410c", textTransform: "uppercase", letterSpacing: 0.4 }}>Subtotal</Typography>
                                        <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#c2410c" }}>${lineTotal.toFixed(2)}</Typography>
                                      </Box>
                                    </Box>

                                    {/* ── Pricing formula ── */}
                                    {qty > 1 && (
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 1.5, px: 1, py: 0.5, bgcolor: "#fafafa", borderRadius: 1, border: "1px dashed #e2e8f0" }}>
                                        <Typography sx={{ fontSize: 11, color: "#64748b" }}>{qty} buses</Typography>
                                        <Typography sx={{ fontSize: 11, color: "#94a3b8" }}>×</Typography>
                                        <Typography sx={{ fontSize: 11, color: "#64748b" }}>${unitPrice.toFixed(2)}</Typography>
                                        <Typography sx={{ fontSize: 11, color: "#94a3b8" }}>=</Typography>
                                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#2f3891" }}>${lineTotal.toFixed(2)}</Typography>
                                        {taxAmt > 0 && (
                                          <>
                                            <Box sx={{ width: "1px", height: 14, bgcolor: "#e2e8f0", mx: 0.5 }} />
                                            <Typography sx={{ fontSize: 11, color: "#64748b" }}>HST ${taxAmt.toFixed(2)}</Typography>
                                          </>
                                        )}
                                      </Box>
                                    )}

                                    {/* ── Stops ── */}
                                    {(pickupList.length > 0 || dropoffList.length > 0 || retPickups.length > 0 || retDropoffs.length > 0) && (
                                      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, borderTop: "1px solid #f1f5f9", pt: 1.25, mt: 0.5 }}>
                                        {pickupList.map((pickup: any, pi: number) =>
                                          (pickup.address) ? (
                                            <Box key={pi} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                                              <Box component="span" sx={{ fontSize: 9, fontWeight: 700, color: "#fff", bgcolor: "#16a34a", borderRadius: 0.75, px: 0.75, py: 0.25, flexShrink: 0, mt: 0.15 }}>PICKUP{pickupList.length > 1 ? ` ${pi + 1}` : ""}</Box>
                                              <Typography sx={{ fontSize: 12, color: "#475569" }}>{pickup.address}{pickup.city ? `, ${pickup.city}` : ""}{pickup.dateTime && toAppTz(pickup.dateTime)?.isValid() && <Typography component="span" sx={{ fontSize: 11, color: "#94a3b8", ml: 0.5 }}>· {formatDateTime(pickup.dateTime, "DD-MMM-YY h:mm A")}</Typography>}</Typography>
                                            </Box>
                                          ) : null
                                        )}
                                        {dropoffList.map((drop: any, di: number) =>
                                          (drop.address) ? (
                                            <Box key={di} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                                              <Box component="span" sx={{ fontSize: 9, fontWeight: 700, color: "#fff", bgcolor: "#dc2626", borderRadius: 0.75, px: 0.75, py: 0.25, flexShrink: 0, mt: 0.15 }}>DROP{dropoffList.length > 1 ? ` ${di + 1}` : ""}</Box>
                                              <Typography sx={{ fontSize: 12, color: "#475569" }}>{drop.address}{drop.city ? `, ${drop.city}` : ""}{drop.dateTime && toAppTz(drop.dateTime)?.isValid() && <Typography component="span" sx={{ fontSize: 11, color: "#94a3b8", ml: 0.5 }}>· {formatDateTime(drop.dateTime, "DD-MMM-YY h:mm A")}</Typography>}</Typography>
                                            </Box>
                                          ) : null
                                        )}
                                        {retPickups.map((pickup: any, pi: number) =>
                                          (pickup.address) ? (
                                            <Box key={pi} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                                              <Box component="span" sx={{ fontSize: 9, fontWeight: 700, color: "#fff", bgcolor: "#2f3891", borderRadius: 0.75, px: 0.75, py: 0.25, flexShrink: 0, mt: 0.15 }}>RTN PICKUP</Box>
                                              <Typography sx={{ fontSize: 12, color: "#475569" }}>{pickup.address}{pickup.city ? `, ${pickup.city}` : ""}{pickup.dateTime && toAppTz(pickup.dateTime)?.isValid() && <Typography component="span" sx={{ fontSize: 11, color: "#94a3b8", ml: 0.5 }}>· {formatDateTime(pickup.dateTime, "DD-MMM-YY h:mm A")}</Typography>}</Typography>
                                            </Box>
                                          ) : null
                                        )}
                                        {retDropoffs.map((drop: any, di: number) =>
                                          (drop.address) ? (
                                            <Box key={di} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                                              <Box component="span" sx={{ fontSize: 9, fontWeight: 700, color: "#fff", bgcolor: "#f59e0b", borderRadius: 0.75, px: 0.75, py: 0.25, flexShrink: 0, mt: 0.15 }}>RTN DROP</Box>
                                              <Typography sx={{ fontSize: 12, color: "#475569" }}>{drop.address}{drop.city ? `, ${drop.city}` : ""}{drop.dateTime && toAppTz(drop.dateTime)?.isValid() && <Typography component="span" sx={{ fontSize: 11, color: "#94a3b8", ml: 0.5 }}>· {formatDateTime(drop.dateTime, "DD-MMM-YY h:mm A")}</Typography>}</Typography>
                                            </Box>
                                          ) : null
                                        )}
                                      </Box>
                                    )}
                                  </Box>
                                </Box>
                              );
                            })}
                        </Box>
                      )}
                    </Box>
                    {/* hidden original table kept for reference - replaced by card layout above */}
                    <Box sx={{ display: "none" }}>
                      <TableContainer>
                        <Table>
                          <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                            <TableRow>
                       {/* <TableCell className={classes.tablheader}>
                        <strong>#</strong>
                      </TableCell> */}
                       {/* <TableCell className={classes.tablheader}>
                        <strong>Bus & Services Information</strong>
                         </TableCell> */}
                                                                   
                              <TableCell sx={{ fontWeight: 700, color: "#1e293b" }}><strong>Trip Information</strong></TableCell>
                              <TableCell sx={{ textAlign: "right", fontWeight: 700, color: "#1e293b" }}><strong>Price</strong></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {workOrderError || coursings.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={8} align="center">
                                  {workOrderError ? "Error fetching data" : "No data available"}
                                </TableCell>
                              </TableRow>
                            ) : (
                              (invoiceCoursings.length > 0 ? invoiceCoursings : coursings)
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((product: any, index: any) => (
                                  <TableRow key={index} sx={{ "&:hover": { backgroundColor: "#f8fafc" } }}>
                                                                            {/* <TableCell className={classes.tablCell}>
                                                                            {page * rowsPerPage + index + 1}
                                                                          </TableCell> */}
                                                                            {/* <TableCell className={classes.tablCell}>
                                                                              {!isMobile ? (
                                                                                <Grid container spacing={1}>
                                                                                  <Grid
                                                                                    item
                                                                                    sm={10}
                                                                                    xs={12}
                                                                                    textAlign={"left"}
                                                                                    alignContent={"center"}
                                                                                  >
                                                                                    <Typography>
                                                                                      <strong>
                                                                                        {product.productName}
                                                                                      </strong>
                                                                                    </Typography>
                                                                                  </Grid>
                                                                                </Grid>
                                                                              ) : (
                                                                                <Grid container spacing={1}>
                                                                                  <Grid item sm={10} xs={12} textAlign={"left"} alignContent={"center"}
                                                                                  >
                                                                                    <Typography>
                                                                                      <strong>
                                                                                        {product.productName}
                                                                                      </strong>
                                                                                    </Typography>
                                                                                  </Grid>
                                                                                </Grid>
                                                                              )}
                                        
                                                                              <Typography variant="body2" color="textSecondary">
                                                                                      {product.productDescription || ""}
                                                                                    </Typography>
                                                                                    <Typography variant="body2">
                                                                                     {product.numberOfPassengers && `${product.numberOfPassengers} Passengers`} 
                                                                                     {product.numberOfPassengers && product.busCount ? " | " : ""}
                                                                                     {product.busCount && `${product.busCount} bus`}
                                                                                   </Typography>
                                                                            </TableCell> */}
                                                                           
                                                                         
                                                                            
                         
                                <TableCell component="th" scope="row">
                                  {(product.productName || product.numberOfPassengers || product.busCount) && (
                                    <Typography variant="body2" component="div" gutterBottom sx={{ fontWeight: 600, color: "#1e293b" }}>
                                      {product.productName}
                                      {(product.numberOfPassengers || product.busCount) && (
                                        <Typography component="span" variant="body2" sx={{ color: "#64748b", fontWeight: 400, ml: 0.5 }}>
                                          {product.numberOfPassengers ? ` · ${product.numberOfPassengers} pax` : ""}
                                          {product.busCount ? ` · Count: ${product.busCount}` : ""}
                                        </Typography>
                                      )}
                                    </Typography>
                                  )}
                                  <Typography variant="subtitle1" component="div" gutterBottom>
                                    {product.transferType ? (Object.keys(TransferType) as (keyof typeof TransferType)[]).find((key) => TransferType[key] === String(product.transferType)) : ""}
                                    {product.transferTypeFrom && product.transferTypeTo ? ` (${product.transferTypeFrom} → ${product.transferTypeTo})` : ""}
                                  </Typography>
                                  {/* New array-based pickup/dropoff display */}
                                  {(product.pickups || []).map((pickup: any, pi: number) => (
                                    (pickup.address || (pickup.dateTime && toAppTz(pickup.dateTime)?.isValid())) ? (
                                      <Typography key={pi} variant="body2" component="div" gutterBottom>
                                        <strong>Pickup{(product.pickups?.length || 0) > 1 ? ` ${pi + 1}` : ""}:</strong>{" "}
                                        {pickup.address}{pickup.city ? `, ${pickup.city}` : ""}
                                        {pickup.dateTime && toAppTz(pickup.dateTime)?.isValid() && <> · {formatDateTime(pickup.dateTime, "DD-MMM-YY hh:mm A")}</>}
                                      </Typography>
                                    ) : null
                                  ))}
                                  {(product.dropoffs || []).map((drop: any, di: number) => (
                                    (drop.address || (drop.dateTime && toAppTz(drop.dateTime)?.isValid())) ? (
                                      <Typography key={di} variant="body2" component="div" gutterBottom>
                                        <strong>Dropoff{(product.dropoffs?.length || 0) > 1 ? ` ${di + 1}` : ""}:</strong>{" "}
                                        {drop.address}{drop.city ? `, ${drop.city}` : ""}
                                        {drop.dateTime && toAppTz(drop.dateTime)?.isValid() && <> · {formatDateTime(drop.dateTime, "DD-MMM-YY hh:mm A")}</>}
                                      </Typography>
                                    ) : null
                                  ))}
                                  {(product.returnPickups || []).map((pickup: any, pi: number) => (
                                    (pickup.address || (pickup.dateTime && toAppTz(pickup.dateTime)?.isValid())) ? (
                                      <Typography key={pi} variant="body2" component="div" gutterBottom>
                                        <strong>Return Pickup{(product.returnPickups?.length || 0) > 1 ? ` ${pi + 1}` : ""}:</strong>{" "}
                                        {pickup.address}{pickup.city ? `, ${pickup.city}` : ""}
                                        {pickup.dateTime && toAppTz(pickup.dateTime)?.isValid() && <> · {formatDateTime(pickup.dateTime, "DD-MMM-YY hh:mm A")}</>}
                                      </Typography>
                                    ) : null
                                  ))}
                                  {(product.returnDropoffs || []).map((drop: any, di: number) => (
                                    (drop.address || (drop.dateTime && toAppTz(drop.dateTime)?.isValid())) ? (
                                      <Typography key={di} variant="body2" component="div" gutterBottom>
                                        <strong>Return Dropoff{(product.returnDropoffs?.length || 0) > 1 ? ` ${di + 1}` : ""}:</strong>{" "}
                                        {drop.address}{drop.city ? `, ${drop.city}` : ""}
                                        {drop.dateTime && toAppTz(drop.dateTime)?.isValid() && <> · {formatDateTime(drop.dateTime, "DD-MMM-YY hh:mm A")}</>}
                                      </Typography>
                                    ) : null
                                  ))}
                                  {/* Fallback: old-format flat fields */}
                                  {!(product.pickups?.length) && product.departureAddress && (
                                    <Typography variant="body2" component="div" gutterBottom>
                                      <strong>Departure:</strong> {product.departureAddress}
                                      {product.departureDateTime && dayjs(product.departureDateTime).isValid() && <> · {dayjs(product.departureDateTime).format("DD-MMM-YY hh:mm A")}</>}
                                    </Typography>
                                  )}
                                  {!(product.dropoffs?.length) && product.destinationAddress && (
                                    <Typography variant="body2" component="div" gutterBottom>
                                      <strong>Destination:</strong> {product.destinationAddress}
                                      {product.returnDateTime && dayjs(product.returnDateTime).isValid() && <> · {dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")}</>}
                                    </Typography>
                                  )}
                                </TableCell>
                                <TableCell align="right">{(product.price ?? 0).toFixed(2)}</TableCell>
                              </TableRow>
                            ))
                          )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                         
                         
                         

                    {/* Totals summary */}
                    <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2.5, pb: 2.5, mt: 1 }}>
                      <Box sx={{ minWidth: 260, bgcolor: "#f8fafc", borderRadius: 2, border: "1px solid #e2e8f0", p: 2 }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.75 }}>
                          <Typography sx={{ fontSize: 13, color: "#64748b" }}>Sub Total</Typography>
                          <Typography sx={{ fontSize: 13, color: "#1e293b" }}>
                            ${parseFloat(invoiceList ? invoiceList?.quoteWorkOrderSubTotal || "0" : WorkOrderDataList?.quoteWorkOrderSubTotal || "0").toFixed(2)}
                          </Typography>
                        </Box>
                        {(invoiceDiscountList.length > 0 ? invoiceDiscountList : discountList).map((discount: any, index: any) => (
                          <Box key={index} sx={{ display: "flex", justifyContent: "space-between", mb: 0.75 }}>
                            <Typography sx={{ fontSize: 13, color: "#64748b" }}>{discount.description || "Discount"}</Typography>
                            <Typography sx={{ fontSize: 13, color: "#dc2626" }}>-${(discount.value !== null ? discount.value : 0).toFixed(2)}</Typography>
                          </Box>
                        ))}
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.75 }}>
                          <Typography sx={{ fontSize: 13, color: "#64748b" }}>HST</Typography>
                          <Typography sx={{ fontSize: 13, color: "#1e293b" }}>${invoiceList ? invoiceTotalTax.toFixed(2) : totalTax.toFixed(2)}</Typography>
                        </Box>
                        <Box sx={{ borderTop: "1px solid #e2e8f0", my: 1 }} />
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.75 }}>
                          <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1e293b" }}>Grand Total</Typography>
                          <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1e293b" }}>
                            ${parseFloat(invoiceList ? invoiceList?.quoteWorkOrderSaleGrandTotal || "0" : WorkOrderDataList?.quoteWorkOrderSaleGrandTotal || "0").toFixed(2)}
                          </Typography>
                        </Box>
                        {/* Payment summary */}
                        <Box sx={{ borderTop: "1px solid #e2e8f0", my: 1 }} />
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                          <Typography sx={{ fontSize: 13, color: "#64748b" }}>Paid Amount</Typography>
                          <Typography sx={{ fontSize: 13, color: amountPaid > 0 ? "#16a34a" : "#64748b", fontWeight: amountPaid > 0 ? 600 : 400 }}>
                            ${amountPaid.toFixed(2)}
                          </Typography>
                        </Box>
                        {(() => {
                          const grandTotalForBalance = parseFloat(
                            invoiceList?.quoteWorkOrderSaleGrandTotal || WorkOrderDataList?.quoteWorkOrderSaleGrandTotal || "0"
                          );
                          const balanceAmt = Math.max(0, grandTotalForBalance - amountPaid);
                          const isPaid = balanceAmt === 0 && amountPaid > 0;
                          const balanceColor = isPaid ? "#16a34a" : "#dc2626";
                          const balanceBg = isPaid ? "#f0fdf4" : "#fef2f2";
                          const balanceBorder = isPaid ? "#bbf7d0" : "#fecaca";
                          return (
                            <Box sx={{ display: "flex", justifyContent: "space-between", bgcolor: balanceBg, border: `1px solid ${balanceBorder}`, borderRadius: 1.5, px: 1.5, py: 0.75, mt: 0.25 }}>
                              <Typography sx={{ fontSize: 13, fontWeight: 700, color: balanceColor }}>Balance</Typography>
                              <Typography sx={{ fontSize: 13, fontWeight: 700, color: balanceColor }}>
                                ${balanceAmt.toFixed(2)}
                              </Typography>
                            </Box>
                          );
                        })()}
                      </Box>
                    </Box>
                  </Card>

                </Grid>


                {Array.isArray(invoiceHistories) && invoiceHistories.length > 0 && (
                   <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box sx={{ borderRadius: 3, overflow: "hidden", border: "1px solid #e2e8f0", boxShadow: "0 1px 8px rgba(0,0,0,0.06)" }}>
                    <Box sx={{ px: 2.5, py: 1.5, bgcolor: "#f8fafc", borderBottom: "1px solid #e2e8f0", display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: 3, height: 16, borderRadius: 2, bgcolor: "#0284c7" }} />
                      <Typography sx={{ fontWeight: 700, fontSize: 12, color: "#1e293b", textTransform: "uppercase", letterSpacing: 0.8 }}>Invoice History</Typography>
                      <Box sx={{ ml: "auto", px: 1.5, py: 0.25, borderRadius: 10, bgcolor: "#e0f2fe", border: "1px solid #bae6fd" }}>
                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#0284c7" }}>{invoiceHistories.length}</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                      {invoiceHistories.map((invoiceHistory, index) => {
                        const isCreated = index === 0;

                        const grandTotal = parseFloat(invoiceHistory.quoteWorkOrderSaleGrandTotal || "0");
                        const subTotal = parseFloat(invoiceHistory.quoteWorkOrderSubTotal || "0");
                        const discount = parseFloat(invoiceHistory.quoteWorkOrderDiscount || "0");
                        const hst = grandTotal - subTotal + discount;
                        const isExpanded = expandedStepsInvoice.includes(index);

                        return (
                          <Box key={index} sx={{ borderRadius: 2.5, border: "1px solid #e2e8f0", overflow: "hidden" }}>
                            <Box
                              sx={{ px: 2, py: 1.25, bgcolor: isCreated ? "#f0f9ff" : "#fafafa", borderBottom: isExpanded ? "1px solid #e2e8f0" : "none", display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer", "&:hover": { bgcolor: isCreated ? "#e0f2fe" : "#f1f5f9" } }}
                              onClick={() => toggleStepInvoice(index)}
                            >
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Box sx={{ width: 28, height: 28, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: isCreated ? "#0284c7" : "#64748b", flexShrink: 0 }}>
                                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#fff" }}>{index + 1}</Typography>
                                </Box>
                                <Box>
                                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>{isCreated ? "Invoice Created" : "Invoice Edited"}</Typography>
                                  <Typography sx={{ fontSize: 11, color: "#64748b" }}>
                                    {invoiceHistory.updated_by} · {dayjs(isCreated ? invoiceHistory.created_at : invoiceHistory.updated_at).format("MMM D, YYYY [at] h:mm A")}
                                    {invoiceHistory.po_number ? ` · PO: ${String(invoiceHistory.po_number)}` : ""}
                                  </Typography>
                                </Box>
                              </Box>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                {grandTotal > 0 && <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#0284c7" }}>${grandTotal.toFixed(2)}</Typography>}
                                {isExpanded ? <ExpandLessSharpIcon sx={{ fontSize: 18, color: "#94a3b8" }} /> : <ExpandMoreSharpIcon sx={{ fontSize: 18, color: "#94a3b8" }} />}
                              </Box>
                            </Box>
                            {isExpanded && (
                              <Box sx={{ p: 2 }}>

                  {/* services start */}
                  {Array.isArray(invoiceHistory.quoteWorkOrderSale) && invoiceHistory.quoteWorkOrderSale.length > 0 && (
                    <Box sx={{ mb: 2 }}>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6, mb: 1 }}>Services</Typography>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {invoiceHistory.quoteWorkOrderSale.map((product: any, pi: number) => {
                        const buses = Number(product.busCount) || 1;
const pricePerBus = parseFloat(product.price ?? 0);          // price IS already per-bus
const lineTotal = pricePerBus * buses;                        // total = price × buses
                          const tripLabel = product.transferType
                            ? (Object.keys(TransferType) as (keyof typeof TransferType)[]).find((k) => TransferType[k] === String(product.transferType)) ?? ""
                            : "";
                          return (
                            <Box key={pi} sx={{ borderRadius: 2, border: "1px solid #f1f5f9", overflow: "hidden" }}>
                              <Box sx={{ px: 2, py: 1, bgcolor: "#f8fafc", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#1e293b" }}>{product.productName}</Typography>
                                  {tripLabel && (
                                    <Box sx={{ px: 1, py: 0.25, borderRadius: 1, bgcolor: "#ede9fe", border: "1px solid #ddd6fe" }}>
                                      <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#2f3891" }}>{tripLabel}</Typography>
                                    </Box>
                                  )}
                                </Box>
                                <Typography sx={{ fontWeight: 800, fontSize: 14, color: "#2f3891" }}>${lineTotal.toFixed(2)}</Typography>
                              </Box>
                              {(product.transferTypeFrom || product.transferTypeTo) && (
                                <Box sx={{ px: 2, py: 0.75, bgcolor: "#fafafa", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", gap: 0.75 }}>
                                  <Typography sx={{ fontSize: 11, color: "#16a34a", fontWeight: 600 }}>{product.transferTypeFrom || "—"}</Typography>
                                  <Typography sx={{ fontSize: 11, color: "#94a3b8" }}>→</Typography>
                                  <Typography sx={{ fontSize: 11, color: "#dc2626", fontWeight: 600 }}>{product.transferTypeTo || "—"}</Typography>
                                </Box>
                              )}
                              <Box sx={{ px: 2, py: 1, display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 1 }}>
                                <Box sx={{ textAlign: "center" }}>
                                  <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.4 }}>Passengers</Typography>
                                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#2f3891" }}>{product.numberOfPassengers || "—"}</Typography>
                                </Box>
                                <Box sx={{ textAlign: "center" }}>
                                  <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.4 }}>Buses</Typography>
                                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0284c7" }}>{buses}</Typography>
                                </Box>
                                <Box sx={{ textAlign: "center" }}>
                                  <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.4 }}>Price/Bus</Typography>
                                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#16a34a" }}>${pricePerBus.toFixed(2)}</Typography>
                                </Box>
                                <Box sx={{ textAlign: "center" }}>
                                  <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.4 }}>Subtotal</Typography>
                                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#ea580c" }}>${lineTotal.toFixed(2)}</Typography>
                                </Box>
                              </Box>
                              <Box sx={{ px: 2, pb: 0.75, display: "flex", justifyContent: "flex-end" }}>
                                <Typography sx={{ fontSize: 10, color: "#94a3b8", fontStyle: "italic" }}>
                                  {buses} {buses !== 1 ? "buses" : "bus"} × ${pricePerBus.toFixed(2)} = ${lineTotal.toFixed(2)}
                                </Typography>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  )}
                  {/* totals breakdown */}
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Box sx={{ minWidth: 220, bgcolor: "#f8fafc", borderRadius: 1.5, border: "1px solid #e2e8f0", p: 1.5 }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                        <Typography sx={{ fontSize: 12, color: "#64748b" }}>Subtotal</Typography>
                        <Typography sx={{ fontSize: 12, color: "#1e293b" }}>${subTotal.toFixed(2)}</Typography>
                      </Box>
                      {discount > 0 && (
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                          <Typography sx={{ fontSize: 12, color: "#64748b" }}>Discount</Typography>
                          <Typography sx={{ fontSize: 12, color: "#dc2626" }}>-${discount.toFixed(2)}</Typography>
                        </Box>
                      )}
                      {hst > 0 && (
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                          <Typography sx={{ fontSize: 12, color: "#64748b" }}>HST</Typography>
                          <Typography sx={{ fontSize: 12, color: "#1e293b" }}>${hst.toFixed(2)}</Typography>
                        </Box>
                      )}
                      <Box sx={{ borderTop: "1px solid #e2e8f0", my: 0.75 }} />
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>Grand Total</Typography>
                        <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0284c7" }}>${grandTotal.toFixed(2)}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
    </Grid>
  )}



               



                {/* ── NOTES SECTION ──────────────────────────────────────── */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card sx={{ borderRadius: 3, boxShadow: "0 1px 8px rgba(0,0,0,0.08)", border: "1px solid #f1f5f9" }}>
                    <Box sx={{ px: 2.5, py: 2, borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: 3, height: 16, borderRadius: 2, bgcolor: "#f59e0b" }} />
                      <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: 13, textTransform: "uppercase", letterSpacing: 0.8 }}>Notes</Typography>
                    </Box>
                    <Box sx={{ p: 2.5 }}>
                      {/* Template selector + Input area */}
                      {noteTemplates.length > 0 && (
                        <Select
                          size="small"
                          displayEmpty
                          value=""
                          onChange={(e) => {
                            const tplId = e.target.value as string;
                            if (tplId) {
                              const tpl = noteTemplates.find((t) => String(t.id) === tplId);
                              if (tpl) setNoteText(tpl.note_message);
                            }
                          }}
                          sx={{ mb: 1.5, fontSize: 13, borderRadius: 2, bgcolor: "#f8fafc", width: "100%", "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0" } }}
                        >
                          <MenuItem value=""><em style={{ color: "#94a3b8", fontStyle: "normal" }}>Select Note Template</em></MenuItem>
                          {noteTemplates.map((t) => (
                            <MenuItem key={t.id} value={String(t.id)} sx={{ fontSize: 13 }}>{t.note_title}</MenuItem>
                          ))}
                        </Select>
                      )}
                      <Box sx={{ display: "flex", gap: 1, mb: 2.5 }}>
                        <TextField
                          multiline
                          minRows={2}
                          maxRows={5}
                          fullWidth
                          size="small"
                          placeholder="Add a note... (Ctrl+Enter to save)"
                          value={noteText}
                          onChange={(e) => setNoteText(e.target.value)}
                          onKeyDown={(e) => { if (e.key === "Enter" && e.ctrlKey) handleSaveNote(); }}
                          InputProps={{ sx: { fontSize: 13, bgcolor: "#f8fafc" } }}
                        />
                        <Button
                          variant="contained"
                          onClick={handleSaveNote}
                          disabled={!noteText.trim() || noteSaving}
                          sx={{ alignSelf: "flex-end", textTransform: "none", fontWeight: 700, fontSize: 13, px: 2.5, borderRadius: 2, bgcolor: "#f59e0b", "&:hover": { bgcolor: "#d97706" }, whiteSpace: "nowrap", minWidth: 80 }}
                        >
                          {noteSaving ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : "Save"}
                        </Button>
                      </Box>
                      {/* Note history */}
                      {workOrderNotes.length === 0 ? (
                        <Typography sx={{ fontSize: 12, color: "#94a3b8", textAlign: "center", py: 1 }}>No notes yet</Typography>
                      ) : (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                          {workOrderNotes.map((note) => (
                            <Box key={note.id} sx={{ bgcolor: "#fffbeb", border: "1px solid #fde68a", borderRadius: 2, p: 1.5 }}>
                              <Typography sx={{ fontSize: 13, color: "#1e293b", lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{note.message}</Typography>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.75 }}>
                                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#d97706" }}>{note.created_by || "Admin"}</Typography>
                                <Typography sx={{ fontSize: 10, color: "#94a3b8" }}>·</Typography>
                                <Typography sx={{ fontSize: 10, color: "#94a3b8" }}>{dayjs(note.created_at).format("MMM D, YYYY h:mm A")}</Typography>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>
                  </Card>
                </Grid>

              </Grid>
            </Grid>


          <Grid item lg={4} md={4} sm={12} xs={12} >


  <Grid container spacing={3} >
    {/* Payment Details */}

    {!!WorkOrderDataList?.invoiceId && dueAmount > 0 && (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Card sx={{ borderRadius: 3, boxShadow: "0 1px 8px rgba(0,0,0,0.08)", border: "1px solid #f1f5f9", backgroundColor: (theme) => `${alpha(theme.palette.primary.light, 0.1)} !important` }}>
        {derivedInvoiceNo && (
          <Box sx={{ borderBottom: "2px solid #f1f5f9", p: 2 }}>
            <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: 14, textTransform: "uppercase", letterSpacing: 1 }}>
              Charter No: {derivedInvoiceNo}
            </Typography>
          </Box>
        )}
        <Grid container spacing={2} sx={{ padding: 2 }}>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <Typography variant="body1">Total Due</Typography>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography variant="body1" textAlign="left">${dueAmount.toFixed(2)}</Typography>
          </Grid>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <Typography variant="body1">{amountPaid <= 0 ? 'Generate Payment Link (100%)' : 'Generate Payment Link'}</Typography>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <TextField
              value={editableAmount}
              onChange={handleAmountChange}
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{
                sx: { fontSize: 14 },
                startAdornment: <Typography variant="h6">$</Typography>,
              }}
            />
          </Grid>
          <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="right" spacing={2}>
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleSendPaymentLink}
                sx={{ fontSize: '0.75rem', padding: '4px 8px', minWidth: 'auto', textTransform: 'none' }}>
                Send by email
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary"
                sx={{ fontSize: '0.75rem', padding: '4px 8px', minWidth: 'auto', textTransform: 'none' }}>
                Send a text
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Grid>
    )}

    {/* ── Driver Assignment Card ─────────────────────── */}
    {invoiceList && (
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card sx={{ borderRadius: 3, boxShadow: "0 1px 8px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          {/* Header */}
          <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{ width: 28, height: 28, borderRadius: 1.5, background: "linear-gradient(135deg,#2f3891,#2563eb)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Typography sx={{ color: "#fff", fontSize: 13, lineHeight: 1 }}>🚗</Typography>
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#1e293b" }}>Driver Assignment</Typography>
          </Box>

          <Box sx={{ p: 2 }}>
            {/* Current driver status */}
            {(() => {
              const rawAssignTo = invoiceList.assign_driver?.assign_to;
              const assignedArr: any[] = rawAssignTo
                ? (Array.isArray(rawAssignTo) ? rawAssignTo : (() => { try { return JSON.parse(rawAssignTo); } catch { return []; } })())
                : [];
              const currentDriver = assignedArr.length > 0
                ? driverList.find((d) => d.id === assignedArr[0]?.driverId)
                : null;

              return (
                <Box sx={{ mb: 2 }}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.75 }}>
                    Currently Assigned
                  </Typography>
                  {currentDriver ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1.5, borderRadius: 2, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0" }}>
                      <Avatar sx={{ width: 32, height: 32, fontSize: 12, fontWeight: 700, bgcolor: "#16a34a" }}>
                        {(currentDriver.driverFirstName?.[0] || "?").toUpperCase()}{(currentDriver.driverLastName?.[0] || "").toUpperCase()}
                      </Avatar>
                      <Box>
                        <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#15803d" }}>
                          {currentDriver.driverFirstName} {currentDriver.driverLastName}
                        </Typography>
                        {currentDriver.driverMobileNum && (
                          <Typography sx={{ fontSize: 11, color: "#16a34a" }}>{currentDriver.driverMobileNum}</Typography>
                        )}
                      </Box>
                      <Chip label="Assigned" size="small" sx={{ ml: "auto", height: 20, fontSize: 10, fontWeight: 700, color: "#16a34a", bgcolor: "#dcfce7", border: "1px solid #bbf7d0" }} />
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1.5, borderRadius: 2, bgcolor: "#fef9c3", border: "1px solid #fde68a" }}>
                      <Typography sx={{ fontSize: 12, color: "#92400e" }}>No driver assigned yet</Typography>
                    </Box>
                  )}
                </Box>
              );
            })()}

            {/* Driver select dropdown */}
            <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.75 }}>
              {invoiceList.assign_driver?.assign_to ? "Update Driver" : "Assign Driver"}
            </Typography>
            <TextField
              select
              size="small"
              fullWidth
              value={sidebarDriverId}
              onChange={(e) => {
                const id = Number(e.target.value) || ("" as "");
                setSidebarDriverId(id);
                setSidebarSmsText(buildSidebarDriverSms(id));
                setSidebarSmsEnabled(true);
              }}
              placeholder="Select a driver"
              sx={{ mb: 1.5, "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
            >
              <MenuItem value=""><em>— Select Driver —</em></MenuItem>
              {driverList
                .filter((d) => d.driverUserRole === "driver")
                .map((d) => (
                  <MenuItem key={d.id} value={d.id}>
                    {d.driverFirstName} {d.driverLastName}
                    {d.driverMobileNum ? ` · ${d.driverMobileNum}` : ""}
                  </MenuItem>
                ))}
            </TextField>

            {/* ── SMS Section ──────────────────────────────────────────────── */}
            {sidebarDriverId && (
              <Box sx={{ mb: 1.5, borderRadius: 2, border: "1px solid #e0e7ff", bgcolor: "#fafafe", overflow: "hidden" }}>
                {/* SMS header row */}
                <Box sx={{ px: 1.5, py: 1, display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: sidebarSmsEnabled ? "1px solid #e0e7ff" : "none", bgcolor: "#eff4ff" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    <Typography sx={{ fontSize: 11, lineHeight: 1 }}>📩</Typography>
                    <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: "#3730a3" }}>
                      Send SMS to Driver
                    </Typography>
                  </Box>
                  <Switch
                    checked={sidebarSmsEnabled}
                    onChange={(e) => {
                      setSidebarSmsEnabled(e.target.checked);
                      if (e.target.checked && !sidebarSmsText) {
                        setSidebarSmsText(buildSidebarDriverSms(sidebarDriverId));
                      }
                    }}
                    size="small"
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": { color: "#2f3891" },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { bgcolor: "#2f3891" },
                    }}
                  />
                </Box>

                {sidebarSmsEnabled && (
                  <Box sx={{ p: 1.5 }}>
                    <TextField
                      fullWidth multiline rows={6}
                      value={sidebarSmsText}
                      onChange={(e) => setSidebarSmsText(e.target.value)}
                      placeholder="SMS message…"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1.5, fontSize: 11.5, fontFamily: "monospace", lineHeight: 1.55,
                          bgcolor: "#fff",
                          "& fieldset": { borderColor: "#c7d2fe" },
                          "&:hover fieldset": { borderColor: "#2f3891" },
                          "&.Mui-focused fieldset": { borderColor: "#2f3891" },
                        },
                      }}
                    />
                    {/* Character counter */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 0.5 }}>
                      <Typography sx={{ fontSize: 10, color: "#94a3b8" }}>
                        Driver will receive trip details via SMS
                      </Typography>
                      <Typography sx={{
                        fontSize: 10, fontWeight: 600,
                        color: sidebarSmsText.length > 160 ? "#ef4444" : sidebarSmsText.length > 140 ? "#f59e0b" : "#64748b",
                      }}>
                        {sidebarSmsText.length} / {sidebarSmsText.length > 160 ? `${Math.ceil(sidebarSmsText.length / 153)}×153` : "160"}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            <Button
              variant="contained"
              fullWidth
              disabled={!sidebarDriverId || sidebarAssigning}
              onClick={handleSidebarAssignDriver}
              sx={{
                borderRadius: 2, textTransform: "none", fontWeight: 700, fontSize: 13,
                bgcolor: "#2f3891", "&:hover": { bgcolor: "#2f3891" },
                "&.Mui-disabled": { bgcolor: "#e2e8f0", color: "#94a3b8" },
              }}
            >
              {sidebarAssigning
                ? <CircularProgress size={16} sx={{ color: "#fff" }} />
                : (invoiceList.assign_driver?.assign_to
                    ? (sidebarSmsEnabled ? "Update Driver & Send SMS" : "Update Driver")
                    : (sidebarSmsEnabled ? "Assign Driver & Send SMS" : "Assign Driver")
                  )
              }
            </Button>
          </Box>
        </Card>
      </Grid>
    )}


<Dialog open={showDriverEmailDialog} onClose={handleDriverEmailDialogClose}  
     PaperProps={{
      sx: { borderRadius: 2 },
    }}
    maxWidth="md" fullWidth >
     <DialogTitle>Send Email
     <IconButton
 aria-label="close"
 onClick={handleDriverEmailDialogClose}
 sx={{
   position: 'absolute',
   right: 8,
   top: 8,
   color: (theme) => theme.palette.grey[500],
 }}
>
 <CancelOutlined />
</IconButton>
     </DialogTitle>
     <DialogContent>
          <Grid container spacing={1} p={"14px"}>
         <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    To
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
         size="small"
         fullWidth
         InputProps={{
           sx: {
             fontSize: 14,
           },
         }}
         InputLabelProps={{
           sx: {
             fontSize: 14,
           },
           shrink: true, 
         }}
         value={driverEmailData.to}
         onChange={(e) => setDriverEmailData({ ...driverEmailData, to: e.target.value })}
       />
         </Grid>
                             </Grid>
                           </Grid>
                           <Grid item lg={6} md={6} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    Select Template
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                               <TextField
  size="small"
  rows={4}
  fullWidth
  select
  value={driverEmailData.template}  // Controlled by state
  onChange={(event) => {
    const selectedTemplateId = event.target.value;
    setInvoiceEmailData({
      ...driverEmailData,
      template: selectedTemplateId, // Update selected template
      subject: driverEmailData.subject, // Reset subject and message when template changes
      message: driverEmailData.message,
    });
  }}

    >
    <MenuItem value="">
    Select option
    </MenuItem>
    {emailTemplateList.map((template) => (
    <MenuItem key={template.id} value={template.id}>
     {template.template_name} {/* Display the name of the template */}
    </MenuItem>
    ))}
    </TextField>
</Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={6} md={6} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                   Subject
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
        size="small"
        fullWidth
        InputProps={{
          sx: {
            fontSize: 14,
          },
        }}
        InputLabelProps={{
          sx: {
            fontSize: 14,
          },
        }}
         value={driverEmailData.subject}
         onChange={(e) => setDriverEmailData({ ...driverEmailData, subject: e.target.value })}
       />
       </Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={12} md={12} sm={12} xs={12}>
  <Grid container alignItems="center">
    {/* Message Label */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Message</Typography>
    </Grid>

    {/* ReactQuill Editor */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <ReactQuill
        value={driverEmailData.message} // Bind only the message value
        onChange={(value) =>
          setDriverEmailData({ ...driverEmailData, message: value })
        } // Update message value in the state
        style={{
          height: "210px",
        }}
      />


    </Grid>
  </Grid>
</Grid>

{/* Attachments Section */}
<Grid item lg={12} md={12} sm={12} xs={12} sx={{ marginTop: 5 }}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
    
    </Grid>
  </Grid>
</Grid>


       
       </Grid>
     </DialogContent>
     <DialogActions>



     <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
           <Card>
             <Grid container spacing={3} p={"24px"}>
               <Grid
                 item
                 lg={12}
                 md={12}
                 sm={12}
                 xs={12}
                 sx={{ display: "flex", justifyContent: "flex-end" }}
               >
               
       <Button   disabled={loading}   startIcon={<SaveAltIcon />} 
onClick={handleReSendDriverEmail} variant="contained">
       {loading ? <CircularProgress size={24} /> : "Send"}
       </Button>
       </Grid>
       </Grid>
       </Card>
       </Grid>
     </DialogActions>
   </Dialog>



   <Dialog open={showEmailDialog} onClose={handleEmailDialogClose}  
     PaperProps={{
      sx: { borderRadius: 2 },
    }}
    maxWidth="md" fullWidth >
     <DialogTitle>Send Email
     <IconButton
 aria-label="close"
 onClick={handleEmailDialogClose}
 sx={{
   position: 'absolute',
   right: 8,
   top: 8,
   color: (theme) => theme.palette.grey[500],
 }}
>
 <CancelOutlined />
</IconButton>
     </DialogTitle>
     <DialogContent>
          <Grid container spacing={1} p={"14px"}>
         <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    To
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
         size="small"
         fullWidth
         InputProps={{
           sx: {
             fontSize: 14,
           },
         }}
         InputLabelProps={{
           sx: {
             fontSize: 14,
           },
           shrink: true, 
         }}
         value={invoiceEmailData.to}
         onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, to: e.target.value })}
       />
         </Grid>
                             </Grid>
                           </Grid>
                           <Grid item lg={6} md={6} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    Select Template
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                               <TextField
  size="small"
  rows={4}
  fullWidth
  select
  value={invoiceEmailData.template}  // Controlled by state
  onChange={(event) => {
    const selectedTemplateId = event.target.value;
    setInvoiceEmailData({
      ...invoiceEmailData,
      template: selectedTemplateId, // Update selected template
      subject: invoiceEmailData.subject, // Reset subject and message when template changes
      message: invoiceEmailData.message,
    });
  }}

    >
    <MenuItem value="">
    Select option
    </MenuItem>
    {emailTemplateList.map((template) => (
    <MenuItem key={template.id} value={template.id}>
     {template.template_name} {/* Display the name of the template */}
    </MenuItem>
    ))}
    </TextField>
</Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={6} md={6} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                   Subject
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
        size="small"
        fullWidth
        InputProps={{
          sx: {
            fontSize: 14,
          },
        }}
        InputLabelProps={{
          sx: {
            fontSize: 14,
          },
        }}
         value={invoiceEmailData.subject}
         onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, subject: e.target.value })}
       />
       </Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={12} md={12} sm={12} xs={12}>
  <Grid container alignItems="center">
    {/* Message Label */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Message</Typography>
    </Grid>

    {/* ReactQuill Editor */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <ReactQuill
        value={invoiceEmailData.message} // Bind only the message value
        onChange={(value) =>
          setInvoiceEmailData({ ...invoiceEmailData, message: value })
        } // Update message value in the state
        style={{
          height: "210px",
        }}
      />


    </Grid>
  </Grid>
</Grid>

{/* Attachments Section */}
<Grid item lg={12} md={12} sm={12} xs={12} sx={{ marginTop: 5 }}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
    
    </Grid>
  </Grid>
</Grid>


       
       </Grid>
     </DialogContent>
     <DialogActions>



     <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
           <Card>
             <Grid container spacing={3} p={"24px"}>
               <Grid
                 item
                 lg={12}
                 md={12}
                 sm={12}
                 xs={12}
                 sx={{ display: "flex", justifyContent: "flex-end" }}
               >
               
       <Button   disabled={loading}   startIcon={<SaveAltIcon />} 
onClick={handleSendEmail} variant="contained">
       {loading ? <CircularProgress size={24} /> : "Send"}
       </Button>
       </Grid>
       </Grid>
       </Card>
       </Grid>
     </DialogActions>
   </Dialog>


<Dialog open={showPaymentDialog} onClose={handlePaymentDialogClose} maxWidth="sm" fullWidth
  PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
  <Box sx={{ height: 4, background: "linear-gradient(90deg,#10b981,#059669)" }} />

  {/* Header */}
  <Box sx={{ px: 3, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #f1f5f9" }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <Box sx={{ width: 36, height: 36, borderRadius: 2, bgcolor: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Typography sx={{ fontSize: 18 }}>💳</Typography>
      </Box>
      <Box>
        <Typography sx={{ fontWeight: 800, fontSize: 16, color: "#0f172a" }}>Process Payment</Typography>
        <Typography sx={{ fontSize: 12, color: "#64748b" }}>{WorkOrderDataList?.quoteWorkOrderNo}</Typography>
      </Box>
    </Box>
    <IconButton size="small" onClick={handlePaymentDialogClose} sx={{ color: "#94a3b8" }}>
      <CloseIcon sx={{ fontSize: 18 }} />
    </IconButton>
  </Box>

  {/* Balance summary */}
  <Box sx={{ mx: 3, mt: 2, mb: 1, display: "flex", gap: 1.5, flexWrap: "wrap" }}>
    <Box sx={{ flex: 1, minWidth: 80, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 2, px: 2, py: 1.25, textAlign: "center" }}>
      <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#16a34a", textTransform: "uppercase", letterSpacing: 0.5 }}>Grand Total</Typography>
      <Typography sx={{ fontSize: 16, fontWeight: 800, color: "#15803d" }}>${parseFloat(WorkOrderDataList?.quoteWorkOrderSaleGrandTotal || "0").toFixed(2)}</Typography>
    </Box>
    <Box sx={{ flex: 1, minWidth: 80, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 2, px: 2, py: 1.25, textAlign: "center" }}>
      <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#16a34a", textTransform: "uppercase", letterSpacing: 0.5 }}>Paid</Typography>
      <Typography sx={{ fontSize: 16, fontWeight: 800, color: "#15803d" }}>${grossAmountPaid.toFixed(2)}</Typography>
    </Box>
    {totalRefunded > 0 && (
      <Box sx={{ flex: 1, minWidth: 80, bgcolor: "#fef2f2", border: "1px solid #fecaca", borderRadius: 2, px: 2, py: 1.25, textAlign: "center" }}>
        <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#dc2626", textTransform: "uppercase", letterSpacing: 0.5 }}>Refunded</Typography>
        <Typography sx={{ fontSize: 16, fontWeight: 800, color: "#dc2626" }}>-${totalRefunded.toFixed(2)}</Typography>
      </Box>
    )}
    <Box sx={{ flex: 1, minWidth: 80, bgcolor: dueAmount > 0 ? "#fef2f2" : "#f0fdf4", border: `1px solid ${dueAmount > 0 ? "#fecaca" : "#bbf7d0"}`, borderRadius: 2, px: 2, py: 1.25, textAlign: "center" }}>
      <Typography sx={{ fontSize: 10, fontWeight: 700, color: dueAmount > 0 ? "#dc2626" : "#16a34a", textTransform: "uppercase", letterSpacing: 0.5 }}>Balance Due</Typography>
      <Typography sx={{ fontSize: 16, fontWeight: 800, color: dueAmount > 0 ? "#dc2626" : "#16a34a" }}>${dueAmount.toFixed(2)}</Typography>
    </Box>
  </Box>

  <Box sx={{ px: 3, pb: 1, display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
    {/* Date + Amount row */}
    <Box sx={{ display: "flex", gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.5 }}>Date</Typography>
        <TextField size="small" type="date" fullWidth value={paymentData.paymentDate}
          onChange={(e) => setPaymentData({ ...paymentData, paymentDate: e.target.value })}
          InputLabelProps={{ shrink: true }}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.5 }}>Amount</Typography>
        <TextField size="small" type="text" inputMode="decimal" fullWidth placeholder={`${dueAmount.toFixed(2)}`}
          value={paymentData.amount}
          onChange={(e) => {
            const val = e.target.value;
            if (val === "" || /^\d*\.?\d{0,2}$/.test(val)) setPaymentData({ ...paymentData, amount: val });
          }}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }} />
      </Box>
    </Box>

    {/* Payment method */}
    <Box>
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.5 }}>Payment Method</Typography>
      <TextField size="small" select fullWidth value={paymentData.paymentMethod}
        onChange={(e) => { setPaymentData({ ...paymentData, paymentMethod: e.target.value }); setShowPaymentMethodError(false); }}
        error={showPaymentMethodError} helperText={showPaymentMethodError ? "Payment method is required" : ""}
        sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}>
        <MenuItem value="">Select method…</MenuItem>
        <MenuItem value="Cash">Cash</MenuItem>
        <MenuItem value="Credit">Credit Card</MenuItem>
        <MenuItem value="Debit">Debit Card</MenuItem>
        <MenuItem value="E-Transfer">E-Transfer</MenuItem>
        <MenuItem value="Online banking">Online Banking</MenuItem>
        <MenuItem value="Pre authorization">Pre Authorization</MenuItem>
        <MenuItem value="Bank deposit">Bank Deposit</MenuItem>
        <MenuItem value="Purchase Order (PO)">Purchase Order (PO)</MenuItem>
      </TextField>
    </Box>

    {/* Description */}
    <Box>
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.5 }}>Description <Typography component="span" sx={{ fontSize: 11, color: "#94a3b8" }}>(optional)</Typography></Typography>
      <TextField size="small" fullWidth multiline rows={2} placeholder="Payment note…"
        value={paymentData.description}
        onChange={(e) => setPaymentData({ ...paymentData, description: e.target.value })}
        sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }} />
    </Box>

    {/* File upload */}
    <Box>
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.5 }}>Attach Receipt <Typography component="span" sx={{ fontSize: 11, color: "#94a3b8" }}>(optional)</Typography></Typography>
      <Button variant="outlined" component="label" size="small"
        sx={{ textTransform: "none", borderRadius: 1.5, borderColor: "#e2e8f0", color: "#64748b", fontSize: 12 }}>
        Upload File
        <input type="file" hidden onChange={(e) => setPaymentData({ ...paymentData, file: e.target.files?.[0] || null })} />
      </Button>
      {paymentData.file && (
        <Typography sx={{ fontSize: 11, color: "#10b981", mt: 0.5 }}>✓ {paymentData.file.name}</Typography>
      )}
    </Box>
  </Box>

  <Box sx={{ px: 3, py: 2, display: "flex", justifyContent: "flex-end", gap: 1, borderTop: "1px solid #f1f5f9", mt: 1 }}>
    <Button variant="outlined" onClick={handlePaymentDialogClose} disabled={loading}
      sx={{ textTransform: "none", fontWeight: 600, fontSize: 13, borderRadius: 1.5, borderColor: "#e2e8f0", color: "#64748b" }}>
      Cancel
    </Button>
    <Button variant="contained" onClick={handleSavePayment} disabled={loading}
      sx={{ textTransform: "none", fontWeight: 700, fontSize: 13, borderRadius: 1.5, bgcolor: "#10b981", "&:hover": { bgcolor: "#059669" }, boxShadow: "none", minWidth: 100 }}>
      {loading ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Pay Now"}
    </Button>
  </Box>
</Dialog>




      
   <Grid item lg={12} md={12} sm={12} xs={12}>
  <Card sx={{ borderRadius: 3, boxShadow: "0 1px 8px rgba(0,0,0,0.08)", border: "1px solid #f1f5f9" }}>
    {Array.isArray(emailLog) && emailLog.length > 0 && (() => {
      const filteredLogs = emailLog
        .filter((email) => email.workOrderNo === WorkOrderDataList?.quoteWorkOrderNo && email.amount !== null)
        .filter((email, i, arr) => arr.findIndex((e) => e.id === email.id) === i); // deduplicate by id
      return filteredLogs.length > 0 && filteredLogs.map((email, index) => {

            const paymentTransaction = bamboraTransactionData.find(
              (transaction) => Number(transaction.trnAmount) === Number(email.amount)
          );
          return(

          <Grid
            container
            spacing={2}
            sx={{
              borderBottom: index !== filteredLogs.length - 1 ? '1px solid #e0e0e0' : 'none',
              padding: 2,
            }}

            key={email.id}
          >
            {/* Header Section */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                Date: {moment(`${email.created_at}`).format("MMM DD, YYYY, hh:mm a")}
                {email.subject && (
    <span
      style={{
        backgroundColor: '#2196F3',
        color: '#fff',
        borderRadius: '12px',
        padding: '2px 8px',
        marginLeft: '8px',
        fontSize: '0.7rem',
        fontWeight: '500',
        cursor: 'pointer',
      }}
    //  onClick={() => handleInvoiceClick(row.invoiceId)}
    >
   Email
    </span>
  )}
       
              </Typography>
             
            </Grid>


            {/* Payment Link Section */}
            <Grid item xs={8}>
              <Typography variant="body1" color="textSecondary">
              {Number(Number(WorkOrderDataList?.quoteWorkOrderSaleGrandTotal).toFixed(2)) === Number(email.amount) 
      ? 'Generate Payment Link (100%)' 
      : 'Generate Payment Link'}
        
              </Typography>
            </Grid>
            <Grid item xs={4} textAlign="right">
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {/* ${((Number(email.quoteWorkOrderSaleGrandTotal || 0) * 0.3) || 0).toFixed(2)} */}
                ${email.amount}
              </Typography>
            </Grid>

            {paymentTransaction ? (
  <Grid item xs={12}>
    <Card sx={{ padding: 3, borderRadius: 2, boxShadow: 'none', backgroundColor: '#f9fafb',  }}>
      {/* Payment Status Section */}
      <Typography
        variant="body1"
        sx={{
          fontWeight: 'bold',
          color: paymentTransaction.trnApproved === '1' ? '#4caf50' : '#f44336',
          display: 'flex',
          alignItems: 'center',
          marginBottom: 1,
        }}
      >
        {/* Icon based on status */}
        {paymentTransaction.trnApproved === '1' ? (
          <CheckCircleIcon sx={{ marginRight: 1, color: '#4caf50' }} />
        ) : (
          <CancelIcon sx={{ marginRight: 1, color: '#f44336' }} />
        )}
     {paymentTransaction.trnApproved === '1' ? 'Approved' : 'Declined'}
      </Typography>

      {/* Transaction Date and Time */}
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ marginTop: 1, display: 'inline-block', fontSize: '0.875rem' }}
      >
        {/* <strong>Date:</strong> {moment(paymentTransaction.trnDate).format('MMM DD, YYYY')} at {moment(paymentTransaction.trnTime, 'HH:mm:ss').format('hh:mm A')} */}
        <strong>Date:</strong> {moment(paymentTransaction.created_at).format('MMM DD, YYYY  hh:mm A')}

      </Typography>

      {/* Transaction ID and Card Type */}
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ marginTop: 1, fontSize: '0.875rem' }}
      >
        <strong>Transaction ID:</strong> {paymentTransaction.trnId}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ marginTop: 1, fontSize: '0.875rem' }}
      >
        <strong>Card Type:</strong> {paymentTransaction.trnCardType}
      </Typography>
    </Card>
  </Grid>
) : (
  <Grid item xs={12}>
    <Card sx={{ padding: 3, borderRadius: 2, boxShadow: 'none', backgroundColor: '#f9fafb' }}>
      <Typography variant="body2" sx={{ textAlign: 'center', color: '#9e9e9e' }}>
        No Transaction made yet
      </Typography>
    </Card>
  </Grid>
)}


            <Grid item xs={8}>
            <Button
    sx={{
      fontSize: '0.75rem',
      padding: '4px 0px',
      minWidth: 'auto',
      textTransform: 'none',
    }}
    onClick={() => toggleStepDetail(index)}
  >
    {expandedStep.includes(index) ? 'Show less' : 'Show more'}
  </Button>
  </Grid> 
  <Grid item xs={12}>
  {expandedStep.includes(index) && (
      <div>
            
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                Subject:
              </Typography>
              <Typography variant="body2" sx={{ marginBottom: 2 }}>
                {email.subject || 'No subject available'}
              </Typography>

              {/* Message Section */}
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                Message:
              </Typography>
              <Typography
  variant="body2"
  sx={{
    whiteSpace: 'pre-line', // This ensures that new lines are preserved
    lineHeight: 0.9, // Better line spacing for readability
    wordBreak: 'break-word', // Avoids word overflow issues
  }}
  dangerouslySetInnerHTML={{ __html: email.message || 'No message available' }} // Render the HTML safely
/>
</div>
 )}
</Grid>
            {/* Action Buttons */}
            <Grid item xs={12} textAlign="right" >
              <Button
                variant="contained"
                color="primary"
                onClick={handleReSendPaymentLink}
                sx={{ marginRight: 2, fontSize: '0.75rem', padding: '4px 8px', minWidth: 'auto', textTransform: 'none' }}
              >
                Resend by Email
              </Button>
              <Button
                variant="contained"
                sx={{ fontSize: '0.75rem', padding: '4px 8px', minWidth: 'auto', textTransform: 'none' }}
              >
                Resend by Text
              </Button>
            </Grid>
          </Grid>
           );
      });
    })()}
  </Card>
</Grid>

    
   
{payments.length > 0 && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
    <Box sx={{ borderRadius: 3, overflow: "hidden", border: "1px solid #e2e8f0", boxShadow: "0 1px 8px rgba(0,0,0,0.06)" }}>
      {/* Header */}
      <Box sx={{ px: 2.5, py: 1.5, bgcolor: "#f8fafc", borderBottom: "1px solid #e2e8f0", display: "flex", alignItems: "center", gap: 1 }}>
        <Box sx={{ width: 3, height: 16, borderRadius: 2, bgcolor: "#2f3891" }} />
        <Typography sx={{ fontWeight: 700, fontSize: 12, color: "#1e293b", textTransform: "uppercase", letterSpacing: 0.8 }}>
          Payment History
        </Typography>
      </Box>

      {/* Payment rows */}
      <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
        {payments.filter((p) => Number(p.amount) > 0).map((payment) => (
          <Box
            key={payment.id}
            sx={{
              borderRadius: 2, border: "1px solid #e2e8f0", bgcolor: "#fff",
              overflow: "hidden",
              "&:hover": { borderColor: "#c4b5fd", boxShadow: "0 2px 8px rgba(124,58,237,0.08)" },
              transition: "all 0.15s",
            }}
          >
            {/* Color bar */}
            <Box sx={{ height: 3, bgcolor: payment.is_return ? "#dc2626" : "#2f3891" }} />
            <Box sx={{ p: 1.75 }}>
              {/* Row 1: Date + action */}
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.25 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                  <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: payment.is_return ? "#fef2f2" : "#f5f3ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Typography sx={{ fontSize: 13 }}>{payment.is_return ? "↩" : "✓"}</Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.5 }}>Payment Date</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>
                      {moment(payment.payment_date || payment.created_at).format("MMM DD, YYYY")}
                    </Typography>
                  </Box>
                </Box>
                {payment.payment_mode.toLowerCase() === "online" && !payment.is_return ? (
                  <IconButton color="warning" title="Refund" onClick={() => refundPayment(payment.transaction_id)} size="small" sx={{ p: 0.5, color: "#d97706" }}>
                    {isRefundLoading ? <CircularProgress size={14} color="inherit" /> : <FaUndo style={{ fontSize: 13 }} />}
                  </IconButton>
                ) : !payment.is_return ? (
                  <IconButton color="error" title="Delete" onClick={() => deletePayment(payment.id)} size="small" sx={{ p: 0.5, color: "#dc2626" }}>
                    <FaTrash style={{ fontSize: 13 }} />
                  </IconButton>
                ) : null}
              </Box>

              {/* Row 2: Amount + Method + Status */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                <Typography sx={{ fontSize: 18, fontWeight: 800, color: payment.is_return ? "#dc2626" : "#2f3891", lineHeight: 1 }}>
                  {payment.is_return ? "-" : ""}${Number(payment.amount).toFixed(2)}
                </Typography>
                <Box sx={{ px: 1.25, py: 0.4, borderRadius: 1, bgcolor: "#f1f5f9", border: "1px solid #e2e8f0" }}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#475569" }}>{payment.payment_method}</Typography>
                </Box>
                <Box sx={{ px: 1.25, py: 0.4, borderRadius: 1, bgcolor: payment.is_return ? "#fef2f2" : "#f0fdf4", border: `1px solid ${payment.is_return ? "#fecaca" : "#bbf7d0"}` }}>
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: payment.is_return ? "#dc2626" : "#16a34a" }}>
                    {payment.is_return ? "Refund" : "Completed"}
                  </Typography>
                </Box>
              </Box>

              {/* Refund note */}
              {!!payment.is_return && payment.description && (
                <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.5 }}>{payment.description}</Typography>
              )}

              {/* Row 3: Proof upload / view */}
              {!payment.is_return && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.75, flexWrap: "wrap" }}>
                  <input
                    type="file"
                    accept="application/pdf"
                    id={`proof-upload-${payment.id}`}
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const f = e.target.files?.[0];
                      if (f) uploadPaymentProof(payment.id, f);
                      e.target.value = "";
                    }}
                  />
                  {payment.file_path ? (
                    <>
                      <Box
                        component="button"
                        onClick={() => handleOpenModal(payment.file_path!)}
                        sx={{
                          display: "flex", alignItems: "center", gap: 0.5,
                          px: 1.25, py: 0.4, borderRadius: 1, cursor: "pointer",
                          bgcolor: "#f0fdf4", border: "1px solid #bbf7d0",
                          color: "#16a34a", fontSize: 11, fontWeight: 600,
                          fontFamily: "inherit",
                          "&:hover": { bgcolor: "#dcfce7" },
                        }}
                      >
                        <DescriptionIcon sx={{ fontSize: 13 }} />
                        View PDF
                      </Box>
                      <Box
                        component="label"
                        htmlFor={`proof-upload-${payment.id}`}
                        sx={{
                          display: "flex", alignItems: "center", gap: 0.5,
                          px: 1.25, py: 0.4, borderRadius: 1, cursor: "pointer",
                          bgcolor: "#f8fafc", border: "1px solid #e2e8f0",
                          color: "#64748b", fontSize: 11, fontWeight: 600,
                          "&:hover": { bgcolor: "#f1f5f9" },
                        }}
                      >
                        {proofUploading.has(payment.id)
                          ? <CircularProgress size={11} sx={{ color: "#64748b" }} />
                          : "Replace"}
                      </Box>
                    </>
                  ) : (
                    <Box
                      component="label"
                      htmlFor={`proof-upload-${payment.id}`}
                      sx={{
                        display: "flex", alignItems: "center", gap: 0.5,
                        px: 1.25, py: 0.4, borderRadius: 1, cursor: "pointer",
                        bgcolor: "#f5f3ff", border: "1px solid #ddd6fe",
                        color: "#2f3891", fontSize: 11, fontWeight: 600,
                        "&:hover": { bgcolor: "#ede9fe" },
                      }}
                    >
                      {proofUploading.has(payment.id)
                        ? <CircularProgress size={11} sx={{ color: "#2f3891" }} />
                        : <><DescriptionIcon sx={{ fontSize: 13 }} /> Upload PDF</>}
                    </Box>
                  )}
                </Box>
              )}

              {/* Row 4: Reference / description */}
              {payment.description && (
                <Typography sx={{ fontSize: 11, color: "#64748b", mt: 0.75, fontStyle: "italic" }}>
                  {payment.description}
                </Typography>
              )}

              {/* Row 5: PO Document link — shown when payment is via PO and a document was uploaded */}
              {payment.payment_method?.toLowerCase().includes("purchase order") &&
                (invoiceList?.po_document || WorkOrderDataList?.po_document) && (
                  <Box sx={{ mt: 0.75 }}>
                    <Box
                      component="a"
                      href={`${LARAVEL_API_URL}/${invoiceList?.po_document || WorkOrderDataList?.po_document}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        display: "inline-flex", alignItems: "center", gap: 0.5,
                        px: 1.25, py: 0.4, borderRadius: 1,
                        bgcolor: "#eff6ff", border: "1px solid #bfdbfe",
                        color: "#1d4ed8", fontSize: 11, fontWeight: 600,
                        textDecoration: "none",
                        "&:hover": { bgcolor: "#dbeafe" },
                      }}
                    >
                      <DescriptionIcon sx={{ fontSize: 13 }} />
                      View PO Document
                    </Box>
                  </Box>
                )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  </Grid>
)}


      {refunds.length > 0 && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" fontWeight="bold">
              Refund History
            </Typography>
          </Grid>

          {refunds.map((payment) => (
            <Grid item xs={12} key={payment.id}>
              <Card sx={{ padding: 2, borderRadius: 2, border: "1px solid #f1f5f9", backgroundColor: (theme) => `${alpha(theme.palette.primary.light, 0.1)} !important`, position: 'relative' }}>
                <Box display="flex" flexDirection="column" gap={1}>
 <Box display="flex" justifyContent="space-between" alignItems="center">

        <Typography variant="body2" color="textSecondary">
                    {(() => { const d = dayjs(payment.updated_at || payment.created_at); return d.isValid() ? d.format("MMM D, YYYY h:mm A") : "—"; })()}
                  </Typography>

            </Box>
                   
          
      
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    ${payment.amount}
                  </Typography>

                  {/* Payment Method */}
                  <Box display="flex" alignItems="center">
                    <Typography variant="body1">
                      <strong>Method:</strong> {payment.payment_method}
                    </Typography>

                 
                  
                   {/* <Typography variant="body2" color="textSecondary">
                    {dayjs(payment.created_at).format("MMM D, YYYY h:mm A")}
                  </Typography> */}
                    {/* {payment.file_path && (
                      <Button
                        variant="text"
                        size="small"
                        onClick={() => payment.file_path && handleOpenModal(payment.file_path)}
                        sx={{ minWidth: "auto", padding: 0, marginLeft: 1 }}
                      >
                        <DescriptionIcon color="primary" fontSize="small" />
                      </Button>
                    )} */}
                  </Box>

                  {/* Payment Mode */}
                  <Box
                    sx={{
                      display: "inline-block",
                      backgroundColor:
                      payment.payment_mode === "ONLINE" ? "#C2E5B3" : "#F8D7DA",
                      color: payment.payment_mode === "ONLINE" ? "#2E7D32" : "#D32F2F",
                      padding: "4px 10px",
                      borderRadius: 2,
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                      textTransform: "capitalize",
                      width: "fit-content"
                    }}
                  >
                    {payment.payment_mode.toLowerCase()}
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
        </Grid>
      )}

      {/* Modal Dialog */}
      <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="md">
        <DialogTitle>View File</DialogTitle>
        <DialogContent>
          {isPdf ? (
            <iframe
              src={fileUrl || ""}
              style={{ width: "100%", height: "500px" }}
              title="PDF Viewer"
            />
          ) : (
            <img
              src={fileUrl || ""}
              alt="File Content"
              style={{
                width: "100%",
                height: "500px",
                objectFit: "contain"
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
   



    {/* Order Timeline */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Card sx={{ borderRadius: 3, boxShadow: "0 1px 8px rgba(0,0,0,0.08)", border: "1px solid #f1f5f9" }}>
        <Box sx={{ borderBottom: "1px solid #f1f5f9", px: 2.5, py: 2, display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 3, height: 16, borderRadius: 2, bgcolor: "#2f3891" }} />
          <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: 13, textTransform: "uppercase", letterSpacing: 0.8 }}>Order Timeline</Typography>
        </Box>
        <Box sx={{ p: 2.5 }}>
          {workOrderHistoryIsLoading ? (
            <CircularProgress size={22} />
          ) : workOrderHistoryError ? (
            <Typography color="error" sx={{ fontSize: 12 }}>Error fetching history</Typography>
          ) : timeLineSteps.length === 0 ? (
            <Typography sx={{ fontSize: 12, color: "#94a3b8", textAlign: "center", py: 2 }}>No history yet</Typography>
          ) : (
            <Box sx={{ position: "relative" }}>
              {/* Vertical connector line */}
              <Box sx={{ position: "absolute", left: 14, top: 30, bottom: 16, width: 2, bgcolor: "#e2e8f0", zIndex: 0 }} />
              {timeLineSteps.map((step, index) => {
                const lbl            = step.label.toLowerCase();
                const isQuoteCreated = lbl.includes("quote created");
                const isInvoiceStep  = lbl.includes("converted") || (lbl.includes("invoice") && !lbl.includes("driver") && !lbl.includes("edited"));
                const isTerminated   = lbl.includes("terminat");
                const isEdited       = lbl.includes("edited");
                const isDriverStep   = lbl.includes("driver");
                const isRefundStep   = lbl.includes("refund");
                const dotColor       = isQuoteCreated ? "#2f3891" : isInvoiceStep ? "#16a34a" : isTerminated ? "#dc2626" : isEdited ? "#f59e0b" : isDriverStep ? "#2f3891" : isRefundStep ? "#ef4444" : "#0284c7";
                const labelBg        = isQuoteCreated ? "#faf5ff" : isInvoiceStep ? "#f0fdf4" : isTerminated ? "#fef2f2" : isEdited ? "#fffbeb" : isDriverStep ? "#eef2ff" : isRefundStep ? "#fef2f2" : "#f0f9ff";
                const labelBorder    = isQuoteCreated ? "#e9d5ff" : isInvoiceStep ? "#bbf7d0" : isTerminated ? "#fecaca" : isEdited ? "#fde68a" : isDriverStep ? "#c7d2fe" : isRefundStep ? "#fecaca" : "#bae6fd";
                const icon           = isQuoteCreated ? "📋" : isInvoiceStep ? "🧾" : isTerminated ? "⛔" : isEdited ? "✏️" : isDriverStep ? "🚗" : isRefundStep ? "↩️" : "💳";
                return (
                  <Box key={index} sx={{ display: "flex", gap: 2, mb: 3, position: "relative", zIndex: 1 }}>
                    {/* Dot */}
                    <Box sx={{ width: 32, height: 32, borderRadius: "50%", bgcolor: `${dotColor}18`, border: `2.5px solid ${dotColor}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, mt: 0.25 }}>
                      <Box sx={{ width: 9, height: 9, borderRadius: "50%", bgcolor: dotColor }} />
                    </Box>
                    {/* Card */}
                    <Box sx={{ flex: 1, border: `1px solid ${labelBorder}`, borderRadius: 2.5, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
                      {/* Card header */}
                      <Box sx={{ bgcolor: labelBg, borderBottom: `1px solid ${labelBorder}`, px: 2, py: 1, display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography sx={{ fontSize: 15, lineHeight: 1 }}>{icon}</Typography>
                        <Typography sx={{ fontSize: 12, fontWeight: 700, color: dotColor, textTransform: "uppercase", letterSpacing: 0.7 }}>{step.label}</Typography>
                      </Box>
                      {/* Card body */}
                      <Box sx={{ px: 2, py: 1.5, bgcolor: "#fff" }}>
                        {step.description}
                      </Box>
                    </Box>
                  </Box>
                );
              })}
              {/* In progress indicator */}
              <Box sx={{ display: "flex", gap: 2, position: "relative", zIndex: 1 }}>
                <Box sx={{ width: 30, height: 30, borderRadius: "50%", bgcolor: "#f8fafc", border: "2px dashed #cbd5e1", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#cbd5e1" }} />
                </Box>
                <Box sx={{ pt: 0.75 }}>
                  <Typography sx={{ fontSize: 11, color: "#94a3b8", fontStyle: "italic" }}>In progress…</Typography>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Card>
    </Grid>
  </Grid>
</Grid>


            {/* ── Terminate Dialog (multi-step) ──────────────────────── */}
            {(() => {
              const closeDialog = () => {
                setOpenTerminateDialog(false);
                setTerminateReason(""); setTerminateReasonError(false);
                setRefundData({ amount: Number(amountPaid).toFixed(2), method: "", reason: "" });
                setRefundProof(null);
                setRefundErrors({ amount: false, method: false, reason: false, proof: false });
              };

              /* ── Step labels ── */
              const stepLabel =
                terminateStep === "ask" ? "Terminate Quote" :
                terminateStep === "refund" ? "Issue Refund" :
                "Termination Reason";

              return (
                <Dialog open={openTerminateDialog} onClose={closeDialog} maxWidth="sm" fullWidth
                  PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>

                  {/* Gradient bar */}
                  <Box sx={{ height: 4, background: terminateStep === "refund" ? "linear-gradient(90deg,#2f3891,#2563eb)" : "linear-gradient(90deg,#dc2626,#f97316)" }} />

                  {/* Header */}
                  <Box sx={{ px: 3, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Box>
                      <Typography sx={{ fontWeight: 700, fontSize: 16, color: "#0f172a" }}>{stepLabel}</Typography>
                      <Typography sx={{ fontSize: 12, color: "#94a3b8", mt: 0.25 }}>{WorkOrderDataList?.quoteWorkOrderNo}</Typography>
                    </Box>
                    <IconButton size="small" onClick={closeDialog}><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
                  </Box>

                  <DialogContent sx={{ px: 3, pb: 2 }}>

                    {/* ══ STEP: ASK ══════════════════════════════════════════════ */}
                    {terminateStep === "ask" && (
                      <>
                        <Box sx={{ bgcolor: "#fffbeb", border: "1px solid #fde68a", borderRadius: 2, px: 2, py: 1.5, mb: 2.5, display: "flex", gap: 1.5, alignItems: "flex-start" }}>
                          <Typography sx={{ fontSize: 22, lineHeight: 1 }}>💳</Typography>
                          <Box>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: "#92400e", mb: 0.25 }}>
                              Payment of ${Number(amountPaid).toFixed(2)} has been received
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: 12, color: "#b45309" }}>
                              Do you want to issue a refund to the client before terminating this quote?
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", gap: 1.5 }}>
                          <Box onClick={() => setTerminateStep("refund")}
                            sx={{ flex: 1, border: "2px solid #e2e8f0", borderRadius: 2, p: 2, cursor: "pointer", textAlign: "center",
                              "&:hover": { borderColor: "#2f3891", bgcolor: "#faf5ff" }, transition: "all 0.15s" }}>
                            <Typography sx={{ fontSize: 24, mb: 0.5 }}>💸</Typography>
                            <Typography sx={{ fontWeight: 700, fontSize: 14, color: "#2f3891" }}>Yes, Issue Refund</Typography>
                            <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.25 }}>Refund then terminate</Typography>
                          </Box>
                          <Box onClick={() => setTerminateStep("terminate")}
                            sx={{ flex: 1, border: "2px solid #e2e8f0", borderRadius: 2, p: 2, cursor: "pointer", textAlign: "center",
                              "&:hover": { borderColor: "#dc2626", bgcolor: "#fef2f2" }, transition: "all 0.15s" }}>
                            <Typography sx={{ fontSize: 24, mb: 0.5 }}>⛔</Typography>
                            <Typography sx={{ fontWeight: 700, fontSize: 14, color: "#dc2626" }}>No, Terminate</Typography>
                            <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.25 }}>Terminate without refund</Typography>
                          </Box>
                        </Box>
                      </>
                    )}

                    {/* ══ STEP: REFUND FORM ══════════════════════════════════════ */}
                    {terminateStep === "refund" && (
                      <>
                        {/* Refund Amount */}
                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.75 }}>
                            Refund Amount <Box component="span" sx={{ color: "#ef4444" }}>*</Box>
                          </Typography>
                          <TextField fullWidth size="small" type="text" inputMode="decimal"
                            value={refundData.amount}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (/^\d*\.?\d{0,2}$/.test(val) || val === "") {
                                setRefundData(p => ({ ...p, amount: val }));
                                const num = parseFloat(val);
                                setRefundErrors(p => ({ ...p, amount: !!val && (num <= 0 || num > amountPaid) }));
                              }
                            }}
                            error={refundErrors.amount}
                            helperText={
                              refundErrors.amount
                                ? `Amount must be between $0.01 and $${amountPaid.toFixed(2)}`
                                : `Max refundable: $${amountPaid.toFixed(2)}`
                            }
                            InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13 } }}
                          />
                        </Box>

                        {/* Refund Method */}
                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.75 }}>
                            Refund Method <Box component="span" sx={{ color: "#ef4444" }}>*</Box>
                          </Typography>
                          <TextField fullWidth select size="small"
                            value={refundData.method}
                            onChange={(e) => { setRefundData(p => ({ ...p, method: e.target.value })); setRefundErrors(p => ({ ...p, method: false })); }}
                            error={refundErrors.method}
                            helperText={refundErrors.method ? "Select a refund method" : ""}
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13 } }}>
                            <MenuItem value="">Select method…</MenuItem>
                            <MenuItem value="Cash">Cash</MenuItem>
                            <MenuItem value="E-transfer">E-transfer</MenuItem>
                            <MenuItem value="Credit Card">Credit Card</MenuItem>
                            <MenuItem value="Debit Card">Debit Card</MenuItem>
                            <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                            <MenuItem value="Cheque">Cheque</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                          </TextField>
                        </Box>

                        {/* Proof of Refund */}
                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.75 }}>
                            Upload Proof of Refund{" "}
                            <Box component="span" sx={{ fontSize: 11, fontWeight: 400, color: "#94a3b8" }}>(Optional)</Box>
                          </Typography>
                          <Box sx={{ border: "1px solid #e2e8f0", borderRadius: 1.5, p: 1.5, bgcolor: "#f8fafc" }}>
                            <input type="file" accept="image/*,.pdf"
                              onChange={(e) => {
                                const f = e.target.files?.[0] || null;
                                setRefundProof(f);
                              }}
                              style={{ fontSize: 13 }}
                            />
                            {refundProof && (
                              <Typography sx={{ fontSize: 11, color: "#16a34a", mt: 0.5 }}>✓ {refundProof.name}</Typography>
                            )}
                          </Box>
                        </Box>

                        {/* Refund Reason */}
                        <Box sx={{ mb: 1 }}>
                          <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.75 }}>
                            Refund Reason <Box component="span" sx={{ color: "#ef4444" }}>*</Box>
                          </Typography>
                          <TextField fullWidth multiline rows={3} size="small"
                            placeholder="Explain why the refund is being issued…"
                            value={refundData.reason}
                            onChange={(e) => { setRefundData(p => ({ ...p, reason: e.target.value })); if (e.target.value.trim()) setRefundErrors(p => ({ ...p, reason: false })); }}
                            error={refundErrors.reason}
                            helperText={refundErrors.reason ? "Refund reason is required" : ""}
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13 } }}
                          />
                        </Box>
                      </>
                    )}

                    {/* ══ STEP: TERMINATE REASON ════════════════════════════════ */}
                    {terminateStep === "terminate" && (
                      <>
                        {terminateStep === "terminate" && amountPaid > 0 && (
                          <Box sx={{ bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 2, px: 2, py: 1.25, mb: 2, display: "flex", gap: 1, alignItems: "center" }}>
                            <Typography sx={{ fontSize: 16 }}>✅</Typography>
                            <Typography variant="body2" sx={{ color: "#15803d", fontWeight: 600, fontSize: 12 }}>
                              Refund processed — you can now terminate this quote.
                            </Typography>
                          </Box>
                        )}
                        <Box sx={{ bgcolor: "#fef2f2", border: "1px solid #fecaca", borderRadius: 2, px: 2, py: 1.5, mb: 2.5 }}>
                          <Typography variant="body2" sx={{ color: "#dc2626", fontWeight: 600 }}>
                            ⛔ This will permanently cancel quote <strong>{WorkOrderDataList?.quoteWorkOrderNo}</strong>. This action will be recorded in the order timeline.
                          </Typography>
                        </Box>
                        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 1 }}>
                          Reason for termination <Box component="span" sx={{ color: "#ef4444" }}>*</Box>
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mb: 1.5 }}>
                          {["Client requested cancellation","Budget constraints","Duplicate quote","No response from client","Trip dates changed","Service no longer needed"].map((preset) => (
                            <Box key={preset} onClick={() => { setTerminateReason(preset); setTerminateReasonError(false); }}
                              sx={{ fontSize: 12, fontWeight: 500, px: 1.5, py: 0.5, borderRadius: 20, cursor: "pointer", border: "1px solid",
                                borderColor: terminateReason === preset ? "#dc2626" : "#e2e8f0",
                                bgcolor: terminateReason === preset ? "#fef2f2" : "#f8fafc",
                                color: terminateReason === preset ? "#dc2626" : "#475569",
                                "&:hover": { borderColor: "#fca5a5", bgcolor: "#fff5f5" }, transition: "all 0.15s" }}>
                              {preset}
                            </Box>
                          ))}
                        </Box>
                        <TextField fullWidth multiline rows={3} size="small"
                          placeholder="Or type a custom reason…"
                          value={terminateReason}
                          onChange={(e) => { setTerminateReason(e.target.value); if (e.target.value.trim()) setTerminateReasonError(false); }}
                          error={terminateReasonError}
                          helperText={terminateReasonError ? "Please provide a reason before terminating" : ""}
                          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13,
                            "& fieldset": { borderColor: terminateReasonError ? "#ef4444" : "#e2e8f0" },
                            "&:hover fieldset": { borderColor: "#fca5a5" },
                            "&.Mui-focused fieldset": { borderColor: "#dc2626" } } }}
                        />
                      </>
                    )}
                  </DialogContent>

                  <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
                    <Button variant="outlined" onClick={closeDialog} disabled={terminateLoading || refundSubmitLoading}
                      sx={{ textTransform: "none", fontWeight: 600, fontSize: 13, borderRadius: 1.5, borderColor: "#e2e8f0", color: "#64748b" }}>
                      Cancel
                    </Button>
                    {terminateStep === "refund" && (
                      <>
                        <Button variant="outlined" onClick={() => setTerminateStep("ask")} disabled={refundSubmitLoading}
                          sx={{ textTransform: "none", fontWeight: 600, fontSize: 13, borderRadius: 1.5, borderColor: "#e2e8f0", color: "#64748b" }}>
                          Back
                        </Button>
                        <Button variant="contained" onClick={handleRefundSubmit} disabled={refundSubmitLoading}
                          sx={{ textTransform: "none", fontWeight: 700, fontSize: 13, borderRadius: 1.5, bgcolor: "#2f3891", "&:hover": { bgcolor: "#252e7a" }, boxShadow: "none", minWidth: 140 }}>
                          {refundSubmitLoading ? "Processing…" : "Process Refund"}
                        </Button>
                      </>
                    )}
                    {terminateStep === "terminate" && (
                      <Button variant="contained" onClick={handleTerminate} disabled={terminateLoading}
                        sx={{ textTransform: "none", fontWeight: 700, fontSize: 13, borderRadius: 1.5, bgcolor: "#dc2626", "&:hover": { bgcolor: "#b91c1c" }, boxShadow: "none", minWidth: 140 }}>
                        {terminateLoading ? "Terminating…" : "Terminate Quote"}
                      </Button>
                    )}
                  </DialogActions>
                </Dialog>
              );
            })()}

            {/* ── Standalone Refund Dialog ───────────────────────────── */}
            <Dialog open={openRefundDialog} onClose={() => !refundSubmitLoading && setOpenRefundDialog(false)} maxWidth="sm" fullWidth
              PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
              <Box sx={{ height: 4, background: "linear-gradient(90deg,#ea580c,#f97316,#fb923c)" }} />
              <Box sx={{ px: 3, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box>
                  <Typography sx={{ fontWeight: 700, fontSize: 16, color: "#0f172a" }}>Issue Refund</Typography>
                  <Typography sx={{ fontSize: 12, color: "#94a3b8", mt: 0.25 }}>{WorkOrderDataList?.quoteWorkOrderNo}</Typography>
                </Box>
                <IconButton size="small" onClick={() => !refundSubmitLoading && setOpenRefundDialog(false)}><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
              </Box>
              <DialogContent sx={{ px: 3, pb: 2 }}>
                {/* Summary bar */}
                <Box sx={{ bgcolor: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 2, px: 2, py: 1.25, mb: 2.5, display: "flex", gap: 1.5, alignItems: "center" }}>
                  <Typography sx={{ fontSize: 20, lineHeight: 1 }}>💳</Typography>
                  <Box>
                    <Typography sx={{ fontWeight: 700, color: "#9a3412", fontSize: 13 }}>
                      Total paid: ${Number(amountPaid).toFixed(2)}
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: "#c2410c" }}>
                      Enter the amount to refund to the client
                    </Typography>
                  </Box>
                </Box>
                {/* Refund Amount */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.75 }}>
                    Refund Amount <Box component="span" sx={{ color: "#ef4444" }}>*</Box>
                  </Typography>
                  <TextField fullWidth size="small" type="text" inputMode="decimal"
                    value={refundData.amount}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*\.?\d{0,2}$/.test(val) || val === "") {
                        setRefundData(p => ({ ...p, amount: val }));
                        const num = parseFloat(val);
                        setRefundErrors(p => ({ ...p, amount: !!val && (num <= 0 || num > amountPaid) }));
                      }
                    }}
                    error={refundErrors.amount}
                    helperText={
                      refundErrors.amount
                        ? `Amount must be between $0.01 and $${amountPaid.toFixed(2)}`
                        : `Max refundable: $${amountPaid.toFixed(2)}`
                    }
                    InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13 } }}
                  />
                </Box>
                {/* Refund Method */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.75 }}>
                    Refund Method <Box component="span" sx={{ color: "#ef4444" }}>*</Box>
                  </Typography>
                  <TextField fullWidth select size="small"
                    value={refundData.method}
                    onChange={(e) => { setRefundData(p => ({ ...p, method: e.target.value })); setRefundErrors(p => ({ ...p, method: false })); }}
                    error={refundErrors.method}
                    helperText={refundErrors.method ? "Select a refund method" : ""}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13 } }}>
                    <MenuItem value="">Select method…</MenuItem>
                    <MenuItem value="Cash">Cash</MenuItem>
                    <MenuItem value="E-transfer">E-transfer</MenuItem>
                    <MenuItem value="Credit Card">Credit Card</MenuItem>
                    <MenuItem value="Debit Card">Debit Card</MenuItem>
                    <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                    <MenuItem value="Cheque">Cheque</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </TextField>
                </Box>
                {/* Upload Proof */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.75 }}>
                    Upload Proof of Refund{" "}
                    <Box component="span" sx={{ fontSize: 11, fontWeight: 400, color: "#94a3b8" }}>(optional)</Box>
                  </Typography>
                  <Box sx={{ border: "1px solid #e2e8f0", borderRadius: 1.5, p: 1.5, bgcolor: "#f8fafc" }}>
                    <input type="file" accept="image/*,.pdf"
                      onChange={(e) => {
                        const f = e.target.files?.[0] || null;
                        setRefundProof(f);
                      }}
                      style={{ fontSize: 13 }}
                    />
                    {refundProof && (
                      <Typography sx={{ fontSize: 11, color: "#16a34a", mt: 0.5 }}>✓ {refundProof.name}</Typography>
                    )}
                  </Box>
                </Box>
                {/* Refund Reason */}
                <Box sx={{ mb: 1 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#475569", mb: 0.75 }}>
                    Refund Reason <Box component="span" sx={{ color: "#ef4444" }}>*</Box>
                  </Typography>
                  <TextField fullWidth multiline rows={3} size="small"
                    placeholder="Explain why the refund is being issued…"
                    value={refundData.reason}
                    onChange={(e) => { setRefundData(p => ({ ...p, reason: e.target.value })); if (e.target.value.trim()) setRefundErrors(p => ({ ...p, reason: false })); }}
                    error={refundErrors.reason}
                    helperText={refundErrors.reason ? "Refund reason is required" : ""}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13 } }}
                  />
                </Box>
              </DialogContent>
              <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
                <Button variant="outlined" onClick={() => setOpenRefundDialog(false)} disabled={refundSubmitLoading}
                  sx={{ textTransform: "none", fontWeight: 600, fontSize: 13, borderRadius: 1.5, borderColor: "#e2e8f0", color: "#64748b" }}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={handleStandaloneRefundSubmit} disabled={refundSubmitLoading}
                  sx={{ textTransform: "none", fontWeight: 700, fontSize: 13, borderRadius: 1.5, bgcolor: "#ea580c", "&:hover": { bgcolor: "#c2410c" }, boxShadow: "none", minWidth: 150 }}>
                  {refundSubmitLoading ? "Processing…" : "Process Refund"}
                </Button>
              </DialogActions>
            </Dialog>

            {/* ── Convert to Invoice Dialog ─────────────────────────── */}
            <Dialog
              open={open}
              onClose={handleCloseDialog}
              maxWidth="xs"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  overflow: "hidden",
                },
              }}
            >
              {/* Header */}
              <Box
                sx={{
                  background:
                    "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
                  px: 3,
                  py: 2.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{ color: "#f8fafc", fontWeight: 700, fontSize: 16 }}
                >
                  {hasPo === true
                    ? "Enter PO Number"
                    : "Convert to Invoice"}
                </Typography>
                <IconButton size="small" onClick={handleCloseDialog}>
                  <CloseIcon sx={{ color: "#94a3b8", fontSize: 18 }} />
                </IconButton>
              </Box>

              <DialogContent sx={{ px: 3, pt: 3, pb: 1 }}>
                {/* Step 1 — Do you have a PO? */}
                {hasPo === null && (
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        gap: 1,
                        py: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: "50%",
                          background: "#eff6ff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 1,
                        }}
                      >
                        <Typography sx={{ fontSize: 26 }}>📋</Typography>
                      </Box>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: "#1e293b" }}
                      >
                        Do you have a PO number?
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "#64748b", lineHeight: 1.6 }}
                      >
                        If a Purchase Order number was issued, the invoice
                        will be marked as{" "}
                        <strong style={{ color: "#16a34a" }}>
                          fully paid
                        </strong>{" "}
                        automatically.
                        <br />
                        Without a PO, the invoice will be created and
                        payment collected separately.
                      </Typography>
                    </Box>
                  </Box>
                )}

                {/* Step 2a — Enter PO Number */}
                {hasPo === true && (
                  <Box sx={{ py: 1 }}>
                    <Box
                      sx={{
                        background: "#f0fdf4",
                        border: "1px solid #bbf7d0",
                        borderRadius: 2,
                        px: 2,
                        py: 1.5,
                        mb: 2.5,
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                      }}
                    >
                      <Typography sx={{ fontSize: 16 }}>✅</Typography>
                      <Typography variant="body2" sx={{ color: "#166534" }}>
                        The full invoice amount will be recorded as paid via
                        Purchase Order.
                      </Typography>
                    </Box>

                    {/* PO Number */}
                    <TextField
                      label="PO Number *"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={poNumber}
                      onChange={(e) => setPoNumber(e.target.value)}
                      placeholder="e.g. PO-2024-00123"
                      sx={{
                        mb: 2,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          backgroundColor: "#f8fafc",
                          "&:hover fieldset": { borderColor: "#3b82f6" },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                            borderWidth: 2,
                          },
                        },
                      }}
                      autoFocus
                    />

                    {/* PO Document Upload */}
                    <Box>
                      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#64748b", mb: 0.75 }}>
                        PO Document <Typography component="span" sx={{ fontSize: 11, color: "#94a3b8", fontWeight: 400 }}>(optional — PDF, JPG, PNG up to 10MB)</Typography>
                      </Typography>
                      <Box
                        component="label"
                        htmlFor="po-document-upload"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          p: 1.5,
                          border: "1.5px dashed",
                          borderColor: poDocumentFile ? "#3b82f6" : "#cbd5e1",
                          borderRadius: 2,
                          bgcolor: poDocumentFile ? "#eff6ff" : "#f8fafc",
                          cursor: "pointer",
                          transition: "all 0.15s",
                          "&:hover": { borderColor: "#3b82f6", bgcolor: "#eff6ff" },
                        }}
                      >
                        <input
                          id="po-document-upload"
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png"
                          style={{ display: "none" }}
                          onChange={(e) => setPoDocumentFile(e.target.files?.[0] ?? null)}
                        />
                        <Typography sx={{ fontSize: 20 }}>
                          {poDocumentFile ? "📎" : "📂"}
                        </Typography>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          {poDocumentFile ? (
                            <>
                              <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#1e40af", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {poDocumentFile.name}
                              </Typography>
                              <Typography sx={{ fontSize: 11, color: "#64748b" }}>
                                {(poDocumentFile.size / 1024).toFixed(1)} KB · Click to change
                              </Typography>
                            </>
                          ) : (
                            <Typography sx={{ fontSize: 13, color: "#94a3b8" }}>
                              Click to upload PO document
                            </Typography>
                          )}
                        </Box>
                        {poDocumentFile && (
                          <Box
                            component="span"
                            onClick={(e) => { e.preventDefault(); setPoDocumentFile(null); }}
                            sx={{ fontSize: 16, color: "#94a3b8", cursor: "pointer", "&:hover": { color: "#ef4444" }, lineHeight: 1 }}
                          >
                            ✕
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                )}

                {/* Step 2b — Confirm no PO */}
                {hasPo === false && (
                  <Box sx={{ py: 1 }}>
                    <Box
                      sx={{
                        background: "#fef9c3",
                        border: "1px solid #fde68a",
                        borderRadius: 2,
                        px: 2,
                        py: 1.5,
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                      }}
                    >
                      <Typography sx={{ fontSize: 16 }}>⚠️</Typography>
                      <Typography variant="body2" sx={{ color: "#92400e" }}>
                        The invoice will be created without a PO number.
                        Payment will need to be collected separately.
                      </Typography>
                    </Box>
                  </Box>
                )}
              </DialogContent>

              <DialogActions sx={{ px: 3, py: 2.5, gap: 1 }}>
                {/* Step 1 buttons */}
                {hasPo === null && (
                  <>
                    <Button
                      variant="outlined"
                      onClick={handleCloseDialog}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        color: "#64748b",
                        borderColor: "#e2e8f0",
                        mr: "auto",
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => setHasPo(false)}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        color: "#dc2626",
                        borderColor: "#fca5a5",
                        "&:hover": {
                          backgroundColor: "#fef2f2",
                          borderColor: "#dc2626",
                        },
                      }}
                    >
                      No, I don't
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => setHasPo(true)}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        background:
                          "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
                        fontWeight: 600,
                        boxShadow: "0 2px 8px rgba(22,163,74,0.3)",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #15803d 0%, #166534 100%)",
                        },
                      }}
                    >
                      Yes, I have a PO
                    </Button>
                  </>
                )}

                {/* Step 2a buttons */}
                {hasPo === true && (
                  <>
                    <Button
                      variant="text"
                      onClick={() => setHasPo(null)}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        color: "#64748b",
                        mr: "auto",
                      }}
                    >
                      ← Back
                    </Button>
                    <Button
                      variant="contained"
                      disabled={!poNumber.trim()}
                      onClick={handleConfirmDialog}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        background:
                          "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
                        fontWeight: 600,
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #334155 0%, #1e293b 100%)",
                        },
                        "&.Mui-disabled": {
                          background: "#e2e8f0",
                          color: "#94a3b8",
                        },
                      }}
                    >
                      Convert & Mark Paid
                    </Button>
                  </>
                )}

                {/* Step 2b buttons */}
                {hasPo === false && (
                  <>
                    <Button
                      variant="text"
                      onClick={() => setHasPo(null)}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        color: "#64748b",
                        mr: "auto",
                      }}
                    >
                      ← Back
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleConfirmDialog}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        background:
                          "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
                        fontWeight: 600,
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #334155 0%, #1e293b 100%)",
                        },
                      }}
                    >
                      Convert to Invoice
                    </Button>
                  </>
                )}
              </DialogActions>
            </Dialog>



            <Dialog
  open={isPoNumberDialogOpen}
  onClose={handleClosePoNumberDialog}
  PaperProps={{
    sx: { borderRadius: 2 },
  }}
  maxWidth="sm"
  fullWidth
>
<DialogTitle>
{(invoiceList?.po_number || (WorkOrderDataList as any)?.po_number) ? "Edit PO Number" : "Add PO Number"}
    <IconButton
      aria-label="close"
      onClick={handleClosePoNumberDialog}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CancelOutlined />
    </IconButton>
  </DialogTitle>
  <DialogContent>


  <Grid container spacing={2} p={"14px"}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>PO Number</Typography>
        <TextField
          size="small"
          fullWidth
          placeholder="Enter PO number"
          value={poNumber}
          onChange={(e) => setPoNumber(e.target.value)}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
          PO Document{" "}
          <Box component="span" sx={{ fontSize: 11, fontWeight: 400, color: "#94a3b8" }}>(optional)</Box>
        </Typography>
        <Box
          component="label"
          sx={{
            display: "flex", alignItems: "center", gap: 1.5,
            border: "1px dashed #cbd5e1", borderRadius: 1.5,
            px: 2, py: 1.25, cursor: "pointer", bgcolor: "#f8fafc",
            "&:hover": { borderColor: "#2f3891", bgcolor: "#f5f3ff" },
          }}
        >
          <input
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            style={{ display: "none" }}
            onChange={(e) => setPoDocumentFile(e.target.files?.[0] ?? null)}
          />
          <AttachFileIcon sx={{ fontSize: 16, color: "#2f3891" }} />
          <Typography sx={{ fontSize: 13, color: poDocumentFile ? "#1e293b" : "#94a3b8" }}>
            {poDocumentFile ? poDocumentFile.name : "Click to attach PDF or image"}
          </Typography>
          {poDocumentFile && (
            <Box
              component="span"
              onClick={(e) => { e.preventDefault(); setPoDocumentFile(null); }}
              sx={{ ml: "auto", color: "#94a3b8", cursor: "pointer", fontSize: 13, "&:hover": { color: "#ef4444" } }}
            >
              ✕
            </Box>
          )}
        </Box>
      </Grid>
</Grid>
  </DialogContent>
  <DialogActions>
    <DialogActions>
    <Grid item lg={12} md={12} sm={12} xs={12} >
     
        <Grid container p={"24px"}>
          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
  disabled={loading}
  onClick={() => updateInvoicePoNumber(poNumber)} 
  variant="contained"
>
  {loading ? <CircularProgress size={24} /> : "Save"}
</Button>

          </Grid>
        </Grid>
     
    </Grid>
  </DialogActions>

  </DialogActions>
</Dialog>



{openViewQuote && (
<Dialog open={openViewQuote} onClose={handleCloseViewQuote} maxWidth="md" fullWidth
  fullScreen={isMobile}
>
<DialogTitle><Typography variant="h5" component="div">
Quote Details
</Typography></DialogTitle>
<DialogContent >
<ViewWorkOrder  quoteId={workOrderId} type="view" />
</DialogContent>
<DialogActions>
 <Button onClick={handleCloseViewQuote}>Close</Button>
</DialogActions>
</Dialog>
)}

{/* ── Email Client dialog ──────────────────────────────────── */}
<Dialog open={openEmailClientDialog} onClose={() => !emailClientSending && setOpenEmailClientDialog(false)}
  maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>

  {/* Gradient header */}
  <Box sx={{ background: "linear-gradient(135deg, #2f3891 0%, #252e7a 60%, #2f3891 100%)", px: 3, pt: 2.5, pb: 2.5, position: "relative" }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box sx={{ width: 38, height: 38, borderRadius: 2, bgcolor: "rgba(255,255,255,0.18)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <EmailOutlinedIcon sx={{ color: "#fff", fontSize: 20 }} />
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: "1rem", color: "#fff", lineHeight: 1.2 }}>Email to Client</Typography>
          <Typography sx={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.7)", mt: 0.2 }}>
            {WorkOrderDataList?.quoteWorkOrderNo}
          </Typography>
        </Box>
      </Box>
      <IconButton size="small" onClick={() => setOpenEmailClientDialog(false)} disabled={emailClientSending}
        sx={{ color: "rgba(255,255,255,0.7)", "&:hover": { color: "#fff", bgcolor: "rgba(255,255,255,0.12)" } }}>
        <CloseIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  </Box>

  <DialogContent sx={{ p: 0, bgcolor: "#f8fafc" }}>

    {/* Client info strip */}
    <Box sx={{ bgcolor: "#fff", px: 3, py: 1.75, borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", gap: 1.5 }}>
      <Box sx={{ width: 36, height: 36, borderRadius: "50%", bgcolor: "#ede9fe", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Typography sx={{ fontSize: "0.8rem", fontWeight: 700, color: "#2f3891" }}>
          {(WorkOrderDataList?.customer?.customerFirstName?.[0] || "") + (WorkOrderDataList?.customer?.customerLastName?.[0] || "")}
        </Typography>
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: "0.82rem", fontWeight: 600, color: "#1e293b" }}>
          {fmtCustomerName(WorkOrderDataList?.customer)}
          {WorkOrderDataList?.customer?.customerCompanyName && (
            <Typography component="span" sx={{ fontSize: "0.72rem", color: "#64748b", fontWeight: 400, ml: 0.75 }}>
              · {WorkOrderDataList.customer.customerCompanyName}
            </Typography>
          )}
        </Typography>
        <TextField variant="standard" size="small" fullWidth value={emailClientTo}
          onChange={(e) => setEmailClientTo(e.target.value)}
          placeholder="recipient@email.com"
          InputProps={{ disableUnderline: false, sx: { fontSize: "0.78rem", color: "#475569" } }}
          sx={{ mt: 0.25 }} />
      </Box>
    </Box>

    {/* Quick templates */}
    <Box sx={{ px: 3, py: 1.5, borderBottom: "1px solid #f1f5f9", bgcolor: "#fff" }}>
      <Typography sx={{ fontSize: "0.68rem", color: "#94a3b8", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", mb: 1 }}>Quick Templates</Typography>
      <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
        {(WorkOrderDataList?.invoiceId ? [
          { label: "Invoice Sent", subject: `Your Invoice – ${derivedInvoiceNo || WorkOrderDataList?.quoteWorkOrderNo}`, msg: `Dear ${WorkOrderDataList?.customer?.customerFirstName || "Customer"},\n\nPlease find attached your invoice ${derivedInvoiceNo || WorkOrderDataList?.quoteWorkOrderNo}.\n\nPlease let us know if you have any questions.\n\nBest regards` },
          { label: "Payment Reminder", subject: `Payment Reminder – ${derivedInvoiceNo || WorkOrderDataList?.quoteWorkOrderNo}`, msg: `Dear ${WorkOrderDataList?.customer?.customerFirstName || "Customer"},\n\nThis is a friendly reminder that payment for invoice ${derivedInvoiceNo || WorkOrderDataList?.quoteWorkOrderNo} is outstanding.\n\nPlease contact us if you have any questions.\n\nBest regards` },
          { label: "Follow Up", subject: `Following Up – ${derivedInvoiceNo || WorkOrderDataList?.quoteWorkOrderNo}`, msg: `Dear ${WorkOrderDataList?.customer?.customerFirstName || "Customer"},\n\nI wanted to follow up regarding invoice ${derivedInvoiceNo || WorkOrderDataList?.quoteWorkOrderNo} that we sent recently.\n\nPlease let us know if you have any questions.\n\nBest regards` },
        ] : [
          { label: "Quote Ready", subject: `Your Quote is Ready – ${WorkOrderDataList?.quoteWorkOrderNo}`, msg: `Dear ${WorkOrderDataList?.customer?.customerFirstName || "Customer"},\n\nYour quote ${WorkOrderDataList?.quoteWorkOrderNo} is ready for your review.\n\nPlease let us know if you have any questions or would like to proceed.\n\nBest regards` },
          { label: "Follow Up", subject: `Following Up – ${WorkOrderDataList?.quoteWorkOrderNo}`, msg: `Dear ${WorkOrderDataList?.customer?.customerFirstName || "Customer"},\n\nI wanted to follow up regarding quote ${WorkOrderDataList?.quoteWorkOrderNo} that we sent recently.\n\nPlease let us know if you have any questions.\n\nBest regards` },
          { label: "Payment Reminder", subject: `Payment Reminder – ${WorkOrderDataList?.quoteWorkOrderNo}`, msg: `Dear ${WorkOrderDataList?.customer?.customerFirstName || "Customer"},\n\nThis is a friendly reminder that payment for ${WorkOrderDataList?.quoteWorkOrderNo} is outstanding.\n\nPlease contact us if you have any questions.\n\nBest regards` },
        ]).map((t) => (
          <Box key={t.label} onClick={() => { setEmailClientSubject(t.subject); setEmailClientMessage(t.msg); }}
            sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#2f3891", bgcolor: "#f5f3ff", border: "1px solid #ede9fe",
              borderRadius: "20px", px: 1.25, py: "4px", cursor: "pointer",
              "&:hover": { bgcolor: "#ede9fe" }, transition: "background 0.15s" }}>
            {t.label}
          </Box>
        ))}
      </Box>
    </Box>

    {/* Fields */}
    <Box sx={{ px: 3, py: 2, display: "flex", flexDirection: "column", gap: 1.75 }}>
      <TextField label="Subject" size="small" fullWidth value={emailClientSubject}
        onChange={(e) => setEmailClientSubject(e.target.value)}
        sx={{ bgcolor: "#fff", borderRadius: 1.5,
          "& .MuiOutlinedInput-root": { borderRadius: 1.5, "&:hover fieldset": { borderColor: "#a78bfa" }, "&.Mui-focused fieldset": { borderColor: "#2f3891", borderWidth: 2 } } }} />
      <Box>
        <Typography sx={{ fontSize: "0.75rem", color: "#64748b", mb: 0.5 }}>Message</Typography>
        <ReactQuill
          value={emailClientMessage}
          onChange={(value) => setEmailClientMessage(value)}
          style={{ height: "180px", marginBottom: "42px" }}
        />
      </Box>
    </Box>
  </DialogContent>

  <DialogActions sx={{ borderTop: "1px solid #e2e8f0", px: 3, py: 2, gap: 1, bgcolor: "#fff" }}>
    <Button onClick={() => setOpenEmailClientDialog(false)} disabled={emailClientSending} variant="outlined" size="small"
      sx={{ borderColor: "#e2e8f0", color: "#64748b", textTransform: "none", borderRadius: 1.5, fontWeight: 500 }}>
      Cancel
    </Button>
    <Button onClick={handleSendClientEmail} variant="contained" size="small"
      disabled={!emailClientTo || !emailClientSubject || emailClientSending}
      startIcon={emailClientSending ? <CircularProgress size={13} sx={{ color: "#fff" }} /> : <EmailOutlinedIcon sx={{ fontSize: 15 }} />}
      sx={{ textTransform: "none", fontWeight: 700, borderRadius: 1.5, px: 2.5,
        background: "linear-gradient(135deg,#2f3891,#252e7a)",
        "&:hover": { background: "linear-gradient(135deg,#252e7a,#1e266b)" },
        "&:disabled": { background: "#e2e8f0", color: "#94a3b8" } }}>
      {emailClientSending ? "Sending…" : "Send Email"}
    </Button>
  </DialogActions>
</Dialog>

{openViewInvoice && (
<Dialog open={openViewInvoice} onClose={handleCloseViewInvoice} maxWidth="md" fullWidth
  fullScreen={isMobile}
>
<DialogTitle><Typography variant="h5" component="div">
Invoice Details
</Typography></DialogTitle>
<DialogContent>
<ViewWorkOrder quoteId={workOrderId} type="view" />
</DialogContent>
<DialogActions>
  <Button onClick={handleCloseViewInvoice}>Close</Button>
</DialogActions>
</Dialog>
)}





          </Grid>
        </>
      )}

      {/* Off-screen ViewWorkOrder used only for PDF generation — must NOT use visibility:hidden or display:none as html2canvas won't capture hidden elements */}
      <div style={{ position: "fixed", left: "-9999px", top: 0, width: "900px", pointerEvents: "none", zIndex: -1 }}>
        <ViewWorkOrder ref={viewWorkOrderRef} quoteId={String(QuoteId)} type="view" />
      </div>

      {/* ── Refund Confirmation Dialog ─────────────────────────────────────── */}
      <Dialog open={Boolean(refundConfirmId)} onClose={() => setRefundConfirmId(null)} maxWidth="xs" fullWidth
        PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
        <Box sx={{ height: 4, background: "linear-gradient(90deg,#ea580c,#f97316,#fb923c)" }} />
        <Box sx={{ px: 3, pt: 2.5, pb: 1, display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box sx={{ bgcolor: "#fff7ed", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Typography sx={{ fontSize: 20, lineHeight: 1 }}>↩️</Typography>
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: 15, color: "#0f172a" }}>Refund Payment</Typography>
            <Typography sx={{ fontSize: 12, color: "#94a3b8", mt: 0.25 }}>This action cannot be undone</Typography>
          </Box>
        </Box>
        <DialogContent sx={{ px: 3, pt: 1, pb: 2 }}>
          <Typography sx={{ fontSize: 13, color: "#475569" }}>
            Are you sure you want to refund this payment?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
          <Button onClick={() => setRefundConfirmId(null)} variant="outlined" size="small"
            sx={{ textTransform: "none", borderRadius: 2, borderColor: "#e2e8f0", color: "#64748b", "&:hover": { borderColor: "#cbd5e1", bgcolor: "#f8fafc" } }}>
            Cancel
          </Button>
          <Button onClick={executeRefund} variant="contained" size="small" disabled={isRefundLoading}
            sx={{ textTransform: "none", borderRadius: 2, bgcolor: "#ea580c", "&:hover": { bgcolor: "#c2410c" } }}>
            {isRefundLoading ? "Processing…" : "Yes, Refund"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default Index;
